var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 692,
    height: 398,
    viewBox: "0 0 692 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.646 364.161H374.069V135.828H417.646V364.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.87 364.16H483.253V236.951H526.87V364.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.996 364.161H282.374V166.343H334.996V364.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.703 364.16H162.658V236.951H179.703V364.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.657 364.16H119.08V224.432H162.657V364.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.057 364.161H179.701V151.367H227.057V364.161Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 368.306H437.909V207.201L471.597 210.744V368.306Z",
    fill: "#32C0DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.23 368.306H437.908V207.201L406.23 213.602V368.306Z",
    fill: "#238BAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.23 213.603L422.873 188.04L437.908 207.202L406.23 213.603Z",
    fill: "#32C0DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 210.744L437.909 207.202L422.874 188.04H435.778L471.597 210.744Z",
    fill: "#A4ECF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 210.744L437.909 207.202L422.874 188.04H435.778L471.597 210.744Z",
    fill: "url(#paint0_linear_1010_30625)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.23 368.306H437.908V207.201L406.23 213.602V368.306Z",
    fill: "url(#paint1_linear_1010_30625)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 233.086H406.23V241.459H437.908V233.086Z",
    fill: "url(#paint2_linear_1010_30625)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 246.693H406.23V255.067H437.908V246.693Z",
    fill: "url(#paint3_linear_1010_30625)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 260.34H406.23V268.713H437.908V260.34Z",
    fill: "url(#paint4_linear_1010_30625)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 273.946H406.23V282.32H437.908V273.946Z",
    fill: "url(#paint5_linear_1010_30625)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 287.593H406.23V295.966H437.908V287.593Z",
    fill: "url(#paint6_linear_1010_30625)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 301.2H406.23V309.573H437.908V301.2Z",
    fill: "url(#paint7_linear_1010_30625)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 314.847H406.23V323.22H437.908V314.847Z",
    fill: "url(#paint8_linear_1010_30625)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 328.453H406.23V336.827H437.908V328.453Z",
    fill: "url(#paint9_linear_1010_30625)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 342.101H406.23V350.474H437.908V342.101Z",
    fill: "url(#paint10_linear_1010_30625)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 355.707H406.23V364.08H437.908V355.707Z",
    fill: "url(#paint11_linear_1010_30625)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.908 219.439H406.23V227.813H437.908V219.439Z",
    fill: "url(#paint12_linear_1010_30625)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.23 268.713H425.004V260.34H406.23V268.713Z",
    fill: "#185472"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.501 282.321H406.23V273.947H428.501V282.321Z",
    fill: "#185472"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.095 287.755H437.908V295.967H419.095V287.755Z",
    fill: "#185472"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.502 364.081H416.321V355.708H428.502V364.081Z",
    fill: "#185472"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.23 323.221H428.501V314.848H406.23V323.221Z",
    fill: "#185472"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 368.306H437.909V207.201L471.597 210.744V368.306Z",
    fill: "url(#paint13_linear_1010_30625)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 233.087H437.909V241.46H471.597V233.087Z",
    fill: "url(#paint14_linear_1010_30625)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 246.693H437.909V255.067H471.597V246.693Z",
    fill: "url(#paint15_linear_1010_30625)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 260.341H437.909V268.714H471.597V260.341Z",
    fill: "url(#paint16_linear_1010_30625)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 273.947H437.909V282.321H471.597V273.947Z",
    fill: "url(#paint17_linear_1010_30625)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 287.594H437.909V295.967H471.597V287.594Z",
    fill: "url(#paint18_linear_1010_30625)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 301.201H437.909V309.574H471.597V301.201Z",
    fill: "url(#paint19_linear_1010_30625)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 314.848H437.909V323.221H471.597V314.848Z",
    fill: "url(#paint20_linear_1010_30625)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 328.454H437.909V336.828H471.597V328.454Z",
    fill: "url(#paint21_linear_1010_30625)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 342.101H437.909V350.474H471.597V342.101Z",
    fill: "url(#paint22_linear_1010_30625)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 355.708H437.909V364.081H471.597V355.708Z",
    fill: "url(#paint23_linear_1010_30625)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.597 219.44H437.909V227.814H471.597V219.44Z",
    fill: "url(#paint24_linear_1010_30625)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 344.435H471.597V342.101H437.909V344.435Z",
    fill: "url(#paint25_linear_1010_30625)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 330.829H471.597V328.454H437.909V330.829Z",
    fill: "url(#paint26_linear_1010_30625)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 317.183H471.597V314.848H437.909V317.183Z",
    fill: "url(#paint27_linear_1010_30625)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 303.576H471.597V301.201H437.909V303.576Z",
    fill: "url(#paint28_linear_1010_30625)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 289.929H471.597V287.594H437.909V289.929Z",
    fill: "url(#paint29_linear_1010_30625)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 276.322H471.597V273.947H437.909V276.322Z",
    fill: "url(#paint30_linear_1010_30625)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 262.675H471.597V260.341H437.909V262.675Z",
    fill: "url(#paint31_linear_1010_30625)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 249.068H471.597V246.693H437.909V249.068Z",
    fill: "url(#paint32_linear_1010_30625)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 235.422H471.597V233.087H437.909V235.422Z",
    fill: "url(#paint33_linear_1010_30625)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 358.083H471.597V355.708H437.909V358.083Z",
    fill: "url(#paint34_linear_1010_30625)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 221.816H471.597V219.44H437.909V221.816Z",
    fill: "url(#paint35_linear_1010_30625)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.596 241.459H457.044V235.421H471.596V241.459Z",
    fill: "#28A3C9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M471.596 272.014H447.154V368.306H471.596V272.014Z",
    fill: "#10304D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.171 130.715L389.105 154.587V368.306H346.171V130.715Z",
    fill: "#FFFAFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.82 130.715H346.172V368.306H323.82V130.715Z",
    fill: "#65C7DE"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.82 139.974H346.172V368.306H323.82V139.974Z",
    fill: "#35A6BE"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.82 139.974H346.172V368.306H323.82V139.974Z",
    fill: "url(#paint36_linear_1010_30625)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.171 130.715L389.105 154.587V368.306H346.171V133.694V130.715Z",
    fill: "url(#paint37_linear_1010_30625)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.171 139.974L383.356 155.351V368.306H346.171V139.974Z",
    fill: "#4EC3DE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.171 139.974L383.356 155.351V368.306H346.171V142.953V139.974Z",
    fill: "url(#paint38_linear_1010_30625)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 356.591H323.82V354.699H346.172V356.591Z",
    fill: "url(#paint39_linear_1010_30625)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 343.71H323.82V341.858H346.172V343.71Z",
    fill: "url(#paint40_linear_1010_30625)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 330.867H323.82V328.975H346.172V330.867Z",
    fill: "url(#paint41_linear_1010_30625)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 317.986H323.82V316.134H346.172V317.986Z",
    fill: "url(#paint42_linear_1010_30625)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 305.144H323.82V303.292H346.172V305.144Z",
    fill: "url(#paint43_linear_1010_30625)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 292.263H323.82V290.411H346.172V292.263Z",
    fill: "url(#paint44_linear_1010_30625)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 279.421H323.82V277.57H346.172V279.421Z",
    fill: "url(#paint45_linear_1010_30625)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 266.578H323.82V264.686H346.172V266.578Z",
    fill: "url(#paint46_linear_1010_30625)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 253.696H323.82V251.845H346.172V253.696Z",
    fill: "url(#paint47_linear_1010_30625)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 240.856H323.82V238.964H346.172V240.856Z",
    fill: "url(#paint48_linear_1010_30625)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 227.974H323.82V226.122H346.172V227.974Z",
    fill: "url(#paint49_linear_1010_30625)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 215.131H323.82V213.279H346.172V215.131Z",
    fill: "url(#paint50_linear_1010_30625)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 202.249H323.82V200.398H346.172V202.249Z",
    fill: "url(#paint51_linear_1010_30625)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 189.408H323.82V187.557H346.172V189.408Z",
    fill: "url(#paint52_linear_1010_30625)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 176.567H323.82V174.675H346.172V176.567Z",
    fill: "url(#paint53_linear_1010_30625)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M346.172 163.685H323.82V161.833H346.172V163.685Z",
    fill: "url(#paint54_linear_1010_30625)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 356.591H346.17V354.699H383.355V356.591Z",
    fill: "url(#paint55_linear_1010_30625)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 343.71H346.17V341.858H383.355V343.71Z",
    fill: "url(#paint56_linear_1010_30625)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 330.868H346.17V328.976H383.355V330.868Z",
    fill: "url(#paint57_linear_1010_30625)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 317.987H346.17V316.135H383.355V317.987Z",
    fill: "url(#paint58_linear_1010_30625)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 305.146H346.17V303.294H383.355V305.146Z",
    fill: "url(#paint59_linear_1010_30625)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 292.262H346.17V290.41H383.355V292.262Z",
    fill: "url(#paint60_linear_1010_30625)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 266.58H346.17V264.688H383.355V266.58Z",
    fill: "url(#paint61_linear_1010_30625)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 253.698H346.17V251.847H383.355V253.698Z",
    fill: "url(#paint62_linear_1010_30625)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 240.855H346.17V238.963H383.355V240.855Z",
    fill: "url(#paint63_linear_1010_30625)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 227.974H346.17V226.122H383.355V227.974Z",
    fill: "url(#paint64_linear_1010_30625)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 202.251H346.17V200.399H383.355V202.251Z",
    fill: "url(#paint65_linear_1010_30625)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 163.685H346.17V161.833H383.355V163.685Z",
    fill: "url(#paint66_linear_1010_30625)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M351.677 187.558H346.17V189.409H351.677V187.558Z",
    fill: "url(#paint67_linear_1010_30625)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M383.356 187.558H360.844V189.409H383.356V187.558Z",
    fill: "url(#paint68_linear_1010_30625)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M374.39 174.674H346.17V176.526H374.39V174.674Z",
    fill: "url(#paint69_linear_1010_30625)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M383.356 174.674H377.446V176.526H383.356V174.674Z",
    fill: "url(#paint70_linear_1010_30625)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M351.155 277.569H346.17V279.421H351.155V277.569Z",
    fill: "url(#paint71_linear_1010_30625)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M383.355 277.569H355.095V279.421H383.355V277.569Z",
    fill: "url(#paint72_linear_1010_30625)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M369.245 213.281H346.17V215.133H369.245V213.281Z",
    fill: "url(#paint73_linear_1010_30625)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M383.356 213.281H373.104V215.133H383.356V213.281Z",
    fill: "url(#paint74_linear_1010_30625)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.356 368.305V306.593H365.748L355.015 322.252V368.305H383.356Z",
    fill: "#1E516B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M383.356 368.305V240.613L374.954 253.576V368.305H383.356Z",
    fill: "#215772"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M389.105 368.306V231.758L383.356 240.614V368.306H389.105Z",
    fill: "#16334D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M355.015 356.591H383.356V354.699H355.015V356.591Z",
    fill: "#1C4961"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M355.015 343.708H383.356V341.856H355.015V343.708Z",
    fill: "#1C4961"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M355.015 330.867H383.356V328.975H355.015V330.867Z",
    fill: "#1C4961"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M357.909 317.986H383.356V316.134H359.196L357.909 317.986Z",
    fill: "#1C4961"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M374.954 305.144H383.356V303.292H374.954V305.144Z",
    fill: "#1C4961"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M374.954 292.261H383.356V290.409H374.954V292.261Z",
    fill: "#1C4961"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M374.954 279.419H383.356V277.567H374.954V279.419Z",
    fill: "#1C4961"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M374.954 266.579H383.356V264.687H374.954V266.579Z",
    fill: "#1C4961"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M374.954 253.696H383.356V251.845H376.04L374.954 253.576V253.696Z",
    fill: "#1C4961"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.761 133.694L306.735 109.822V368.306H263.761V133.694Z",
    fill: "#FFFAFF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.45 133.694H263.761L306.735 109.822H260.304L241.45 133.694Z",
    fill: "#ACEDF4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.45 133.694H263.761V368.306H241.45V133.694Z",
    fill: "#65C7DE"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.45 142.952H263.761V368.305H241.45V142.952Z",
    fill: "url(#paint75_linear_1010_30625)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.761 133.694L306.735 109.822V368.306H263.761V133.694Z",
    fill: "url(#paint76_linear_1010_30625)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.761 142.953L300.986 116.183V368.306H263.761V142.953Z",
    fill: "#4EC3DE"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.761 142.953L300.986 116.183V368.306H263.761V142.953Z",
    fill: "url(#paint77_linear_1010_30625)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.988 368.307H270.194V244.117H300.988V368.307Z",
    fill: "#215772"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.45 133.694H263.761L306.735 109.822H260.304L241.45 133.694Z",
    fill: "url(#paint78_linear_1010_30625)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 356.59H241.45V354.698H263.761V356.59Z",
    fill: "url(#paint79_linear_1010_30625)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 343.709H241.45V341.857H263.761V343.709Z",
    fill: "url(#paint80_linear_1010_30625)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 330.868H241.45V328.976H263.761V330.868Z",
    fill: "url(#paint81_linear_1010_30625)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 317.986H241.45V316.135H263.761V317.986Z",
    fill: "url(#paint82_linear_1010_30625)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 305.145H241.45V303.293H263.761V305.145Z",
    fill: "url(#paint83_linear_1010_30625)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 292.261H241.45V290.41H263.761V292.261Z",
    fill: "url(#paint84_linear_1010_30625)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 279.42H241.45V277.568H263.761V279.42Z",
    fill: "url(#paint85_linear_1010_30625)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 266.579H241.45V264.687H263.761V266.579Z",
    fill: "url(#paint86_linear_1010_30625)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 253.697H241.45V251.845H263.761V253.697Z",
    fill: "url(#paint87_linear_1010_30625)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 240.856H241.45V238.964H263.761V240.856Z",
    fill: "url(#paint88_linear_1010_30625)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 227.973H241.45V226.121H263.761V227.973Z",
    fill: "url(#paint89_linear_1010_30625)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 215.132H241.45V213.28H263.761V215.132Z",
    fill: "url(#paint90_linear_1010_30625)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 202.25H241.45V200.398H263.761V202.25Z",
    fill: "url(#paint91_linear_1010_30625)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 189.408H241.45V187.556H263.761V189.408Z",
    fill: "url(#paint92_linear_1010_30625)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 176.566H241.45V174.674H263.761V176.566Z",
    fill: "url(#paint93_linear_1010_30625)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 163.685H241.45V161.833H263.761V163.685Z",
    fill: "url(#paint94_linear_1010_30625)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 150.843H241.45V148.951H263.761V150.843Z",
    fill: "url(#paint95_linear_1010_30625)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 356.591H300.987V354.699H263.762V356.591Z",
    fill: "url(#paint96_linear_1010_30625)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 343.709H300.987V341.857H263.762V343.709Z",
    fill: "url(#paint97_linear_1010_30625)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 330.868H300.987V328.976H263.762V330.868Z",
    fill: "url(#paint98_linear_1010_30625)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 317.986H300.987V316.135H263.762V317.986Z",
    fill: "url(#paint99_linear_1010_30625)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 305.145H300.987V303.293H263.762V305.145Z",
    fill: "url(#paint100_linear_1010_30625)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 292.262H300.987V290.41H263.762V292.262Z",
    fill: "url(#paint101_linear_1010_30625)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 279.42H300.987V277.568H263.762V279.42Z",
    fill: "url(#paint102_linear_1010_30625)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 266.58H300.987V264.688H263.762V266.58Z",
    fill: "url(#paint103_linear_1010_30625)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 253.698H300.987V251.846H263.762V253.698Z",
    fill: "url(#paint104_linear_1010_30625)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 227.973H300.987V226.121H263.762V227.973Z",
    fill: "url(#paint105_linear_1010_30625)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 202.25H300.987V200.398H263.762V202.25Z",
    fill: "url(#paint106_linear_1010_30625)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 189.409H300.987V187.558H263.762V189.409Z",
    fill: "url(#paint107_linear_1010_30625)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 176.566H300.987V174.674H263.762V176.566Z",
    fill: "url(#paint108_linear_1010_30625)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M263.762 150.843H300.987V148.951H263.762V150.843Z",
    fill: "url(#paint109_linear_1010_30625)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M287.761 161.832H263.762V163.684H287.761V161.832Z",
    fill: "url(#paint110_linear_1010_30625)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M300.987 161.832H292.425V163.684H300.987V161.832Z",
    fill: "url(#paint111_linear_1010_30625)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M272.485 238.965H263.762V240.817H272.485V238.965Z",
    fill: "url(#paint112_linear_1010_30625)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M300.988 238.965H276.466V240.817H300.988V238.965Z",
    fill: "url(#paint113_linear_1010_30625)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M283.299 213.279H263.762V215.131H283.299V213.279Z",
    fill: "url(#paint114_linear_1010_30625)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M300.947 213.279H287.158V215.131H300.947V213.279Z",
    fill: "url(#paint115_linear_1010_30625)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 356.592H300.987V354.7H270.193V356.592Z",
    fill: "#1C4961"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 343.709H300.987V341.857H270.193V343.709Z",
    fill: "#1C4961"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 330.868H300.987V328.976H270.193V330.868Z",
    fill: "#1C4961"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 317.987H300.987V316.135H270.193V317.987Z",
    fill: "#1C4961"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 305.145H300.987V303.293H270.193V305.145Z",
    fill: "#1C4961"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 292.262H300.987V290.41H270.193V292.262Z",
    fill: "#1C4961"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 279.42H300.987V277.568H270.193V279.42Z",
    fill: "#1C4961"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 266.58H300.987V264.688H270.193V266.58Z",
    fill: "#1C4961"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M270.193 253.697H300.987V251.846H270.193V253.697Z",
    fill: "#1C4961"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.627 368.308H214.356V191.142H252.627V368.308Z",
    fill: "#32C0DF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 368.308H214.356V191.142H187.261V368.308Z",
    fill: "#238BAF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.943 170.449L187.261 191.141H214.356L219.943 170.449Z",
    fill: "#32C0DF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.944 170.449L252.627 191.141H214.356L219.944 170.449Z",
    fill: "#A4ECF4"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.944 170.449L252.627 191.141H214.356L219.944 170.449Z",
    fill: "url(#paint116_linear_1010_30625)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 246.693H203.421V254.423H187.261V246.693Z",
    fill: "#185472"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.396 219.439H214.356V227.169H198.396V219.439Z",
    fill: "#185472"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M214.396 191.142H187.261V368.268H214.396V191.142Z",
    fill: "url(#paint117_linear_1010_30625)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 219.441H214.356V227.171H187.261V219.441Z",
    fill: "url(#paint118_linear_1010_30625)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 233.089H214.356V240.818H187.261V233.089Z",
    fill: "url(#paint119_linear_1010_30625)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 246.695H214.356V254.424H187.261V246.695Z",
    fill: "url(#paint120_linear_1010_30625)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 260.342H214.356V268.071H187.261V260.342Z",
    fill: "url(#paint121_linear_1010_30625)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 273.948H214.356V281.677H187.261V273.948Z",
    fill: "url(#paint122_linear_1010_30625)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 287.595H214.356V295.325H187.261V287.595Z",
    fill: "url(#paint123_linear_1010_30625)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 301.202H214.356V308.931H187.261V301.202Z",
    fill: "url(#paint124_linear_1010_30625)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 314.849H214.356V322.578H187.261V314.849Z",
    fill: "url(#paint125_linear_1010_30625)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 328.456H214.356V336.185H187.261V328.456Z",
    fill: "url(#paint126_linear_1010_30625)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 342.103H214.356V349.832H187.261V342.103Z",
    fill: "url(#paint127_linear_1010_30625)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.356 191.142H187.261V198.871H214.356V191.142Z",
    fill: "url(#paint128_linear_1010_30625)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 355.709H214.356V363.438H187.261V355.709Z",
    fill: "url(#paint129_linear_1010_30625)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.261 205.835H214.356V213.564H187.261V205.835Z",
    fill: "url(#paint130_linear_1010_30625)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M252.587 191.142H214.356V368.268H252.587V191.142Z",
    fill: "url(#paint131_linear_1010_30625)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 219.441H252.625V227.171H214.354V219.441Z",
    fill: "url(#paint132_linear_1010_30625)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 233.089H252.625V240.818H214.354V233.089Z",
    fill: "url(#paint133_linear_1010_30625)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 246.695H252.625V254.424H214.354V246.695Z",
    fill: "url(#paint134_linear_1010_30625)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 260.342H252.625V268.071H214.354V260.342Z",
    fill: "url(#paint135_linear_1010_30625)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 273.949H252.625V281.678H214.354V273.949Z",
    fill: "url(#paint136_linear_1010_30625)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 287.596H252.625V295.325H214.354V287.596Z",
    fill: "url(#paint137_linear_1010_30625)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 301.202H252.625V308.932H214.354V301.202Z",
    fill: "url(#paint138_linear_1010_30625)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 314.85H252.625V322.579H214.354V314.85Z",
    fill: "url(#paint139_linear_1010_30625)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 328.456H252.625V336.185H214.354V328.456Z",
    fill: "url(#paint140_linear_1010_30625)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 342.103H252.625V349.832H214.354V342.103Z",
    fill: "url(#paint141_linear_1010_30625)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 355.709H252.625V363.438H214.354V355.709Z",
    fill: "url(#paint142_linear_1010_30625)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.354 205.835H252.625V213.564H214.354V205.835Z",
    fill: "url(#paint143_linear_1010_30625)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.625 198.871H214.354V191.142H252.625V198.871Z",
    fill: "url(#paint144_linear_1010_30625)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 330.628H214.354V328.454H252.625V330.628Z",
    fill: "url(#paint145_linear_1010_30625)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 317.023H214.354V314.849H252.625V317.023Z",
    fill: "url(#paint146_linear_1010_30625)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 303.376H214.354V301.202H252.625V303.376Z",
    fill: "url(#paint147_linear_1010_30625)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 289.77H214.354V287.596H252.625V289.77Z",
    fill: "url(#paint148_linear_1010_30625)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 276.122H214.354V273.948H252.625V276.122Z",
    fill: "url(#paint149_linear_1010_30625)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 262.516H214.354V260.342H252.625V262.516Z",
    fill: "url(#paint150_linear_1010_30625)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 248.869H214.354V246.695H252.625V248.869Z",
    fill: "url(#paint151_linear_1010_30625)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 235.263H214.354V233.089H252.625V235.263Z",
    fill: "url(#paint152_linear_1010_30625)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 221.615H214.354V219.442H252.625V221.615Z",
    fill: "url(#paint153_linear_1010_30625)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 344.276H214.354V342.102H252.625V344.276Z",
    fill: "url(#paint154_linear_1010_30625)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 357.881H214.354V355.707H252.625V357.881Z",
    fill: "url(#paint155_linear_1010_30625)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M252.625 208.009H214.354V205.835H252.625V208.009Z",
    fill: "url(#paint156_linear_1010_30625)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.315 235.262H232.808V240.817H222.315V235.262Z",
    fill: "#28A3C9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.983 262.516H238.797V268.071H227.983V262.516Z",
    fill: "#28A3C9"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.987 146.939L275.661 134.419L263.762 142.953V149.112L300.987 167.509V146.939Z",
    fill: "url(#paint157_linear_1010_30625)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.987 173.87L263.762 155.473V165.778L300.987 184.135V173.87Z",
    fill: "url(#paint158_linear_1010_30625)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.172 169.282V189.853L383.357 208.21V187.639L346.172 169.282Z",
    fill: "url(#paint159_linear_1010_30625)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.173 196.212V206.477L383.358 224.874V214.569L346.173 196.212Z",
    fill: "url(#paint160_linear_1010_30625)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.853 364.16H387.698V299.71H418.853V364.16Z",
    fill: "#DADADA"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.698 299.709L376.965 284.05L366.231 299.709V364.159H387.698V299.709Z",
    fill: "#9D9D9C"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.697 299.709L376.964 284.05H408.119L418.852 299.709H387.697Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.698 299.709L376.965 284.05L366.231 299.709V364.159H387.698V299.709Z",
    fill: "url(#paint161_linear_1010_30625)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.853 364.16H387.698V299.71H418.853V364.16Z",
    fill: "url(#paint162_linear_1010_30625)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.603 306.432H405.949V314.765H400.603V306.432Z",
    fill: "#003D4C"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.603 321.165H405.949V329.498H400.603V321.165Z",
    fill: "#003D4C"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.486 306.432H414.873V314.765H409.486V306.432Z",
    fill: "#003D4C"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.486 321.165H414.873V329.498H409.486V321.165Z",
    fill: "#003D4C"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.678 306.432H397.024V314.765H391.678V306.432Z",
    fill: "#003D4C"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.678 321.165H397.024V329.498H391.678V321.165Z",
    fill: "#003D4C"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.603 335.899H405.949V344.232H400.603V335.899Z",
    fill: "#003D4C"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.486 335.899H414.873V344.232H409.486V335.899Z",
    fill: "#003D4C"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.678 335.899H397.024V344.232H391.678V335.899Z",
    fill: "#003D4C"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.603 350.593H405.949V364.159H400.603V350.593Z",
    fill: "#003D4C"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.486 350.593H414.873V364.159H409.486V350.593Z",
    fill: "#003D4C"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.678 350.593H397.024V364.159H391.678V350.593Z",
    fill: "#003D4C"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M395.859 352.163H391.678V364.159H395.859V352.163Z",
    fill: "#006C88"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M404.783 352.163H400.603V364.159H404.783V352.163Z",
    fill: "#006C88"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M413.667 352.163H409.486V364.159H413.667V352.163Z",
    fill: "#006C88"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M395.859 337.47H391.678V344.273H395.859V337.47Z",
    fill: "#006C88"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M404.783 337.47H400.603V344.273H404.783V337.47Z",
    fill: "#006C88"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M413.667 337.47H409.486V344.273H413.667V337.47Z",
    fill: "#006C88"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M395.859 322.736H391.678V329.539H395.859V322.736Z",
    fill: "#006C88"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M404.783 322.736H400.603V329.54H404.783V322.736Z",
    fill: "#00ABC5"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M413.667 322.736H409.486V329.539H413.667V322.736Z",
    fill: "#006C88"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M395.859 308.003H391.678V314.806H395.859V308.003Z",
    fill: "#006C88"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M404.783 308.003H400.603V314.806H404.783V308.003Z",
    fill: "#006C88"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M413.667 308.003H409.486V314.806H413.667V308.003Z",
    fill: "#00ABC5"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M584.815 337.157H108.827V342.566H584.815V337.157Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.42 342.502H449.124V337.39H460.42V342.502Z",
    fill: "#999999"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.784 323.743H461.869V337.39H412.784V323.743Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.42 323.743H449.124V337.39H460.42V323.743Z",
    fill: "#999999"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.869 332.922V334.854H412.784V332.922H461.869Z",
    fill: "#DE4961"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.734 329.54L358.714 326.44C360.845 324.75 364.222 323.743 367.357 323.743H410.894V337.39C400.12 337.39 366.875 337.39 356.101 337.39C354.292 337.39 351.197 336.182 351.197 334.25C351.157 332.277 353.689 330.305 354.734 329.54Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.854 332.922V334.854H361.77L352.202 336.062C351.841 335.78 351.559 335.458 351.398 335.096L361.006 332.962H410.854V332.922Z",
    fill: "#DE4961"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.867 323.743H463.797V337.39H461.867V323.743Z",
    fill: "#4C4C4C"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.854 323.743H412.784V337.39H410.854V323.743Z",
    fill: "#4C4C4C"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.381 326.319H454.229C454.632 326.319 454.993 326.682 454.993 327.084V330.868C454.993 331.271 454.632 331.633 454.229 331.633H420.381C419.979 331.633 419.617 331.271 419.617 330.868V327.084C419.617 326.682 419.979 326.319 420.381 326.319Z",
    fill: "#006893"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.834 326.319H417.608C418.01 326.319 418.372 326.682 418.372 327.084V335.337C418.372 335.739 418.01 336.102 417.608 336.102H414.834C414.432 336.102 414.07 335.739 414.07 335.337V327.084C414.07 326.682 414.392 326.319 414.834 326.319Z",
    fill: "#01314D"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.084 326.319H459.858C460.26 326.319 460.622 326.682 460.622 327.084V335.337C460.622 335.739 460.26 336.102 459.858 336.102H457.084C456.682 336.102 456.32 335.739 456.32 335.337V327.084C456.32 326.682 456.642 326.319 457.084 326.319Z",
    fill: "#01314D"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.381 326.319H426.733C427.135 326.319 427.496 326.682 427.496 327.084V330.868C427.496 331.271 427.135 331.633 426.733 331.633H420.381C419.979 331.633 419.617 331.271 419.617 330.868V327.084C419.617 326.682 419.979 326.319 420.381 326.319Z",
    fill: "#01314D"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.548 326.319H435.9C436.302 326.319 436.663 326.682 436.663 327.084V330.868C436.663 331.271 436.302 331.633 435.9 331.633H429.548C429.146 331.633 428.784 331.271 428.784 330.868V327.084C428.784 326.682 429.146 326.319 429.548 326.319Z",
    fill: "#01314D"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.713 326.319H445.065C445.467 326.319 445.828 326.682 445.828 327.084V330.868C445.828 331.271 445.467 331.633 445.065 331.633H438.713C438.311 331.633 437.949 331.271 437.949 330.868V327.084C437.949 326.682 438.311 326.319 438.713 326.319Z",
    fill: "#01314D"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.877 326.319H454.229C454.631 326.319 454.993 326.682 454.993 327.084V330.868C454.993 331.271 454.631 331.633 454.229 331.633H447.877C447.475 331.633 447.113 331.271 447.113 330.868V327.084C447.153 326.682 447.475 326.319 447.877 326.319Z",
    fill: "#01314D"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.367 326.319H403.216C403.618 326.319 403.98 326.682 403.98 327.084V330.868C403.98 331.271 403.618 331.633 403.216 331.633H369.367C368.965 331.633 368.604 331.271 368.604 330.868V327.084C368.604 326.682 368.965 326.319 369.367 326.319Z",
    fill: "#006893"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.818 326.319H366.592C366.994 326.319 367.356 326.682 367.356 327.084V335.337C367.356 335.739 366.994 336.102 366.592 336.102H363.818C363.416 336.102 363.055 335.739 363.055 335.337V327.084C363.055 326.682 363.376 326.319 363.818 326.319Z",
    fill: "#012A42"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.029 326.319H408.803C409.205 326.319 409.567 326.682 409.567 327.084V335.337C409.567 335.739 409.205 336.102 408.803 336.102H406.029C405.627 336.102 405.266 335.739 405.266 335.337V327.084C405.266 326.682 405.627 326.319 406.029 326.319Z",
    fill: "#012A42"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.835 326.319H361.006C361.408 326.319 361.77 326.682 361.77 327.084V330.868C361.77 331.271 361.408 331.633 361.006 331.633H352.403C353.207 330.707 354.172 329.942 354.735 329.54L358.715 326.44C358.715 326.4 358.795 326.36 358.835 326.319Z",
    fill: "#012A42"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.367 326.319H375.719C376.121 326.319 376.483 326.682 376.483 327.084V330.868C376.483 331.271 376.121 331.633 375.719 331.633H369.367C368.965 331.633 368.604 331.271 368.604 330.868V327.084C368.604 326.682 368.965 326.319 369.367 326.319Z",
    fill: "#012A42"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.533 326.319H384.885C385.287 326.319 385.649 326.682 385.649 327.084V330.868C385.649 331.271 385.287 331.633 384.885 331.633H378.533C378.131 331.633 377.77 331.271 377.77 330.868V327.084C377.77 326.682 378.131 326.319 378.533 326.319Z",
    fill: "#012A42"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.698 326.319H394.05C394.452 326.319 394.814 326.682 394.814 327.084V330.868C394.814 331.271 394.452 331.633 394.05 331.633H387.698C387.296 331.633 386.935 331.271 386.935 330.868V327.084C386.935 326.682 387.296 326.319 387.698 326.319Z",
    fill: "#012A42"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.864 326.319H403.216C403.618 326.319 403.98 326.682 403.98 327.084V330.868C403.98 331.271 403.618 331.633 403.216 331.633H396.864C396.462 331.633 396.101 331.271 396.101 330.868V327.084C396.101 326.682 396.462 326.319 396.864 326.319Z",
    fill: "#012A42"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.916 329.54L515.937 326.44C513.806 324.75 510.429 323.743 507.294 323.743H463.757V337.39C474.53 337.39 507.776 337.39 518.55 337.39C520.359 337.39 523.454 336.182 523.454 334.25C523.454 332.277 520.921 330.305 519.916 329.54Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.797 332.922V334.854H512.881L522.449 336.062C522.811 335.78 523.092 335.458 523.253 335.096L513.645 332.962H463.797V332.922Z",
    fill: "#DE4961"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.284 326.319H471.436C471.034 326.319 470.672 326.682 470.672 327.084V330.868C470.672 331.271 471.034 331.633 471.436 331.633H505.284C505.686 331.633 506.048 331.271 506.048 330.868V327.084C506.048 326.682 505.686 326.319 505.284 326.319Z",
    fill: "#006893"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.831 326.319H508.057C507.655 326.319 507.293 326.682 507.293 327.084V335.337C507.293 335.739 507.655 336.102 508.057 336.102H510.831C511.233 336.102 511.594 335.739 511.594 335.337V327.084C511.594 326.682 511.273 326.319 510.831 326.319Z",
    fill: "#01314D"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.581 326.319H465.807C465.405 326.319 465.043 326.682 465.043 327.084V335.337C465.043 335.739 465.405 336.102 465.807 336.102H468.581C468.983 336.102 469.344 335.739 469.344 335.337V327.084C469.344 326.682 469.023 326.319 468.581 326.319Z",
    fill: "#01314D"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.816 326.319H513.646C513.244 326.319 512.882 326.682 512.882 327.084V330.868C512.882 331.271 513.244 331.633 513.646 331.633H522.248C521.444 330.707 520.48 329.942 519.917 329.54L515.937 326.44C515.897 326.4 515.857 326.36 515.816 326.319Z",
    fill: "#01314D"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.283 326.319H498.932C498.53 326.319 498.168 326.682 498.168 327.084V330.868C498.168 331.271 498.53 331.633 498.932 331.633H505.283C505.685 331.633 506.047 331.271 506.047 330.868V327.084C506.047 326.682 505.685 326.319 505.283 326.319Z",
    fill: "#01314D"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.117 326.319H489.766C489.364 326.319 489.002 326.682 489.002 327.084V330.868C489.002 331.271 489.364 331.633 489.766 331.633H496.117C496.519 331.633 496.881 331.271 496.881 330.868V327.084C496.881 326.682 496.519 326.319 496.117 326.319Z",
    fill: "#01314D"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.952 326.319H480.601C480.199 326.319 479.837 326.682 479.837 327.084V330.868C479.837 331.271 480.199 331.633 480.601 331.633H486.952C487.354 331.633 487.716 331.271 487.716 330.868V327.084C487.676 326.682 487.354 326.319 486.952 326.319Z",
    fill: "#01314D"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.787 326.319H471.436C471.034 326.319 470.672 326.682 470.672 327.084V330.868C470.672 331.271 471.034 331.633 471.436 331.633H477.787C478.189 331.633 478.551 331.271 478.551 330.868V327.084C478.511 326.682 478.189 326.319 477.787 326.319Z",
    fill: "#01314D"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.062 337.39H518.591L517.505 338.718C516.782 339.563 516.138 339.926 514.691 339.926H360.001C358.514 339.926 357.911 339.563 357.187 338.718L356.062 337.39Z",
    fill: "#808080"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.32 332.922V334.854H449.124V332.922H456.32Z",
    fill: "#8B2135"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.42 339.926H449.124V337.39H460.42V339.926Z",
    fill: "#5E5E5E"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M584.398 330.708H410.854V331.634H584.398V330.708Z",
    fill: "url(#paint163_linear_1010_30625)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.267 327.527H584.358V333.968H363.057V334.853H584.399V337.39H356.062C355.941 337.39 355.821 337.39 355.66 337.349H355.579C355.539 337.349 355.539 337.349 355.499 337.349H355.459C355.419 337.349 355.419 337.349 355.378 337.349H355.338H355.298C355.258 337.349 355.218 337.349 355.137 337.309H355.097H355.057C355.017 337.309 355.017 337.309 354.976 337.309C354.936 337.309 354.936 337.309 354.896 337.309C354.856 337.309 354.816 337.309 354.816 337.269C354.695 337.229 354.574 337.229 354.494 337.188C354.414 337.188 354.373 337.148 354.293 337.148C354.213 337.108 354.172 337.108 354.092 337.068C354.052 337.068 353.971 337.027 353.931 337.027C353.891 336.987 353.811 336.987 353.77 336.987H353.73C353.69 336.987 353.69 336.947 353.65 336.947C353.569 336.907 353.449 336.866 353.368 336.826C353.208 336.746 353.047 336.665 352.886 336.585C352.765 336.544 352.645 336.464 352.564 336.383C352.524 336.383 352.524 336.343 352.484 336.343C352.404 336.303 352.363 336.262 352.283 336.222C352.243 336.182 352.203 336.182 352.162 336.142C352.122 336.142 352.122 336.101 352.082 336.101L352.042 336.061C352.002 336.061 352.002 336.021 352.002 336.021C351.961 335.981 351.881 335.94 351.841 335.9C351.801 335.86 351.76 335.82 351.72 335.779C351.68 335.739 351.64 335.699 351.64 335.659L351.6 335.618C351.559 335.578 351.559 335.578 351.519 335.538C351.519 335.538 351.519 335.498 351.479 335.498C351.479 335.498 351.479 335.457 351.439 335.457L351.399 335.417C351.399 335.417 351.399 335.417 351.399 335.377C351.399 335.337 351.358 335.337 351.358 335.337C351.318 335.296 351.318 335.256 351.318 335.256C351.278 335.216 351.278 335.176 351.278 335.135C351.278 335.095 351.238 335.095 351.238 335.095C351.238 335.055 351.198 335.015 351.198 334.974C351.198 334.934 351.157 334.894 351.157 334.853C351.117 334.773 351.117 334.733 351.117 334.652V334.612C351.117 334.572 351.117 334.491 351.117 334.451C351.117 334.37 351.117 334.25 351.117 334.169C351.117 334.129 351.117 334.129 351.117 334.089C351.117 334.048 351.117 333.968 351.157 333.887C351.157 333.847 351.157 333.847 351.157 333.847V333.807C351.157 333.767 351.157 333.767 351.157 333.767C351.157 333.767 351.157 333.767 351.157 333.726V333.686V333.646C351.157 333.606 351.157 333.565 351.198 333.525V333.485C351.198 333.445 351.238 333.404 351.238 333.364C351.238 333.284 351.278 333.243 351.318 333.163C351.358 333.122 351.358 333.042 351.399 333.002V332.961C351.439 332.881 351.479 332.8 351.519 332.76C351.519 332.72 351.559 332.72 351.559 332.68C351.6 332.639 351.64 332.559 351.68 332.519C351.841 332.277 352.002 332.076 352.162 331.875C352.203 331.794 352.283 331.754 352.323 331.673L352.363 331.633C352.404 331.593 352.404 331.593 352.444 331.553C352.484 331.512 352.524 331.472 352.564 331.432C352.605 331.391 352.685 331.311 352.725 331.271L352.846 331.15C352.926 331.069 352.966 331.029 353.047 330.949C353.167 330.868 353.248 330.747 353.368 330.667C353.409 330.627 353.409 330.627 353.449 330.586C353.489 330.546 353.529 330.506 353.569 330.506C353.61 330.466 353.65 330.466 353.69 330.425C353.811 330.345 353.931 330.264 354.012 330.184C354.052 330.144 354.132 330.103 354.172 330.063C354.213 330.063 354.213 330.023 354.213 330.023C354.293 329.942 354.373 329.902 354.454 329.862L358.434 326.762C358.474 326.722 358.514 326.682 358.554 326.641C358.554 326.641 358.554 326.641 358.594 326.641C358.755 326.52 358.916 326.4 359.077 326.319C359.197 326.239 359.318 326.158 359.439 326.078C359.599 325.997 359.72 325.917 359.881 325.836C360.042 325.756 360.202 325.675 360.363 325.595C360.484 325.514 360.645 325.474 360.765 325.393C360.926 325.313 361.127 325.232 361.288 325.152C361.449 325.071 361.65 325.031 361.851 324.951C361.971 324.91 362.092 324.87 362.172 324.83C362.333 324.789 362.494 324.709 362.655 324.669C362.815 324.628 363.016 324.548 363.177 324.548C363.338 324.508 363.499 324.467 363.619 324.427C363.78 324.387 363.941 324.347 364.102 324.306C364.263 324.266 364.423 324.266 364.584 324.226C364.624 324.226 364.705 324.186 364.785 324.186C364.946 324.145 365.147 324.145 365.348 324.105C365.469 324.105 365.629 324.065 365.79 324.065C365.951 324.065 366.072 324.025 366.232 324.025C366.514 323.984 366.835 323.984 367.117 323.984H584.198V326.561H405.267V327.527Z",
    fill: "url(#paint164_linear_1010_30625)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M584.399 337.39V339.926H360.002C358.515 339.926 357.912 339.563 357.188 338.718L356.103 337.43L356.062 337.39H584.399Z",
    fill: "url(#paint165_linear_1010_30625)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M527.635 349.265H525.424V364.16H527.635V349.265Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.453 342.502H521.242L525.423 349.265H527.634L523.453 342.502Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M529.605 342.502H531.816L527.635 349.265H525.424L529.605 342.502Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.65 344.394L531.816 342.502H529.605L528.479 344.394H530.65Z",
    fill: "#9D9D9C"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.619 344.394L523.453 342.502H521.242L522.408 344.394H524.619Z",
    fill: "#9D9D9C"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M483.978 349.265H481.767V364.159H483.978V349.265Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.757 342.502H477.586L481.767 349.265H483.978L479.757 342.502Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.947 342.502H488.158L483.978 349.265H481.767L485.947 342.502Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.992 344.394L488.158 342.502H485.947L484.781 344.394H486.992Z",
    fill: "#9D9D9C"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.923 344.394L479.757 342.502H477.586L478.752 344.394H480.923Z",
    fill: "#9D9D9C"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M440.324 349.265H438.113V364.16H440.324V349.265Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.101 342.502H433.931L438.111 349.265H440.282L436.101 342.502Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.294 342.502H444.465L440.284 349.265H438.113L442.294 342.502Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.339 344.394L444.465 342.502H442.294L441.128 344.394H443.339Z",
    fill: "#9D9D9C"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.267 344.394L436.101 342.502H433.931L435.056 344.394H437.267Z",
    fill: "#9D9D9C"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M396.621 349.265H394.41V364.16H396.621V349.265Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.442 342.502H390.231L394.412 349.265H396.623L392.442 342.502Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.631 342.502H400.802L396.621 349.265H394.41L398.631 342.502Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.638 344.394L400.803 342.502H398.633L397.467 344.394H399.638Z",
    fill: "#9D9D9C"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.608 344.394L392.442 342.502H390.231L391.397 344.394H393.608Z",
    fill: "#9D9D9C"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M352.967 349.265H350.756V364.159H352.967V349.265Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.786 342.502H346.575L350.756 349.265H352.967L348.786 342.502Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.937 342.502H357.148L352.967 349.265H350.756L354.937 342.502Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.983 344.394L357.149 342.502H354.938L353.772 344.394H355.983Z",
    fill: "#9D9D9C"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.912 344.394L348.786 342.502H346.575L347.741 344.394H349.912Z",
    fill: "#9D9D9C"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M309.311 349.265H307.1V364.16H309.311V349.265Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.09 342.502H302.919L307.1 349.265H309.271L305.09 342.502Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.28 342.502H313.491L309.27 349.265H307.1L311.28 342.502Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.325 344.394L313.491 342.502H311.28L310.114 344.394H312.325Z",
    fill: "#9D9D9C"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.256 344.394L305.09 342.502H302.919L304.085 344.394H306.256Z",
    fill: "#9D9D9C"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M265.651 349.265H263.44V364.16H265.651V349.265Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.431 342.502H259.22L263.441 349.265H265.612L261.431 342.502Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.621 342.502H269.792L265.611 349.265H263.44L267.621 342.502Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.626 344.394L269.792 342.502H267.621L266.455 344.394H268.626Z",
    fill: "#9D9D9C"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.597 344.394L261.431 342.502H259.22L260.386 344.394H262.597Z",
    fill: "#9D9D9C"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M221.956 349.265H219.745V364.16H221.956V349.265Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.774 342.502H215.563L219.744 349.265H221.955L217.774 342.502Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.926 342.502H226.137L221.956 349.265H219.745L223.926 342.502Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.97 344.394L226.135 342.502H223.924L222.799 344.394H224.97Z",
    fill: "#9D9D9C"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.94 344.394L217.774 342.502H215.563L216.729 344.394H218.94Z",
    fill: "#9D9D9C"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M178.297 349.265H176.086V364.16H178.297V349.265Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.076 342.502H171.905L176.086 349.265H178.297L174.076 342.502Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.267 342.502H182.478L178.297 349.265H176.086L180.267 342.502Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.312 344.394L182.477 342.502H180.266L179.101 344.394H181.312Z",
    fill: "#9D9D9C"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.242 344.394L174.076 342.502H171.905L173.071 344.394H175.242Z",
    fill: "#9D9D9C"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M134.64 349.266H132.429V364.161H134.64V349.266Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.419 342.502H128.248L132.429 349.265H134.6L130.419 342.502Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.61 342.502H138.78L134.6 349.265H132.429L136.61 342.502Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.654 344.394L138.78 342.502H136.609L135.443 344.394H137.654Z",
    fill: "#9D9D9C"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.585 344.394L130.419 342.502H128.248L129.374 344.394H131.585Z",
    fill: "#9D9D9C"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.309 364.161H214.194V285.3H245.309V364.161Z",
    fill: "#DADADA"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.195 285.299L203.421 269.64L192.688 285.299V364.161H214.195V285.299Z",
    fill: "#9D9D9C"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.196 285.299L203.422 269.64H234.577L245.31 285.299H214.196Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.195 285.299L203.421 269.64L192.688 285.299V364.161H214.195V285.299Z",
    fill: "url(#paint166_linear_1010_30625)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.309 364.161H214.194V285.3H245.309V364.161Z",
    fill: "url(#paint167_linear_1010_30625)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.174 350.595H223.52V358.968H218.174V350.595Z",
    fill: "#003D4C"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M222.355 352.164H218.174V358.967H222.355V352.164Z",
    fill: "#006C88"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.059 350.595H232.445V358.968H227.059V350.595Z",
    fill: "#003D4C"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M231.239 352.164H227.059V358.967H231.239V352.164Z",
    fill: "#006C88"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.984 350.595H241.331V358.968H235.984V350.595Z",
    fill: "#003D4C"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M240.165 352.164H235.984V358.967H240.165V352.164Z",
    fill: "#006C88"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.174 335.901H223.52V344.234H218.174V335.901Z",
    fill: "#003D4C"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M222.355 337.472H218.174V344.275H222.355V337.472Z",
    fill: "#006C88"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.059 335.901H232.445V344.234H227.059V335.901Z",
    fill: "#003D4C"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M231.239 337.472H227.059V344.275H231.239V337.472Z",
    fill: "#00ABC5"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.984 335.901H241.331V344.234H235.984V335.901Z",
    fill: "#003D4C"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M240.165 337.472H235.984V344.275H240.165V337.472Z",
    fill: "#006C88"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.174 321.168H223.52V329.501H218.174V321.168Z",
    fill: "#003D4C"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M222.355 322.736H218.174V329.54H222.355V322.736Z",
    fill: "#006C88"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.059 321.168H232.445V329.501H227.059V321.168Z",
    fill: "#003D4C"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M231.239 322.736H227.059V329.54H231.239V322.736Z",
    fill: "#006C88"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.984 321.168H241.331V329.501H235.984V321.168Z",
    fill: "#003D4C"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M240.165 322.736H235.984V329.54H240.165V322.736Z",
    fill: "#00ABC5"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.174 306.434H223.52V314.767H218.174V306.434Z",
    fill: "#003D4C"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M222.355 308.003H218.174V314.806H222.355V308.003Z",
    fill: "#00ABC5"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.059 306.434H232.445V314.767H227.059V306.434Z",
    fill: "#003D4C"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M231.239 308.003H227.059V314.806H231.239V308.003Z",
    fill: "#006C88"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.984 306.434H241.331V314.767H235.984V306.434Z",
    fill: "#003D4C"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M240.165 308.003H235.984V314.806H240.165V308.003Z",
    fill: "#006C88"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.174 291.7H223.52V300.033H218.174V291.7Z",
    fill: "#003D4C"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M222.355 293.271H218.174V300.074H222.355V293.271Z",
    fill: "#006C88"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.059 291.7H232.445V300.033H227.059V291.7Z",
    fill: "#003D4C"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M231.239 293.271H227.059V300.074H231.239V293.271Z",
    fill: "#006C88"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.984 291.7H241.331V300.033H235.984V291.7Z",
    fill: "#003D4C"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M240.165 293.271H235.984V300.074H240.165V293.271Z",
    fill: "#006C88"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.599 364.16H156.188V253.697H198.599V364.16Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.187 253.697H138.017V364.16H156.187V253.697Z",
    fill: "#C2C2C2"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.187 253.697H138.017V364.16H156.187V253.697Z",
    fill: "url(#paint168_linear_1010_30625)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.599 364.16H156.188V253.697H198.599V364.16Z",
    fill: "url(#paint169_linear_1010_30625)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.252 350.594H193.533V364.16H161.252V350.594Z",
    fill: "#00546F"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M192.327 352.164H161.252V364.16H192.327V352.164Z",
    fill: "#00ABC5"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M192.327 352.164H161.252V364.16H192.327V352.164Z",
    fill: "url(#paint170_linear_1010_30625)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.252 335.899H165.875V344.232H161.252V335.899Z",
    fill: "#00546F"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M164.669 337.471H161.252V344.274H164.669V337.471Z",
    fill: "#00ABC5"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.459 335.899H175.082V344.232H170.459V335.899Z",
    fill: "#00546F"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M173.876 337.471H170.459V344.274H173.876V337.471Z",
    fill: "#00ABC5"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.702 335.899H184.325V344.232H179.702V335.899Z",
    fill: "#00546F"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M183.119 337.471H179.702V344.274H183.119V337.471Z",
    fill: "#54E6ED"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.909 335.899H193.532V344.232H188.909V335.899Z",
    fill: "#00546F"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M192.326 337.471H188.909V344.274H192.326V337.471Z",
    fill: "#00ABC5"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.252 321.166H165.875V329.499H161.252V321.166Z",
    fill: "#00546F"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M164.669 322.737H161.252V329.541H164.669V322.737Z",
    fill: "#54E6ED"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.459 321.166H175.082V329.499H170.459V321.166Z",
    fill: "#00546F"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M173.876 322.737H170.459V329.541H173.876V322.737Z",
    fill: "#00ABC5"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.702 321.166H184.325V329.499H179.702V321.166Z",
    fill: "#00546F"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M183.119 322.737H179.702V329.541H183.119V322.737Z",
    fill: "#00ABC5"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.909 321.166H193.532V329.499H188.909V321.166Z",
    fill: "#00546F"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M192.326 322.737H188.909V329.541H192.326V322.737Z",
    fill: "#00ABC5"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.252 306.432H165.875V314.765H161.252V306.432Z",
    fill: "#00546F"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M164.669 308.003H161.252V314.806H164.669V308.003Z",
    fill: "#00ABC5"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.459 306.433H175.082V314.766H170.459V306.433Z",
    fill: "#00546F"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M173.876 308.003H170.459V314.806H173.876V308.003Z",
    fill: "#00ABC5"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.702 306.432H184.325V314.765H179.702V306.432Z",
    fill: "#00546F"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M183.119 308.003H179.702V314.806H183.119V308.003Z",
    fill: "#00ABC5"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.909 306.433H193.532V314.766H188.909V306.433Z",
    fill: "#00546F"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M192.326 308.003H188.909V314.806H192.326V308.003Z",
    fill: "#00ABC5"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.252 291.699H165.875V300.032H161.252V291.699Z",
    fill: "#00546F"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M164.669 293.27H161.252V300.073H164.669V293.27Z",
    fill: "#00ABC5"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.459 291.699H175.082V300.032H170.459V291.699Z",
    fill: "#00546F"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M173.876 293.27H170.459V300.073H173.876V293.27Z",
    fill: "#00ABC5"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.702 291.699H184.325V300.032H179.702V291.699Z",
    fill: "#00546F"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M183.119 293.27H179.702V300.073H183.119V293.27Z",
    fill: "#54E6ED"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.909 291.699H193.532V300.032H188.909V291.699Z",
    fill: "#00546F"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M192.326 293.27H188.909V300.073H192.326V293.27Z",
    fill: "#00ABC5"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.252 276.965H165.875V285.298H161.252V276.965Z",
    fill: "#00546F"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M164.669 278.536H161.252V285.339H164.669V278.536Z",
    fill: "#00ABC5"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.459 276.965H175.082V285.298H170.459V276.965Z",
    fill: "#00546F"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M173.876 278.536H170.459V285.339H173.876V278.536Z",
    fill: "#54E6ED"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.702 276.965H184.325V285.298H179.702V276.965Z",
    fill: "#00546F"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M183.119 278.536H179.702V285.339H183.119V278.536Z",
    fill: "#00ABC5"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.909 276.965H193.532V285.298H188.909V276.965Z",
    fill: "#00546F"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M192.326 278.536H188.909V285.339H192.326V278.536Z",
    fill: "#00ABC5"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.252 262.231H165.875V270.564H161.252V262.231Z",
    fill: "#00546F"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M164.669 263.802H161.252V270.605H164.669V263.802Z",
    fill: "#00ABC5"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.459 262.231H175.082V270.564H170.459V262.231Z",
    fill: "#00546F"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M173.876 263.802H170.459V270.605H173.876V263.802Z",
    fill: "#00ABC5"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.702 262.231H184.325V270.564H179.702V262.231Z",
    fill: "#00546F"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M183.119 263.802H179.702V270.605H183.119V263.802Z",
    fill: "#00ABC5"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.909 262.231H193.532V270.564H188.909V262.231Z",
    fill: "#00546F"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M192.326 263.802H188.909V270.605H192.326V263.802Z",
    fill: "#00ABC5"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M188.909 350.594H180.065V364.16H188.909V350.594Z",
    fill: "#54E6ED"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.08 364.161H152.407V314.444H175.08V364.161Z",
    fill: "#DADADA"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.407 314.444L141.674 298.784L130.94 314.444V364.16H152.407V314.444Z",
    fill: "#9D9D9C"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.406 314.444L141.673 298.784H164.346L175.079 314.444H152.406Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.08 364.161H152.407V314.444H175.08V364.161Z",
    fill: "url(#paint171_linear_1010_30625)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.407 314.444L141.674 298.784L130.94 314.444V364.16H152.407V314.444Z",
    fill: "url(#paint172_linear_1010_30625)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.147 321.166H171.258V329.499H165.147V321.166Z",
    fill: "#003D4C"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.266 321.166H162.336V329.499H156.266V321.166Z",
    fill: "#003D4C"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.147 335.899H171.258V344.232H165.147V335.899Z",
    fill: "#003D4C"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.266 335.899H162.336V344.232H156.266V335.899Z",
    fill: "#003D4C"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.147 350.634H171.258V358.967H165.147V350.634Z",
    fill: "#003D4C"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.266 350.634H162.336V358.967H156.266V350.634Z",
    fill: "#003D4C"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M161.13 322.736H156.266V329.54H161.13V322.736Z",
    fill: "#006C88"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M170.012 322.736H165.147V329.54H170.012V322.736Z",
    fill: "#006C88"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M161.13 337.469H156.266V344.272H161.13V337.469Z",
    fill: "#00ABC5"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M170.012 337.469H165.147V344.272H170.012V337.469Z",
    fill: "#006C88"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M161.13 352.203H156.266V359.006H161.13V352.203Z",
    fill: "#006C88"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M170.012 352.203H165.147V359.006H170.012V352.203Z",
    fill: "#006C88"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.603 337.993C140.708 337.993 144.849 342.14 144.849 347.252C144.849 352.365 140.708 356.511 135.603 356.511C130.497 356.511 126.357 352.365 126.357 347.252C126.317 342.14 130.457 337.993 135.603 337.993Z",
    fill: "#698018"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.567 338.437C140.587 338.437 143.843 341.697 143.843 345.723C143.843 349.748 140.587 353.009 136.567 353.009C132.547 353.009 129.291 349.748 129.291 345.723C129.291 341.697 132.547 338.437 136.567 338.437Z",
    fill: "url(#paint173_radial_1010_30625)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.412 339.764C139.582 340.046 141.15 341.535 140.949 343.065C140.748 344.595 138.819 345.601 136.648 345.319C134.477 345.038 132.909 343.548 133.11 342.018C133.311 340.489 135.241 339.482 137.412 339.764Z",
    fill: "url(#paint174_radial_1010_30625)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M136.086 347.011V351.882L138.819 349.547L139.141 349.909L136.086 352.848V364.16H135.161L135.483 346.77L136.086 347.011Z",
    fill: "#4F372A"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.511 359.128V364.16H198.597V357.719H220.104C220.908 357.719 221.511 358.363 221.511 359.128Z",
    fill: "#789E10"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.511 359.128V360.255C221.511 360.819 221.069 361.262 220.506 361.262H198.597V357.76H220.104C220.908 357.719 221.511 358.363 221.511 359.128Z",
    fill: "#AFD435"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.067 358.967H202.137C202.057 358.967 201.977 358.886 201.977 358.806V357.88C201.977 357.799 202.057 357.719 202.137 357.719H220.067C220.147 357.719 220.227 357.799 220.227 357.88V358.806C220.227 358.886 220.187 358.967 220.067 358.967Z",
    fill: "#E8F090"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.781 364.16H303.038V224.432H339.781V364.16Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.037 224.432H281.57V364.16H303.037V224.432Z",
    fill: "#C2C2C2"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.037 224.432H281.57V364.16H303.037V224.432Z",
    fill: "url(#paint175_linear_1010_30625)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.781 364.16H303.038V224.432H339.781V364.16Z",
    fill: "url(#paint176_linear_1010_30625)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.656 350.594H312.726V364.16H306.656V350.594Z",
    fill: "#006D88"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.454 350.594H320.524V364.16H314.454V350.594Z",
    fill: "#006D88"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.254 350.594H328.324V364.16H322.254V350.594Z",
    fill: "#006D88"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.053 350.594H336.163V364.16H330.053V350.594Z",
    fill: "#006D88"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M311.802 352.163H306.656V364.159H311.802V352.163Z",
    fill: "#00B6CA"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M319.599 352.163H314.453V364.159H319.599V352.163Z",
    fill: "#00B6CA"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 352.163H322.254V364.159H327.4V352.163Z",
    fill: "#00B6CA"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 352.163H330.053V364.159H335.198V352.163Z",
    fill: "#00B6CA"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.656 335.86H312.726V344.234H306.656V335.86Z",
    fill: "#006D88"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M311.802 337.43H306.656V344.233H311.802V337.43Z",
    fill: "#5DDBD8"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.454 335.86H320.524V344.234H314.454V335.86Z",
    fill: "#006D88"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 337.43H314.454V344.233H319.6V337.43Z",
    fill: "#00B6CA"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.254 335.86H328.324V344.234H322.254V335.86Z",
    fill: "#006D88"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 337.43H322.254V344.233H327.4V337.43Z",
    fill: "#00B6CA"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.053 335.86H336.163V344.234H330.053V335.86Z",
    fill: "#006D88"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 337.43H330.053V344.233H335.198V337.43Z",
    fill: "#00B6CA"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.656 321.127H312.726V329.5H306.656V321.127Z",
    fill: "#006D88"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M311.802 322.696H306.656V329.5H311.802V322.696Z",
    fill: "#00B6CA"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.454 321.127H320.524V329.5H314.454V321.127Z",
    fill: "#006D88"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 322.696H314.454V329.5H319.6V322.696Z",
    fill: "#00B6CA"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.254 321.127H328.324V329.5H322.254V321.127Z",
    fill: "#006D88"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 322.696H322.254V329.5H327.4V322.696Z",
    fill: "#5DDBD8"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.053 321.127H336.163V329.5H330.053V321.127Z",
    fill: "#006D88"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 322.696H330.053V329.5H335.198V322.696Z",
    fill: "#00B6CA"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.656 306.393H312.726V314.766H306.656V306.393Z",
    fill: "#006D88"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M311.802 307.962H306.656V314.765H311.802V307.962Z",
    fill: "#00B6CA"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.454 306.393H320.524V314.766H314.454V306.393Z",
    fill: "#006D88"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 307.962H314.454V314.765H319.6V307.962Z",
    fill: "#00B6CA"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.254 306.393H328.324V314.766H322.254V306.393Z",
    fill: "#006D88"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 307.962H322.254V314.765H327.4V307.962Z",
    fill: "#00B6CA"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.053 306.393H336.163V314.766H330.053V306.393Z",
    fill: "#006D88"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 307.962H330.053V314.765H335.198V307.962Z",
    fill: "#00B6CA"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.656 291.659H312.726V300.033H306.656V291.659Z",
    fill: "#006D88"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M311.802 293.229H306.656V300.032H311.802V293.229Z",
    fill: "#00B6CA"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.454 291.659H320.524V300.032H314.454V291.659Z",
    fill: "#006D88"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 293.229H314.454V300.032H319.6V293.229Z",
    fill: "#5DDBD8"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.254 291.659H328.324V300.032H322.254V291.659Z",
    fill: "#006D88"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 293.229H322.254V300.032H327.4V293.229Z",
    fill: "#00B6CA"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.053 291.659H336.163V300.032H330.053V291.659Z",
    fill: "#006D88"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 293.229H330.053V300.032H335.198V293.229Z",
    fill: "#00B6CA"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.656 276.966H312.726V285.299H306.656V276.966Z",
    fill: "#006D88"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M311.802 278.535H306.656V285.338H311.802V278.535Z",
    fill: "#00B6CA"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.454 276.966H320.524V285.299H314.454V276.966Z",
    fill: "#006D88"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 278.535H314.454V285.338H319.6V278.535Z",
    fill: "#00B6CA"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.254 276.966H328.324V285.299H322.254V276.966Z",
    fill: "#006D88"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 278.535H322.254V285.338H327.4V278.535Z",
    fill: "#5DDBD8"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.053 276.966H336.163V285.299H330.053V276.966Z",
    fill: "#006D88"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 278.535H330.053V285.338H335.198V278.535Z",
    fill: "#5DDBD8"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.656 262.232H312.726V270.565H306.656V262.232Z",
    fill: "#006D88"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M311.802 263.802H306.656V270.605H311.802V263.802Z",
    fill: "#00B6CA"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.454 262.232H320.524V270.565H314.454V262.232Z",
    fill: "#006D88"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 263.802H314.454V270.605H319.6V263.802Z",
    fill: "#00B6CA"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.254 262.232H328.324V270.565H322.254V262.232Z",
    fill: "#006D88"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 263.802H322.254V270.605H327.4V263.802Z",
    fill: "#00B6CA"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.053 262.232H336.163V270.565H330.053V262.232Z",
    fill: "#006D88"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 263.802H330.053V270.605H335.198V263.802Z",
    fill: "#00B6CA"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.656 247.498H312.726V255.831H306.656V247.498Z",
    fill: "#006D88"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M311.802 249.067H306.656V255.871H311.802V249.067Z",
    fill: "#00B6CA"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.454 247.498H320.524V255.831H314.454V247.498Z",
    fill: "#006D88"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 249.067H314.454V255.871H319.6V249.067Z",
    fill: "#5DDBD8"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.254 247.498H328.324V255.831H322.254V247.498Z",
    fill: "#006D88"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 249.067H322.254V255.871H327.4V249.067Z",
    fill: "#00B6CA"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.053 247.498H336.163V255.831H330.053V247.498Z",
    fill: "#006D88"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 249.067H330.053V255.871H335.198V249.067Z",
    fill: "#00B6CA"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.656 232.765H312.726V241.138H306.656V232.765Z",
    fill: "#006D88"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M311.802 234.334H306.656V241.137H311.802V234.334Z",
    fill: "#00B6CA"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.454 232.765H320.524V241.138H314.454V232.765Z",
    fill: "#006D88"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 234.334H314.454V241.137H319.6V234.334Z",
    fill: "#00B6CA"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.254 232.765H328.324V241.138H322.254V232.765Z",
    fill: "#006D88"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 234.334H322.254V241.137H327.4V234.334Z",
    fill: "#00B6CA"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.053 232.765H336.163V241.138H330.053V232.765Z",
    fill: "#006D88"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 234.334H330.053V241.137H335.198V234.334Z",
    fill: "#00B6CA"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M311.802 352.163H306.656V364.159H311.802V352.163Z",
    fill: "url(#paint177_linear_1010_30625)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M319.599 352.163H314.453V364.159H319.599V352.163Z",
    fill: "url(#paint178_linear_1010_30625)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M327.4 352.163H322.254V364.159H327.4V352.163Z",
    fill: "url(#paint179_linear_1010_30625)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M335.198 352.163H330.053V364.159H335.198V352.163Z",
    fill: "url(#paint180_linear_1010_30625)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.419 332.076C289.248 332.076 293.952 336.786 293.952 342.623C293.952 348.46 289.248 353.17 283.419 353.17C277.59 353.17 272.887 348.46 272.887 342.623C272.887 336.786 277.63 332.076 283.419 332.076Z",
    fill: "#698018"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.545 332.601C289.128 332.601 292.826 336.304 292.826 340.893C292.826 345.483 289.128 349.186 284.545 349.186C279.962 349.186 276.264 345.483 276.264 340.893C276.264 336.304 279.962 332.601 284.545 332.601Z",
    fill: "url(#paint181_radial_1010_30625)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.509 334.088C287.961 334.41 289.77 336.101 289.529 337.832C289.288 339.563 287.117 340.73 284.665 340.368C282.212 340.046 280.403 338.355 280.645 336.624C280.846 334.893 283.057 333.766 285.509 334.088Z",
    fill: "url(#paint182_radial_1010_30625)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M283.057 343.911V348.822L280.364 346.488L280.042 346.85L283.057 349.789V364.16H284.022L283.7 343.71L283.057 343.911Z",
    fill: "#4F372A"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.037 364.16H317.308V358.484C317.308 358.081 316.986 357.719 316.544 357.719H295.922C295.439 357.719 295.037 358.121 295.037 358.604V364.16Z",
    fill: "#789E10"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.991 361.261H316.785C317.107 361.261 317.348 361.02 317.348 360.698V358.484C317.348 358.081 317.026 357.719 316.584 357.719H301.991C301.67 357.719 301.429 357.96 301.429 358.282V360.698C301.429 361.02 301.71 361.261 301.991 361.261Z",
    fill: "#AFD435"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.58 358.967H305.289C305.168 358.967 305.088 358.886 305.088 358.765V357.96C305.088 357.84 305.168 357.759 305.289 357.759H315.58C315.701 357.759 315.781 357.84 315.781 357.96V358.765C315.781 358.886 315.701 358.967 315.58 358.967Z",
    fill: "#E8F090"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.009 338.839C301.672 338.839 305.41 342.623 305.41 347.252C305.41 351.922 301.632 355.666 297.009 355.666C292.345 355.666 288.607 351.882 288.607 347.252C288.567 342.623 292.345 338.839 297.009 338.839Z",
    fill: "#87A31F"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.893 339.241C301.551 339.241 304.526 342.22 304.526 345.883C304.526 349.547 301.551 352.526 297.893 352.526C294.235 352.526 291.26 349.547 291.26 345.883C291.26 342.22 294.235 339.241 297.893 339.241Z",
    fill: "url(#paint183_radial_1010_30625)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.654 340.449C300.624 340.731 302.071 342.059 301.87 343.468C301.669 344.877 299.941 345.763 297.971 345.521C296.001 345.239 294.554 343.911 294.755 342.502C294.916 341.093 296.685 340.167 298.654 340.449Z",
    fill: "url(#paint184_radial_1010_30625)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M297.49 347.011V351.882L300.224 349.547L300.545 349.909L297.49 352.848V364.16H296.565L296.847 346.77L297.49 347.011Z",
    fill: "#4F372A"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.294 364.16H293.148V358.484C293.148 358.081 292.826 357.719 292.384 357.719H275.138C274.656 357.719 274.254 358.121 274.254 358.604V364.16H274.294Z",
    fill: "#789E10"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.158 361.261H292.625C292.946 361.261 293.187 361.02 293.187 360.698V358.484C293.187 358.081 292.866 357.719 292.424 357.719H279.158C278.836 357.719 278.595 357.96 278.595 358.282V360.698C278.595 361.02 278.836 361.261 279.158 361.261Z",
    fill: "#AFD435"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.418 358.967H284.665C284.544 358.967 284.464 358.886 284.464 358.765V357.96C284.464 357.84 284.544 357.759 284.665 357.759H291.418C291.539 357.759 291.619 357.84 291.619 357.96V358.765C291.619 358.886 291.539 358.967 291.418 358.967Z",
    fill: "#E8F090"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.802 364.16V361.221C255.802 360.457 255.199 359.812 254.395 359.812H228.707C227.822 359.812 227.099 360.537 227.099 361.423V364.16H255.802Z",
    fill: "#706F6F"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.151 364.16H259.662V358.484C259.662 358.081 259.341 357.719 258.899 357.719H229.995C229.512 357.719 229.11 358.121 229.11 358.604V364.16H229.151Z",
    fill: "#789E10"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.929 361.261H259.099C259.421 361.261 259.662 361.02 259.662 360.698V358.484C259.662 358.081 259.341 357.719 258.898 357.719H232.929C232.607 357.719 232.366 357.96 232.366 358.282V360.698C232.406 361.02 232.648 361.261 232.929 361.261Z",
    fill: "#AFD435"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.853 358.967H237.11C237.03 358.967 236.949 358.886 236.949 358.806V357.88C236.949 357.799 237.03 357.719 237.11 357.719H257.853C257.934 357.719 258.014 357.799 258.014 357.88V358.806C258.014 358.886 257.934 358.967 257.853 358.967Z",
    fill: "#E8F090"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.043 364.16H460.421V253.697H513.043V364.16Z",
    fill: "white"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 262.231H489.083V270.564H484.38V262.231Z",
    fill: "#00ABC5"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 262.231H479.677V270.564H474.974V262.231Z",
    fill: "#54E6ED"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 262.231H470.31V270.564H465.606V262.231Z",
    fill: "#00ABC5"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 262.231H507.857V270.564H503.153V262.231Z",
    fill: "#00ABC5"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 262.231H498.491V270.564H493.787V262.231Z",
    fill: "#00ABC5"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 276.965H489.083V285.298H484.38V276.965Z",
    fill: "#00ABC5"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 276.965H479.677V285.298H474.974V276.965Z",
    fill: "#00ABC5"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 276.965H470.31V285.298H465.606V276.965Z",
    fill: "#00ABC5"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 276.965H507.857V285.298H503.153V276.965Z",
    fill: "#00ABC5"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 276.965H498.491V285.298H493.787V276.965Z",
    fill: "#54E6ED"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 291.699H489.083V300.032H484.38V291.699Z",
    fill: "#00ABC5"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 291.699H479.677V300.032H474.974V291.699Z",
    fill: "#00ABC5"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 291.699H470.31V300.032H465.606V291.699Z",
    fill: "#00ABC5"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 291.699H507.857V300.032H503.153V291.699Z",
    fill: "#00ABC5"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 291.699H498.491V300.032H493.787V291.699Z",
    fill: "#00ABC5"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 306.432H489.083V314.765H484.38V306.432Z",
    fill: "#00ABC5"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 306.432H479.677V314.765H474.974V306.432Z",
    fill: "#54E6ED"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 306.432H470.31V314.765H465.606V306.432Z",
    fill: "#00ABC5"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 306.432H507.857V314.765H503.153V306.432Z",
    fill: "#00ABC5"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 306.433H498.491V314.766H493.787V306.433Z",
    fill: "#00ABC5"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 321.166H489.083V329.499H484.38V321.166Z",
    fill: "#00ABC5"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 321.166H479.677V329.499H474.974V321.166Z",
    fill: "#00ABC5"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 321.166H470.31V329.499H465.606V321.166Z",
    fill: "#00ABC5"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 321.166H507.857V329.499H503.153V321.166Z",
    fill: "#00ABC5"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 321.166H498.491V329.499H493.787V321.166Z",
    fill: "#00ABC5"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 335.899H489.083V344.232H484.38V335.899Z",
    fill: "#00ABC5"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 335.899H479.677V344.232H474.974V335.899Z",
    fill: "#00ABC5"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 335.899H470.31V344.232H465.606V335.899Z",
    fill: "#00ABC5"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 335.899H507.857V344.232H503.153V335.899Z",
    fill: "#00ABC5"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 335.899H498.491V344.232H493.787V335.899Z",
    fill: "#00ABC5"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.12 350.594H509.385V364.16H464.12V350.594Z",
    fill: "#00ABC5"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 262.231H470.31V263.801V270.564H469.104V263.801H465.606V262.231Z",
    fill: "#00546F"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 262.231H479.677V263.801V270.564H478.471V263.801H474.974V262.231Z",
    fill: "#00546F"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 262.231H489.083V263.801V270.564H487.877V263.801H484.38V262.231Z",
    fill: "#00546F"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 262.231H498.491V263.801V270.564H497.285V263.801H493.787V262.231Z",
    fill: "#00546F"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 262.231H507.857V263.801V270.564H506.651V263.801H503.153V262.231Z",
    fill: "#00546F"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 276.965H470.31V278.535V285.298H469.104V278.535H465.606V276.965Z",
    fill: "#00546F"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 276.965H479.677V278.535V285.298H478.471V278.535H474.974V276.965Z",
    fill: "#00546F"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 276.965H489.083V278.535V285.298H487.877V278.535H484.38V276.965Z",
    fill: "#00546F"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 276.965H498.491V278.535V285.298H497.285V278.535H493.787V276.965Z",
    fill: "#00546F"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 276.965H507.857V278.535V285.298H506.651V278.535H503.153V276.965Z",
    fill: "#00546F"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 291.699H470.31V293.269V300.032H469.104V293.269H465.606V291.699Z",
    fill: "#00546F"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 291.699H479.677V293.269V300.032H478.471V293.269H474.974V291.699Z",
    fill: "#00546F"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 291.699H489.083V293.269V300.032H487.877V293.269H484.38V291.699Z",
    fill: "#00546F"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 291.699H498.491V293.269V300.032H497.285V293.269H493.787V291.699Z",
    fill: "#00546F"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 291.699H507.857V293.269V300.032H506.651V293.269H503.153V291.699Z",
    fill: "#00546F"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 306.432H470.31V308.002V314.765H469.104V308.002H465.606V306.432Z",
    fill: "#00546F"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 306.432H479.677V308.002V314.765H478.471V308.002H474.974V306.432Z",
    fill: "#00546F"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 306.432H489.083V308.002V314.765H487.877V308.002H484.38V306.432Z",
    fill: "#00546F"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 306.433H498.491V308.003V314.766H497.285V308.003H493.787V306.433Z",
    fill: "#00546F"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 306.432H507.857V308.002V314.765H506.651V308.002H503.153V306.432Z",
    fill: "#00546F"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 321.166H470.31V322.736V329.499H469.104V322.736H465.606V321.166Z",
    fill: "#00546F"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 321.166H479.677V322.736V329.499H478.471V322.736H474.974V321.166Z",
    fill: "#00546F"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 321.166H489.083V322.736V329.499H487.877V322.736H484.38V321.166Z",
    fill: "#00546F"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 321.166H498.491V322.736V329.499H497.285V322.736H493.787V321.166Z",
    fill: "#00546F"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 321.166H507.857V322.736V329.499H506.651V322.736H503.153V321.166Z",
    fill: "#00546F"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.606 335.899H470.31V337.469V344.232H469.104V337.469H465.606V335.899Z",
    fill: "#00546F"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.974 335.899H479.677V337.469V344.232H478.471V337.469H474.974V335.899Z",
    fill: "#00546F"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.38 335.899H489.083V337.469V344.232H487.877V337.469H484.38V335.899Z",
    fill: "#00546F"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.787 335.899H498.491V337.469V344.232H497.285V337.469H493.787V335.899Z",
    fill: "#00546F"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.153 335.899H507.857V337.469V344.232H506.651V337.469H503.153V335.899Z",
    fill: "#00546F"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.12 350.594H509.385V364.16H464.12V350.594Z",
    fill: "url(#paint185_linear_1010_30625)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.12 350.594H509.385V352.164V364.16H508.179V352.164H464.12V350.594Z",
    fill: "#00546F"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M489.084 350.594H474.974V364.16H489.084V350.594Z",
    fill: "#54E6ED"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.435 364.16H523.093V358.484C523.093 358.081 522.771 357.719 522.329 357.719H504.279C503.797 357.719 503.395 358.121 503.395 358.604V364.16H503.435Z",
    fill: "#789E10"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.454 361.261H522.529C522.851 361.261 523.092 361.02 523.092 360.698V358.484C523.092 358.081 522.771 357.719 522.328 357.719H507.454C507.133 357.719 506.892 357.96 506.892 358.282V360.698C506.932 361.02 507.173 361.261 507.454 361.261Z",
    fill: "#AFD435"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.365 358.966H514.33C514.209 358.966 514.129 358.886 514.129 358.765V357.96C514.129 357.839 514.209 357.759 514.33 357.759H521.365C521.486 357.759 521.566 357.839 521.566 357.96V358.765C521.566 358.886 521.486 358.966 521.365 358.966Z",
    fill: "#E8F090"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.987 364.16H495.394V358.484C495.394 358.081 495.072 357.719 494.63 357.719H454.832C454.349 357.719 453.947 358.121 453.947 358.604V364.16H453.987Z",
    fill: "#789E10"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.034 361.261H494.832C495.153 361.261 495.395 361.02 495.395 360.698V358.484C495.395 358.081 495.073 357.719 494.631 357.719H463.034C462.712 357.719 462.471 357.96 462.471 358.282V360.698C462.511 361.02 462.752 361.261 463.034 361.261Z",
    fill: "#AFD435"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.384 358.966H476.54C476.419 358.966 476.339 358.886 476.339 358.765V357.96C476.339 357.839 476.419 357.759 476.54 357.759H493.384C493.504 357.759 493.585 357.839 493.585 357.96V358.765C493.625 358.886 493.504 358.966 493.384 358.966Z",
    fill: "#E8F090"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.312 28.9319C274.472 28.9319 272.03 31.5895 271.155 35.2836C270.411 34.2737 269.27 33.6093 267.996 33.6093C265.714 33.6093 263.883 35.7088 263.883 38.3133H291.033C291.033 34.8584 288.671 32.0413 285.539 32.0413C284.504 32.0413 283.575 32.5462 282.832 33.4233C281.717 30.7125 279.647 28.9319 277.312 28.9319Z",
    fill: "#DEF9FF"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.983 25.8235C178.026 25.8235 179.672 27.8964 179.672 30.4477H172.294C172.294 27.8964 173.939 25.8235 175.983 25.8235Z",
    fill: "#DEF9FF"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.052 25.5574C211.414 25.5574 213.352 27.7366 213.352 30.4474H181.106C181.106 26.2218 183.468 22.7935 186.388 22.7935C188.113 22.7935 189.626 23.9628 190.608 25.7966C191.855 21.5444 194.774 18.5413 198.171 18.5413C201.86 18.5413 204.992 22.0759 206.027 26.9393C206.823 26.0889 207.885 25.5574 209.052 25.5574Z",
    fill: "#DEF9FF"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.596 27.8157C222.109 27.8157 223.303 28.985 223.303 30.4467H217.862C217.862 28.985 219.083 27.8157 220.596 27.8157Z",
    fill: "#DEF9FF"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.417 26.3013C150.585 26.3013 151.593 27.0454 152.177 28.1882C152.947 25.0522 155.282 22.7932 158.016 22.7932C161.386 22.7932 164.146 26.2215 164.146 30.4472H146.1C146.1 28.1616 147.586 26.3013 149.417 26.3013Z",
    fill: "#DEF9FF"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.663 27.1252C357.911 27.1252 358.946 28.6135 358.946 30.4207H354.381C354.381 28.6135 355.416 27.1252 356.663 27.1252Z",
    fill: "#DEF9FF"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.23 24.6007C327.123 24.6007 329.458 27.2052 329.458 30.4475H296.417C296.417 26.1421 298.885 22.6606 301.937 22.6606C303.238 22.6606 304.432 23.2985 305.387 24.3615C306.847 21.0129 309.448 18.7805 312.42 18.7805C316.056 18.7805 319.135 22.1025 320.223 26.7002C321.178 25.398 322.611 24.6007 324.23 24.6007Z",
    fill: "#DEF9FF"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.859 26.3013C347.639 26.3013 346.577 27.0454 345.94 28.1882C345.117 25.0522 342.676 22.7932 339.783 22.7932C336.227 22.7932 333.334 26.2215 333.334 30.4737H352.363C352.336 28.1616 350.797 26.3013 348.859 26.3013Z",
    fill: "#DEF9FF"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.14 35.7883C261.573 35.7883 262.767 36.9311 262.767 38.3131H257.539C257.539 36.9045 258.707 35.7883 260.14 35.7883Z",
    fill: "#DEF9FF"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.611 47.9395C504.86 47.9395 503.354 49.5785 502.814 51.8567C502.355 51.2339 501.652 50.8241 500.866 50.8241C499.458 50.8241 498.329 52.119 498.329 53.7252H515.073C515.073 51.5945 513.616 49.8571 511.685 49.8571C511.047 49.8571 510.474 50.1685 510.015 50.7094C509.328 49.0376 508.051 47.9395 506.611 47.9395Z",
    fill: "#DEF9FF"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.12 46.0225C445.38 46.0225 446.395 47.3009 446.395 48.8744H441.845C441.845 47.3009 442.86 46.0225 444.12 46.0225Z",
    fill: "#DEF9FF"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.514 45.8583C465.971 45.8583 467.166 47.2023 467.166 48.8741H447.279C447.279 46.268 448.736 44.1537 450.536 44.1537C451.6 44.1537 452.533 44.8749 453.139 46.0058C453.908 43.3833 455.709 41.5312 457.804 41.5312C460.079 41.5312 462.01 43.7111 462.648 46.7106C463.139 46.1861 463.794 45.8583 464.514 45.8583Z",
    fill: "#DEF9FF"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.635 47.252C472.568 47.252 473.305 47.9731 473.305 48.8746H469.949C469.949 47.9731 470.702 47.252 471.635 47.252Z",
    fill: "#DEF9FF"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.736 46.3168C428.457 46.3168 429.078 46.7758 429.439 47.4805C429.913 45.5465 431.354 44.1533 433.039 44.1533C435.118 44.1533 436.82 46.2677 436.82 48.8737H425.69C425.69 47.4641 426.607 46.3168 427.736 46.3168Z",
    fill: "#DEF9FF"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.548 46.8252C556.317 46.8252 556.956 47.743 556.956 48.8576H554.141C554.141 47.743 554.779 46.8252 555.548 46.8252Z",
    fill: "#DEF9FF"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.549 45.2672C537.333 45.2672 538.773 46.8734 538.773 48.873H518.396C518.396 46.2178 519.918 44.0707 521.8 44.0707C522.602 44.0707 523.338 44.4641 523.928 45.1197C524.828 43.0545 526.432 41.6777 528.265 41.6777C530.507 41.6777 532.406 43.7265 533.077 46.562C533.666 45.7589 534.55 45.2672 535.549 45.2672Z",
    fill: "#DEF9FF"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M550.739 46.3168C549.986 46.3168 549.331 46.7758 548.939 47.4805C548.431 45.5465 546.925 44.1533 545.141 44.1533C542.948 44.1533 541.164 46.2677 541.164 48.8901H552.9C552.883 47.4641 551.934 46.3168 550.739 46.3168Z",
    fill: "#DEF9FF"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.02 52.168C496.904 52.168 497.64 52.8727 497.64 53.725H494.416C494.416 52.8564 495.136 52.168 496.02 52.168Z",
    fill: "#DEF9FF"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.478 379.177H535.474C536.479 379.177 537.283 378.372 537.283 377.365V364.161H108.629V377.365C108.629 378.372 109.473 379.177 110.478 379.177Z",
    fill: "#8DB818"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M208.688 374.185H305.088C305.45 374.185 305.772 373.863 305.772 373.501V370.925C305.772 370.562 305.45 370.24 305.088 370.24H208.688C208.326 370.24 208.005 370.562 208.005 370.925V373.501C208.005 373.904 208.286 374.185 208.688 374.185Z",
    fill: "#AFD435"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M203.18 374.185H179.984C179.622 374.185 179.301 373.863 179.301 373.501V370.925C179.301 370.562 179.622 370.24 179.984 370.24H203.18C203.541 370.24 203.863 370.562 203.863 370.925V373.501C203.863 373.904 203.541 374.185 203.18 374.185Z",
    fill: "#AFD435"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M315.258 370.24H330.333C331.057 370.24 331.619 369.676 331.619 368.952V364.161H537.283V372.937C537.283 373.621 536.721 374.185 536.037 374.185H401.447H396.985H315.258C314.575 374.185 314.012 373.621 314.012 372.937V371.488C314.012 370.803 314.575 370.24 315.258 370.24Z",
    fill: "#AFD435"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M536.599 368.106H463.193C462.831 368.106 462.51 367.784 462.51 367.422V364.161H537.322V367.422C537.282 367.824 537.001 368.106 536.599 368.106Z",
    fill: "#E8F090"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M456.923 368.106H357.749C357.387 368.106 357.065 367.784 357.065 367.422V364.161H457.606V367.422C457.606 367.824 457.325 368.106 456.923 368.106Z",
    fill: "#E8F090"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M384.923 384.893H383.958C382.149 384.893 380.702 386.342 380.702 388.153C380.702 389.965 382.149 391.414 383.958 391.414H384.923C386.732 391.414 388.179 389.965 388.179 388.153C388.179 386.342 386.732 384.893 384.923 384.893Z",
    fill: "#3E3935"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M403.134 384.893H402.169C400.36 384.893 398.913 386.342 398.913 388.153C398.913 389.965 400.36 391.414 402.169 391.414H403.134C404.943 391.414 406.39 389.965 406.39 388.153C406.39 386.342 404.943 384.893 403.134 384.893Z",
    fill: "#3E3935"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M408.721 383.081L402.45 381.592L398.43 373.259H381.304L377.968 381.592V388.637L380.541 389.643H407.635L408.721 387.791V383.081Z",
    fill: "#008AAF"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M406.912 383.081L400.681 381.592L396.621 373.259H381.304L377.968 381.592V388.637L380.541 389.643H405.867L406.912 387.791V383.081Z",
    fill: "#11AACE"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M408.721 383.081L402.45 381.592H377.968V383.081H408.721Z",
    fill: "white"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M396.099 374.185H383.436L380.863 381.592H399.677L396.099 374.185Z",
    fill: "#043954"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M395.536 374.908H385.165L382.793 381.591H398.833L395.536 374.908Z",
    fill: "#015475"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M408.721 386.986H377.968V387.791H408.721V386.986Z",
    fill: "white"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M383.958 391.414C385.757 391.414 387.215 389.954 387.215 388.153C387.215 386.352 385.757 384.893 383.958 384.893C382.16 384.893 380.702 386.352 380.702 388.153C380.702 389.954 382.16 391.414 383.958 391.414Z",
    fill: "#3E3935"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M386.25 388.154C386.25 389.402 385.245 390.449 383.958 390.449C382.672 390.449 381.667 389.442 381.667 388.154C381.667 386.866 382.672 385.859 383.958 385.859C385.245 385.859 386.25 386.866 386.25 388.154Z",
    fill: "#B2B2B2"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M385.807 388.153C385.807 389.16 385.003 389.965 383.998 389.965C382.993 389.965 382.189 389.16 382.189 388.153C382.189 387.147 382.993 386.342 383.998 386.342C385.003 386.342 385.807 387.147 385.807 388.153Z",
    fill: "#EDEDED"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M402.169 391.414C403.968 391.414 405.426 389.954 405.426 388.153C405.426 386.352 403.968 384.893 402.169 384.893C400.371 384.893 398.913 386.352 398.913 388.153C398.913 389.954 400.371 391.414 402.169 391.414Z",
    fill: "#3E3935"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M404.461 388.153C404.461 389.401 403.456 390.448 402.169 390.448C400.883 390.448 399.878 389.441 399.878 388.153C399.878 386.865 400.883 385.858 402.169 385.858C403.456 385.858 404.461 386.865 404.461 388.153Z",
    fill: "#B2B2B2"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M404.018 388.152C404.018 389.159 403.214 389.964 402.209 389.964C401.204 389.964 400.4 389.159 400.4 388.152C400.4 387.146 401.204 386.341 402.209 386.341C403.214 386.341 404.018 387.146 404.018 388.152Z",
    fill: "#EDEDED"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M406.914 386.985H408.723L408.281 383.886H406.914V386.985Z",
    fill: "#EDEDED"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M377.973 387H379.26V383.9H377.973V387Z",
    fill: "#E54545"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M400.682 381.592H402.451L398.873 374.185H397.104L400.682 381.592Z",
    fill: "#043954"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M396.696 381.572H399.711V379.157H396.696V381.572Z",
    fill: "#008AAF"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M396.66 379.176H395.896V381.591H396.66V379.176Z",
    fill: "#11AACE"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M406.949 387.803H408.718V386.998H406.949V387.803Z",
    fill: "#11AACE"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M405.386 391.414H372.382C372.261 391.414 372.181 391.494 372.181 391.615V392.299C372.181 392.42 372.261 392.501 372.382 392.501H405.386C405.507 392.501 405.587 392.42 405.587 392.299V391.615C405.587 391.494 405.507 391.414 405.386 391.414Z",
    fill: "url(#paint186_linear_1010_30625)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M384.44 374.185H387.254L389.867 381.592H387.094L384.44 374.185Z",
    fill: "url(#paint187_linear_1010_30625)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M397.104 374.185L396.621 373.259H381.305L380.943 374.185H397.104Z",
    fill: "white"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M485.987 389.118H486.951C488.76 389.118 490.208 390.567 490.208 392.379C490.208 394.19 488.76 395.64 486.951 395.64H485.987C484.178 395.64 482.73 394.19 482.73 392.379C482.73 390.608 484.218 389.118 485.987 389.118Z",
    fill: "#3E3935"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M467.817 389.118H468.781C470.59 389.118 472.038 390.567 472.038 392.379C472.038 394.19 470.59 395.64 468.781 395.64H467.817C466.008 395.64 464.56 394.19 464.56 392.379C464.52 390.608 466.008 389.118 467.817 389.118Z",
    fill: "#3E3935"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M462.229 387.347L468.5 385.857L472.52 377.524H489.645L492.982 385.857V392.862L490.409 393.868H463.314L462.229 392.057V387.347Z",
    fill: "#878787"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M464.037 387.347L470.268 385.857L474.288 377.524H489.645L492.981 385.857V392.862L490.408 393.868H465.082L464.037 392.057V387.347Z",
    fill: "#C6C6C6"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M462.229 387.347L468.5 385.857H492.982V387.347H462.229Z",
    fill: "white"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M474.85 378.45H487.513L490.086 385.858H471.232L474.85 378.45Z",
    fill: "#043954"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M475.414 379.176H485.785L488.157 385.858H472.117L475.414 379.176Z",
    fill: "#015475"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M492.982 391.252H462.229V392.057H492.982V391.252Z",
    fill: "white"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M487.693 395.518C489.443 395.104 490.527 393.348 490.114 391.596C489.7 389.843 487.946 388.758 486.196 389.172C484.446 389.585 483.362 391.342 483.776 393.094C484.189 394.847 485.943 395.932 487.693 395.518Z",
    fill: "#3E3935"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M484.698 392.379C484.698 393.626 485.703 394.673 486.99 394.673C488.276 394.673 489.281 393.667 489.281 392.379C489.281 391.131 488.276 390.084 486.99 390.084C485.703 390.084 484.698 391.131 484.698 392.379Z",
    fill: "#B2B2B2"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M485.143 392.378C485.143 393.384 485.947 394.189 486.952 394.189C487.957 394.189 488.761 393.384 488.761 392.378C488.761 391.372 487.957 390.566 486.952 390.566C485.947 390.566 485.143 391.372 485.143 392.378Z",
    fill: "#F6F6F6"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M469.522 395.51C471.272 395.097 472.356 393.34 471.943 391.588C471.529 389.835 469.776 388.75 468.025 389.164C466.275 389.578 465.191 391.334 465.605 393.086C466.018 394.839 467.772 395.924 469.522 395.51Z",
    fill: "#3E3935"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M466.489 392.379C466.489 393.626 467.494 394.673 468.781 394.673C470.067 394.673 471.072 393.667 471.072 392.379C471.072 391.131 470.067 390.084 468.781 390.084C467.494 390.084 466.489 391.131 466.489 392.379Z",
    fill: "#B2B2B2"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M466.932 392.378C466.932 393.384 467.736 394.189 468.741 394.189C469.746 394.189 470.55 393.384 470.55 392.378C470.55 391.372 469.746 390.566 468.741 390.566C467.736 390.566 466.932 391.372 466.932 392.378Z",
    fill: "#F6F6F6"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M464.038 391.251H462.229L462.671 388.151H464.038V391.251Z",
    fill: "#EDEDED"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M492.983 388.151H491.696V391.251H492.983V388.151Z",
    fill: "#E54545"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M470.268 385.858H468.499L472.077 378.45H473.846L470.268 385.858Z",
    fill: "#043954"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M474.247 383.402H471.232V385.818H474.247V383.402Z",
    fill: "#878787"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M474.244 385.85H475.008V383.434H474.244V385.85Z",
    fill: "#C6C6C6"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M463.997 391.252H462.229V392.057H463.997V391.252Z",
    fill: "#C6C6C6"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M465.565 395.68H498.57C498.69 395.68 498.771 395.76 498.771 395.881V396.565C498.771 396.686 498.69 396.767 498.57 396.767H465.565C465.445 396.767 465.364 396.686 465.364 396.565V395.881C465.324 395.76 465.445 395.68 465.565 395.68Z",
    fill: "url(#paint188_linear_1010_30625)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M481.444 378.45H484.902L487.515 385.857H484.057L481.444 378.45Z",
    fill: "url(#paint189_linear_1010_30625)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M478.99 378.45H480.719L483.372 385.857H481.643L478.99 378.45Z",
    fill: "url(#paint190_linear_1010_30625)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M490.007 378.45L489.645 377.524H474.289L473.847 378.45H490.007Z",
    fill: "white"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M266.132 389.118H267.097C268.906 389.118 270.353 390.567 270.353 392.379C270.353 394.19 268.906 395.64 267.097 395.64H266.132C264.323 395.64 262.876 394.19 262.876 392.379C262.836 390.608 264.323 389.118 266.132 389.118Z",
    fill: "#3E3935"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M247.921 389.118H248.886C250.695 389.118 252.142 390.567 252.142 392.379C252.142 394.19 250.695 395.64 248.886 395.64H247.921C246.112 395.64 244.665 394.19 244.665 392.379C244.665 390.608 246.112 389.118 247.921 389.118Z",
    fill: "#3E3935"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M242.334 387.347L248.605 385.857L252.625 377.524H269.75L273.087 385.857V392.862L270.514 393.868H243.419L242.334 392.057V387.347Z",
    fill: "#878787"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M244.143 387.347L250.374 385.857L254.434 377.524H269.75L273.087 385.857V392.862L270.514 393.868H245.188L244.143 392.057V387.347Z",
    fill: "#C6C6C6"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M242.334 387.347L248.605 385.857H273.087V387.347H242.334Z",
    fill: "white"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M254.956 378.45H267.619L270.192 385.857H251.338L254.956 378.45Z",
    fill: "#043954"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M255.519 379.176H265.891L268.263 385.858H252.223L255.519 379.176Z",
    fill: "#015475"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M273.087 391.252H242.334V392.057H273.087V391.252Z",
    fill: "white"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M267.846 395.526C269.597 395.114 270.682 393.358 270.27 391.605C269.859 389.852 268.106 388.766 266.355 389.178C264.605 389.59 263.519 391.346 263.931 393.099C264.343 394.852 266.096 395.939 267.846 395.526Z",
    fill: "#3E3935"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M264.806 392.379C264.806 393.626 265.811 394.673 267.097 394.673C268.343 394.673 269.388 393.667 269.388 392.379C269.388 391.131 268.383 390.084 267.097 390.084C265.811 390.124 264.806 391.131 264.806 392.379Z",
    fill: "#B2B2B2"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M265.248 392.378C265.248 393.384 266.052 394.189 267.057 394.189C268.062 394.189 268.866 393.384 268.866 392.378C268.866 391.372 268.062 390.566 267.057 390.566C266.052 390.566 265.248 391.372 265.248 392.378Z",
    fill: "#F6F6F6"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M249.638 395.527C251.388 395.115 252.473 393.359 252.061 391.606C251.65 389.853 249.897 388.767 248.146 389.179C246.396 389.591 245.31 391.347 245.722 393.1C246.134 394.853 247.887 395.939 249.638 395.527Z",
    fill: "#3E3935"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M246.594 392.379C246.594 393.626 247.599 394.673 248.885 394.673C250.172 394.673 251.177 393.667 251.177 392.379C251.177 391.131 250.172 390.084 248.885 390.084C247.599 390.084 246.594 391.131 246.594 392.379Z",
    fill: "#B2B2B2"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M247.037 392.378C247.037 393.384 247.841 394.189 248.846 394.189C249.851 394.189 250.655 393.384 250.655 392.378C250.655 391.372 249.851 390.566 248.846 390.566C247.841 390.566 247.037 391.372 247.037 392.378Z",
    fill: "#F6F6F6"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M244.143 391.251H242.334L242.776 388.151H244.143V391.251Z",
    fill: "#EDEDED"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M273.086 388.151H271.8V391.251H273.086V388.151Z",
    fill: "#E54545"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M250.373 385.857H248.604L252.182 378.45H253.951L250.373 385.857Z",
    fill: "#043954"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M254.353 383.402H251.338V385.818H254.353V383.402Z",
    fill: "#878787"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M254.354 385.85H255.118V383.434H254.354V385.85Z",
    fill: "#C6C6C6"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M244.103 391.252H242.334V392.057H244.103V391.252Z",
    fill: "#C6C6C6"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M245.671 395.68H278.675C278.796 395.68 278.876 395.76 278.876 395.881V396.565C278.876 396.686 278.796 396.767 278.675 396.767H245.671C245.55 396.767 245.47 396.686 245.47 396.565V395.881C245.43 395.76 245.55 395.68 245.671 395.68Z",
    fill: "url(#paint191_linear_1010_30625)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M261.55 378.45H265.007L267.62 385.857H264.163L261.55 378.45Z",
    fill: "url(#paint192_linear_1010_30625)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M259.096 378.45H260.824L263.478 385.857H261.749L259.096 378.45Z",
    fill: "url(#paint193_linear_1010_30625)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M270.113 378.45L269.751 377.524H254.435L253.952 378.45H270.113Z",
    fill: "white"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M150.797 384.893H149.832C148.023 384.893 146.576 386.342 146.576 388.154C146.576 389.965 148.023 391.414 149.832 391.414H150.797C152.606 391.414 154.053 389.965 154.053 388.154C154.053 386.342 152.606 384.893 150.797 384.893Z",
    fill: "#3E3935"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M169.01 384.893H168.045C166.236 384.893 164.789 386.342 164.789 388.153C164.789 389.965 166.236 391.414 168.045 391.414H169.01C170.819 391.414 172.266 389.965 172.266 388.153C172.266 386.342 170.779 384.893 169.01 384.893Z",
    fill: "#3E3935"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M174.556 383.081L168.285 381.592L164.265 373.259H147.18L143.803 381.592V388.637L146.376 389.643H173.47L174.556 387.791V383.081Z",
    fill: "#006C88"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M172.787 383.081L166.516 381.592L162.496 373.259H147.18L143.803 381.592V388.637L146.376 389.643H171.702L172.787 387.791V383.081Z",
    fill: "#008AAF"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M174.556 383.082L168.285 381.592H143.803V383.082H174.556Z",
    fill: "white"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M161.933 374.185H149.31L146.697 381.592H165.551L161.933 374.185Z",
    fill: "#043954"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M161.412 374.948H151L148.628 381.59H164.708L161.412 374.948Z",
    fill: "#015475"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M174.556 386.986H143.803V387.791H174.556V386.986Z",
    fill: "white"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M149.832 391.414C151.631 391.414 153.089 389.954 153.089 388.154C153.089 386.353 151.631 384.893 149.832 384.893C148.034 384.893 146.576 386.353 146.576 388.154C146.576 389.954 148.034 391.414 149.832 391.414Z",
    fill: "#3E3935"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M152.126 388.154C152.126 389.402 151.121 390.449 149.834 390.449C148.588 390.449 147.543 389.442 147.543 388.154C147.543 386.866 148.548 385.86 149.834 385.86C151.081 385.86 152.126 386.866 152.126 388.154Z",
    fill: "#B2B2B2"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M151.643 388.153C151.643 389.159 150.839 389.965 149.834 389.965C148.829 389.965 148.025 389.159 148.025 388.153C148.025 387.147 148.829 386.341 149.834 386.341C150.839 386.301 151.643 387.147 151.643 388.153Z",
    fill: "#EDEDED"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M168.044 391.414C169.843 391.414 171.301 389.954 171.301 388.153C171.301 386.352 169.843 384.893 168.044 384.893C166.246 384.893 164.788 386.352 164.788 388.153C164.788 389.954 166.246 391.414 168.044 391.414Z",
    fill: "#3E3935"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M170.296 388.153C170.296 389.401 169.291 390.448 168.004 390.448C166.718 390.448 165.713 389.441 165.713 388.153C165.713 386.865 166.718 385.858 168.004 385.858C169.291 385.858 170.296 386.865 170.296 388.153Z",
    fill: "#B2B2B2"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M169.854 388.152C169.854 389.159 169.05 389.964 168.045 389.964C167.04 389.964 166.236 389.159 166.236 388.152C166.236 387.146 167.04 386.341 168.045 386.341C169.05 386.341 169.854 387.146 169.854 388.152Z",
    fill: "#EDEDED"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M172.788 386.986H174.557L174.155 383.887H172.788V386.986Z",
    fill: "#EDEDED"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M143.839 387H145.125V383.9H143.839V387Z",
    fill: "#E54545"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M166.517 381.592H168.286L164.708 374.185H162.939L166.517 381.592Z",
    fill: "#043954"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M162.519 381.572H165.534V379.157H162.519V381.572Z",
    fill: "#006C88"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M162.536 379.177H161.772V381.592H162.536V379.177Z",
    fill: "#008AAF"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M172.775 387.803H174.544V386.998H172.775V387.803Z",
    fill: "#008AAF"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M171.26 391.414H138.256C138.135 391.414 138.055 391.494 138.055 391.615V392.299C138.055 392.42 138.135 392.501 138.256 392.501H171.26C171.381 392.501 171.461 392.42 171.461 392.299V391.615C171.461 391.494 171.34 391.414 171.26 391.414Z",
    fill: "url(#paint194_linear_1010_30625)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M150.396 374.185H153.17L155.783 381.592H153.009L150.396 374.185Z",
    fill: "url(#paint195_linear_1010_30625)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M153.652 374.185H154.979L157.632 381.592H156.306L153.652 374.185Z",
    fill: "url(#paint196_linear_1010_30625)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M162.94 374.185L162.498 373.259H147.181L146.779 374.185H162.94Z",
    fill: "white"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M349.026 389.12H349.991C351.8 389.12 353.247 390.569 353.247 392.381C353.247 394.192 351.8 395.642 349.991 395.642H349.026C347.217 395.642 345.77 394.192 345.77 392.381C345.77 390.61 347.217 389.12 349.026 389.12Z",
    fill: "#3E3935"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M326.596 389.12H327.561C329.37 389.12 330.817 390.569 330.817 392.381C330.817 394.192 329.37 395.642 327.561 395.642H326.596C324.787 395.642 323.34 394.192 323.34 392.381C323.34 390.61 324.787 389.12 326.596 389.12Z",
    fill: "#3E3935"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M321.047 387.349L327.318 385.86L331.338 377.486H353.77L355.981 385.86V392.864L354.011 393.871H322.132L321.047 392.059V387.349Z",
    fill: "#006C88"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M322.815 387.349L329.087 385.86L333.107 377.486H353.77L355.981 385.86V392.864L354.011 393.871H323.901L322.815 392.059V387.349Z",
    fill: "#008AAF"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M321.047 387.349L327.318 385.859H355.981V387.349H321.047Z",
    fill: "white"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M333.671 378.452H352.243L354.012 385.859H330.053L333.671 378.452Z",
    fill: "#043954"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M334.192 379.178H350.955L352.322 385.86H330.896L334.192 379.178Z",
    fill: "#015475"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M355.981 391.254H321.047V392.059H355.981V391.254Z",
    fill: "white"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M350.738 395.527C352.489 395.115 353.574 393.359 353.162 391.606C352.75 389.853 350.997 388.767 349.247 389.179C347.496 389.591 346.411 391.347 346.823 393.1C347.235 394.853 348.988 395.939 350.738 395.527Z",
    fill: "#3E3935"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M347.7 392.381C347.7 393.629 348.705 394.676 349.992 394.676C351.278 394.676 352.283 393.67 352.283 392.381C352.283 391.134 351.278 390.087 349.992 390.087C348.705 390.087 347.7 391.134 347.7 392.381Z",
    fill: "#B2B2B2"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M348.141 392.382C348.141 393.388 348.945 394.193 349.95 394.193C350.955 394.193 351.759 393.388 351.759 392.382C351.759 391.375 350.955 390.57 349.95 390.57C348.945 390.57 348.141 391.375 348.141 392.382Z",
    fill: "#EDEDED"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M329.846 394.696C331.118 393.423 331.117 391.358 329.846 390.085C328.574 388.812 326.513 388.812 325.241 390.085C323.969 391.358 323.969 393.423 325.241 394.696C326.513 395.97 328.574 395.97 329.846 394.696Z",
    fill: "#3E3935"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M325.269 392.382C325.269 393.63 326.274 394.676 327.56 394.676C328.846 394.676 329.851 393.67 329.851 392.382C329.851 391.134 328.846 390.087 327.56 390.087C326.274 390.087 325.269 391.134 325.269 392.382Z",
    fill: "#B2B2B2"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M325.751 392.381C325.751 393.387 326.555 394.192 327.56 394.192C328.565 394.192 329.369 393.387 329.369 392.381C329.369 391.374 328.565 390.569 327.56 390.569C326.555 390.569 325.751 391.374 325.751 392.381Z",
    fill: "#EDEDED"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M322.816 391.254H321.047L321.449 388.154H322.816V391.254Z",
    fill: "#EDEDED"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M355.981 388.154H354.694V391.254H355.981V388.154Z",
    fill: "#E54545"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M329.086 385.859H327.317L330.855 378.452H332.624L329.086 385.859Z",
    fill: "#043954"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M333.068 383.404H330.053V385.82H333.068V383.404Z",
    fill: "#006C88"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M333.067 385.852H333.831V383.436H333.067V385.852Z",
    fill: "#008AAF"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M322.816 391.254H321.047V392.059H322.816V391.254Z",
    fill: "#008AAF"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M324.343 395.682H357.347C357.468 395.682 357.548 395.762 357.548 395.883V396.567C357.548 396.688 357.468 396.769 357.347 396.769H324.343C324.222 396.769 324.142 396.688 324.142 396.567V395.883C324.142 395.762 324.222 395.682 324.343 395.682Z",
    fill: "url(#paint197_linear_1010_30625)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M340.302 378.452H339.418V385.819H340.302V378.452Z",
    fill: "#008AAF"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M345.409 378.452H348.826L351.479 385.859H348.022L345.409 378.452Z",
    fill: "url(#paint198_linear_1010_30625)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M354.052 378.452L353.77 377.486H333.107L332.625 378.452H354.052Z",
    fill: "white"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M497.605 335.74C502.55 335.74 506.57 339.766 506.57 344.717C506.57 349.669 502.55 353.694 497.605 353.694C492.661 353.694 488.641 349.669 488.641 344.717C488.681 339.766 492.661 335.74 497.605 335.74Z",
    fill: "#71891A"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.57 336.183C502.47 336.183 505.605 339.323 505.605 343.227C505.605 347.132 502.47 350.272 498.57 350.272C494.671 350.272 491.535 347.132 491.535 343.227C491.535 339.323 494.671 336.183 498.57 336.183Z",
    fill: "url(#paint199_radial_1010_30625)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.374 337.431C501.465 337.713 502.992 339.122 502.791 340.611C502.59 342.101 500.741 343.067 498.651 342.785C496.56 342.503 495.033 341.094 495.234 339.605C495.435 338.156 497.284 337.149 499.374 337.431Z",
    fill: "url(#paint200_radial_1010_30625)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M498.127 344.436V349.307L500.86 346.972L501.142 347.334L498.127 350.313V364.161H497.202L497.484 344.194L498.127 344.436Z",
    fill: "#4F372A"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.345 332.076C475.174 332.076 479.877 336.786 479.877 342.623C479.877 348.46 475.174 353.17 469.345 353.17C463.516 353.17 458.812 348.46 458.812 342.623C458.853 336.786 463.556 332.076 469.345 332.076Z",
    fill: "#698018"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.471 332.601C475.054 332.601 478.752 336.304 478.752 340.893C478.752 345.483 475.054 349.186 470.471 349.186C465.888 349.186 462.189 345.483 462.189 340.893C462.189 336.304 465.928 332.601 470.471 332.601Z",
    fill: "url(#paint201_radial_1010_30625)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.437 334.088C473.889 334.41 475.698 336.101 475.457 337.832C475.215 339.563 473.045 340.73 470.592 340.368C468.14 340.046 466.331 338.355 466.572 336.624C466.814 334.893 468.984 333.766 471.437 334.088Z",
    fill: "url(#paint202_radial_1010_30625)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M468.983 343.911V348.822L466.289 346.488L465.968 346.85L468.983 349.789V364.16H469.988L469.626 343.71L468.983 343.911Z",
    fill: "#4F372A"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.335 112.651C351.335 104.076 344.421 97.1523 335.858 97.1523C327.295 97.1523 320.381 104.076 320.381 112.651C320.381 120.863 326.773 127.586 334.853 128.109V291.871H336.903V128.109C344.943 127.586 351.335 120.863 351.335 112.651Z",
    fill: "url(#paint203_linear_1010_30625)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.947 76.9732C244.947 68.3986 238.033 61.4746 229.47 61.4746C220.908 61.4746 213.993 68.3986 213.993 76.9732C213.993 85.1854 220.385 91.9082 228.465 92.4315V364.2H230.515V92.4315C238.555 91.8679 244.947 85.1854 244.947 76.9732Z",
    fill: "url(#paint204_linear_1010_30625)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.193 76.9732C294.193 68.3986 287.279 61.4746 278.716 61.4746C270.154 61.4746 263.239 68.3986 263.239 76.9732C263.239 85.1854 269.631 91.9082 277.711 92.4315V364.2H279.762V92.4315C287.802 91.8679 294.193 85.1854 294.193 76.9732Z",
    fill: "url(#paint205_linear_1010_30625)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.642 135.828C472.642 127.253 465.727 120.329 457.165 120.329C448.602 120.329 441.688 127.253 441.688 135.828C441.688 144.04 448.079 150.763 456.16 151.286V364.16H458.21V151.286C466.25 150.763 472.642 144.08 472.642 135.828Z",
    fill: "url(#paint206_linear_1010_30625)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.405 76.9732C441.405 68.3986 434.491 61.4746 425.928 61.4746C417.366 61.4746 410.451 68.3986 410.451 76.9732C410.451 85.1854 416.843 91.9082 424.923 92.4315V364.2H426.973V92.4315C435.054 91.8679 441.405 85.1854 441.405 76.9732Z",
    fill: "url(#paint207_linear_1010_30625)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.716 67.3525C283.058 67.3525 286.555 70.8548 286.555 75.2025C286.555 77.175 285.832 78.9865 284.585 80.3955L279.359 86.3534C278.998 86.7559 278.395 86.7559 278.033 86.3534L272.807 80.3955C271.601 79.0268 270.837 77.2153 270.837 75.2025C270.877 70.8548 274.415 67.3525 278.716 67.3525ZM278.716 70.2107C281.49 70.2107 283.701 72.4651 283.701 75.2427C283.661 77.8996 281.45 80.1137 278.797 80.154C276.023 80.1942 273.772 77.9399 273.772 75.1622C273.772 72.4248 275.983 70.2107 278.716 70.2107Z",
    fill: "#15C4D1"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M460.057 129.225L459.696 127.374C459.655 127.213 459.535 127.092 459.414 127.092H457.163H454.912C454.791 127.092 454.671 127.213 454.63 127.374L454.269 129.225H457.163H460.057Z",
    fill: "#15C4D1"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M464.4 135.264L463.354 130.836C463.274 130.473 462.912 130.191 462.591 130.191H457.123H451.656C451.294 130.191 450.973 130.473 450.892 130.836L449.847 135.264C449.244 135.264 448.762 135.747 448.762 136.351V140.457C448.762 140.658 448.923 140.859 449.164 140.859H449.887V143.476C449.887 143.717 450.088 143.919 450.33 143.919H452.299C452.541 143.919 452.742 143.717 452.742 143.476V140.859H457.164H461.586V143.476C461.586 143.717 461.787 143.919 462.028 143.919H463.998C464.239 143.919 464.44 143.717 464.44 143.476V140.859H465.163C465.364 140.859 465.565 140.698 465.565 140.457V136.351C465.525 135.787 465.003 135.264 464.4 135.264ZM453.505 138.404C453.505 138.645 453.304 138.806 453.103 138.806H450.289C450.048 138.806 449.887 138.605 449.887 138.404V137.196C449.887 136.954 450.088 136.793 450.289 136.793H453.103C453.345 136.793 453.505 136.995 453.505 137.196V138.404ZM451.254 135.264L452.098 131.56H457.123H462.148L462.993 135.264H457.123H451.254ZM464.4 138.404C464.4 138.645 464.199 138.806 463.998 138.806H461.184C460.942 138.806 460.782 138.605 460.782 138.404V137.196C460.782 136.954 460.983 136.793 461.184 136.793H463.998C464.239 136.793 464.4 136.995 464.4 137.196V138.404Z",
    fill: "#15C4D1"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M344.943 107.297C343.294 106.653 338.43 105.123 334.209 107.498C329.224 110.356 327.174 115.549 326.611 117.482C326.491 117.884 326.732 118.327 327.134 118.407C328.782 118.85 333.405 119.213 337.304 117.522C340.48 116.153 342.45 112.812 343.174 111.282C343.937 109.632 344.701 108.504 345.144 107.981C345.304 107.78 345.224 107.418 344.943 107.297ZM333.646 112.329C329.184 114.865 326.933 117.321 326.933 117.321C326.933 117.321 328.702 114.221 333.003 111.644C336.943 109.269 341.606 108.706 341.606 108.706C341.606 108.706 337.626 110.034 333.646 112.329Z",
    fill: "#15C4D1"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M229.471 68.6807C229.471 68.6807 222.275 69.204 222.275 71.9414C222.275 84.7831 229.471 86.2323 229.471 86.2323C229.471 86.2323 236.667 84.7831 236.667 71.9414C236.667 69.204 229.471 68.6807 229.471 68.6807ZM234.094 73.5114L230.195 81.1198C230.155 81.2003 230.074 81.3211 229.994 81.3613C229.833 81.4821 229.632 81.5626 229.431 81.5626C229.19 81.5626 228.949 81.4821 228.788 81.2808L225.451 77.4162C225.17 77.0539 225.29 76.6111 225.652 76.3293C226.014 76.0475 226.416 75.967 226.697 76.3293L229.19 79.268L232.526 72.7465C232.727 72.344 233.21 72.2635 233.612 72.4647C234.134 72.666 234.335 73.1088 234.094 73.5114Z",
    fill: "#15C4D1"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.141 135.868C179.141 127.293 172.226 120.369 163.664 120.369C155.101 120.369 148.187 127.293 148.187 135.868C148.187 144.08 154.578 150.803 162.659 151.326V364.2H164.709V151.326C172.749 150.803 179.141 144.08 179.141 135.868Z",
    fill: "url(#paint208_linear_1010_30625)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M171.544 127.213C171.423 126.891 171.101 126.649 170.74 126.649C170.579 126.649 170.458 126.69 170.338 126.77L168.77 127.897L168.73 127.938C168.448 128.139 168.207 128.38 168.046 128.622C167.926 128.783 167.845 128.944 167.765 129.105L155.906 130.111C155.504 130.152 155.222 130.554 155.303 130.997L156.187 135.224C156.268 135.707 156.509 136.069 156.83 136.391C157.152 136.713 157.554 136.874 158.036 136.915L166.076 137.841L166.478 138.565C166.84 139.129 167.041 139.572 167.202 140.055C167.282 140.336 167.363 140.659 167.403 141.061H159.363C158.881 141.061 158.479 141.262 158.157 141.584C158.036 141.705 157.876 142.027 157.876 142.027C157.755 142.269 157.715 142.551 157.755 142.832C157.795 143.275 157.996 143.718 158.358 144.04L158.398 144.08C158.76 144.402 159.202 144.604 159.685 144.604C160.167 144.604 160.569 144.402 160.891 144.08C161.212 143.758 161.333 143.315 161.293 142.832C161.293 142.752 161.293 142.712 161.252 142.631H166.559C166.559 142.712 166.559 142.752 166.559 142.832C166.599 143.315 166.8 143.758 167.162 144.08H167.202C167.564 144.402 168.006 144.604 168.488 144.604C168.931 144.604 169.373 144.443 169.654 144.121L169.694 144.08L169.775 144.04V144C170.056 143.678 170.177 143.275 170.137 142.832C170.096 142.39 169.895 141.987 169.574 141.665L169.453 141.544C169.333 141.423 169.172 141.343 169.011 141.262C168.931 140.659 168.85 140.175 168.689 139.733C168.488 139.129 168.207 138.605 167.805 137.921L167.323 137.116L167.725 135.465C167.765 135.425 167.765 135.345 167.765 135.304L168.247 133.453C168.287 133.412 168.287 133.332 168.287 133.292L168.649 131.842C168.689 131.802 168.689 131.722 168.689 131.681L169.051 130.192V130.152C169.091 129.95 169.172 129.789 169.252 129.669C169.333 129.548 169.453 129.427 169.614 129.306L171.222 128.179C171.584 127.897 171.704 127.575 171.544 127.213ZM163.021 131.078L163.102 135.949L161.453 135.747L160.77 131.279L163.021 131.078ZM157.835 135.264C157.795 135.224 157.755 135.143 157.715 135.023L156.991 131.601L159.242 131.4L159.845 135.546L158.036 135.345C157.996 135.385 157.916 135.345 157.835 135.264ZM165.916 136.271L164.549 136.11L164.468 130.957L167.282 130.715L165.916 136.271Z",
    fill: "#15C4D1"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.595 184.941C511.595 176.366 504.68 169.442 496.118 169.442C487.555 169.442 480.641 176.366 480.641 184.941C480.641 193.153 487.032 199.876 495.113 200.399V364.161H497.163V200.399C505.203 199.876 511.595 193.153 511.595 184.941Z",
    fill: "url(#paint209_linear_1010_30625)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M504.24 179.707H499.697V177.533C499.697 176.889 499.174 176.406 498.571 176.406H493.747C493.104 176.406 492.622 176.929 492.622 177.533V179.707H488.079C487.516 179.707 487.114 180.149 487.114 180.673V190.052C487.114 190.616 487.556 191.018 488.079 191.018H504.28C504.802 191.018 505.245 190.576 505.245 190.052V180.673C505.204 180.149 504.762 179.707 504.24 179.707ZM494.029 177.855H498.169V179.707H494.029V177.855ZM499.576 186.429C499.576 186.631 499.416 186.751 499.255 186.751H497.526V188.482C497.526 188.684 497.365 188.804 497.204 188.804H495.114C494.913 188.804 494.792 188.643 494.792 188.482V186.751H493.064C492.863 186.751 492.742 186.59 492.742 186.429V184.336C492.742 184.135 492.903 184.014 493.064 184.014H494.792V182.283C494.792 182.082 494.953 181.961 495.114 181.961H497.204C497.405 181.961 497.526 182.122 497.526 182.283V184.014H499.255C499.456 184.014 499.576 184.175 499.576 184.336V186.429Z",
    fill: "#15C4D1"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.522 186.071C135.522 177.496 128.608 170.572 120.045 170.572C111.483 170.572 104.568 177.496 104.568 186.071C104.568 194.283 110.96 201.006 119.04 201.529V365.291H121.091V201.529C129.131 201.006 135.522 194.283 135.522 186.071Z",
    fill: "url(#paint210_linear_1010_30625)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.013 243.918C579.013 235.344 572.098 228.42 563.536 228.42C554.973 228.42 548.059 235.344 548.059 243.918C548.059 252.131 554.45 258.853 562.531 259.377V273.563V287.75H564.581V259.377C572.621 258.853 579.013 252.131 579.013 243.918Z",
    fill: "url(#paint211_linear_1010_30625)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.557 15.4986C415.557 6.92403 408.642 0 400.08 0C391.517 0 384.603 6.92403 384.603 15.4986C384.603 23.7108 390.994 30.4336 399.075 30.9569V243.831H401.125V30.9569C409.165 30.4336 415.557 23.751 415.557 15.4986Z",
    fill: "url(#paint212_linear_1010_30625)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M407.034 148.954C406.552 149.719 405.788 150.725 405.788 151.692C405.788 152.376 406.351 152.939 407.034 152.939C407.718 152.939 408.28 152.376 408.28 151.692C408.28 150.725 407.517 149.719 407.034 148.954Z",
    fill: "#15C4D1"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M405.948 15.8608V18.2359H408.119V15.4582C408.119 14.2505 407.154 13.2844 405.948 13.2844H401.928V12.4793C401.928 12.0767 401.607 11.7144 401.164 11.7144H400.722V9.62109H403.054C403.536 9.62109 403.898 9.25878 403.898 8.77571V8.29264C403.898 7.80956 403.536 7.44726 403.054 7.44726H400.722V6.84342C400.722 6.60188 400.521 6.36035 400.24 6.36035H399.717C399.476 6.36035 399.235 6.56162 399.235 6.84342V7.44726H396.903C396.421 7.44726 396.059 7.80956 396.059 8.29264V8.77571C396.059 9.25878 396.421 9.62109 396.903 9.62109H399.235V11.7144H398.833C398.431 11.7144 398.069 12.0364 398.069 12.4793V13.2844H391.838V15.4582H398.069V16.2633C398.069 16.6659 398.391 17.0282 398.833 17.0282H401.164C401.566 17.0282 401.928 16.7062 401.928 16.2633V15.4582H405.586C405.787 15.4582 405.948 15.6595 405.948 15.8608Z",
    fill: "#15C4D1"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M120.045 176.57C114.819 176.57 110.558 180.837 110.558 186.071C110.558 191.304 114.819 195.571 120.045 195.571C125.271 195.571 129.532 191.304 129.532 186.071C129.532 180.837 125.271 176.57 120.045 176.57ZM120.045 194.202C115.583 194.202 111.965 190.579 111.965 186.111C111.965 181.643 115.583 178.02 120.045 178.02C124.507 178.02 128.125 181.643 128.125 186.111C128.165 190.539 124.507 194.202 120.045 194.202Z",
    fill: "#15C4D1"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M122.659 180.192H118.719L117.111 186.432H119.885L118.277 192.672L123.785 186.432H121.051L122.659 180.192Z",
    fill: "#15C4D1"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M563.535 234.418C558.309 234.418 554.048 238.685 554.048 243.918C554.048 249.152 558.309 253.419 563.535 253.419C568.761 253.419 573.022 249.152 573.022 243.918C573.022 238.685 568.761 234.418 563.535 234.418ZM563.535 252.05C559.073 252.05 555.455 248.427 555.455 243.959C555.455 239.49 559.073 235.867 563.535 235.867C567.997 235.867 571.615 239.49 571.615 243.959C571.656 248.387 567.997 252.05 563.535 252.05Z",
    fill: "#15C4D1"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M566.147 238.04H562.208L560.6 244.28H563.373L561.765 250.519L567.273 244.28H564.539L566.147 238.04Z",
    fill: "#15C4D1"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M424.401 75.4033C425.245 74.5579 426.652 74.5579 427.536 75.4033C428.38 76.2487 428.38 77.6577 427.536 78.5433C426.692 79.3887 425.285 79.3887 424.401 78.5433C423.516 77.6577 423.516 76.2487 424.401 75.4033Z",
    fill: "#15C4D1"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M426.452 70.8933C427.899 71.0141 429.225 71.6179 430.271 72.6646C431.316 73.7112 431.919 75.0397 432.039 76.4889C432.08 76.7707 431.838 76.972 431.557 76.972H430.954C430.713 76.972 430.512 76.7707 430.472 76.5292C430.351 75.4825 429.909 74.5164 429.185 73.7515C428.421 72.9866 427.457 72.5438 426.411 72.4633C426.17 72.423 425.969 72.262 425.969 71.9802V71.3764C425.929 71.0946 426.17 70.8933 426.452 70.8933Z",
    fill: "#15C4D1"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M434.733 76.9726C434.492 76.9726 434.291 76.7713 434.251 76.5298C434.13 74.4767 433.286 72.5444 431.839 71.0952C430.392 69.646 428.462 68.8006 426.412 68.6798C426.171 68.6798 425.97 68.4786 425.97 68.1968V67.5929C425.97 67.3111 426.211 67.1099 426.452 67.1099C428.904 67.2306 431.196 68.237 432.924 70.0083C434.653 71.7393 435.658 74.0339 435.819 76.4895C435.819 76.7713 435.618 76.9726 435.336 76.9726H434.733Z",
    fill: "#15C4D1"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M425.928 81.9642V82.568C425.928 82.8498 425.687 83.0511 425.446 83.0511C423.999 82.9303 422.672 82.3265 421.627 81.2798C420.582 80.2331 419.979 78.9047 419.858 77.4555C419.818 77.1737 420.059 76.9724 420.34 76.9724H420.943C421.185 76.9724 421.386 77.1737 421.426 77.4152C421.546 78.4619 421.989 79.428 422.712 80.1929C423.476 80.9578 424.441 81.4006 425.486 81.4811C425.767 81.5213 425.928 81.6824 425.928 81.9642Z",
    fill: "#15C4D1"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M417.165 76.9724C417.407 76.9724 417.608 77.1737 417.648 77.4152C417.768 79.4683 418.613 81.3603 420.06 82.8498C421.507 84.299 423.437 85.1444 425.487 85.2651C425.728 85.2651 425.929 85.4664 425.929 85.7482V86.3521C425.929 86.6339 425.688 86.8351 425.447 86.8351C422.994 86.7144 420.703 85.708 418.974 83.9367C417.246 82.2057 416.241 79.9111 416.08 77.4555C416.08 77.1737 416.281 76.9724 416.562 76.9724H417.165Z",
    fill: "#15C4D1"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M452.127 77.8306C451.845 77.8306 451.566 77.8066 451.29 77.7586C451.014 77.7136 450.756 77.6506 450.516 77.5696V76.9756C450.768 77.0566 451.032 77.1211 451.308 77.1691C451.584 77.2141 451.853 77.2366 452.114 77.2366C452.684 77.2366 453.108 77.1226 453.387 76.8946C453.669 76.6666 453.81 76.3276 453.81 75.8776C453.81 75.5866 453.74 75.3451 453.599 75.1531C453.461 74.9581 453.231 74.8066 452.91 74.6986C452.589 74.5906 452.153 74.5216 451.601 74.4916L450.764 74.4421L450.989 71.0851H454.238V71.6791H451.335L451.664 71.3821L451.475 74.1766L451.011 73.8616L451.848 73.9066C452.475 73.9456 452.985 74.0416 453.378 74.1946C453.771 74.3476 454.058 74.5621 454.238 74.8381C454.421 75.1141 454.512 75.4561 454.512 75.8641C454.512 76.5031 454.31 76.9906 453.905 77.3266C453.503 77.6626 452.91 77.8306 452.127 77.8306ZM458.663 77.8036C457.913 77.8036 457.285 77.6851 456.778 77.4481C456.271 77.2111 455.888 76.8451 455.63 76.3501C455.372 75.8521 455.243 75.2116 455.243 74.4286C455.243 73.6216 455.377 72.9661 455.644 72.4621C455.911 71.9581 456.289 71.5891 456.778 71.3551C457.267 71.1181 457.844 70.9996 458.51 70.9996C458.762 70.9996 459.011 71.0161 459.257 71.0491C459.506 71.0821 459.754 71.1316 460 71.1976V71.8321C459.73 71.7571 459.478 71.7061 459.244 71.6791C459.01 71.6491 458.779 71.6341 458.551 71.6341C458.023 71.6341 457.568 71.7241 457.187 71.9041C456.809 72.0841 456.518 72.3781 456.314 72.7861C456.11 73.1941 456.008 73.7416 456.008 74.4286C456.008 75.0796 456.106 75.6076 456.301 76.0126C456.496 76.4146 456.787 76.7086 457.174 76.8946C457.561 77.0806 458.042 77.1736 458.618 77.1736C458.834 77.1736 459.035 77.1646 459.221 77.1466C459.41 77.1286 459.586 77.1046 459.748 77.0746L459.46 77.3761V74.5051H460.153V77.6731C459.871 77.7181 459.613 77.7511 459.379 77.7721C459.145 77.7931 458.906 77.8036 458.663 77.8036ZM466.52 77.8306C466.061 77.8306 465.645 77.7706 465.273 77.6506C464.904 77.5276 464.588 77.3326 464.324 77.0656C464.06 76.7986 463.857 76.4476 463.716 76.0126C463.575 75.5776 463.505 75.0496 463.505 74.4286C463.505 73.6246 463.628 72.9706 463.874 72.4666C464.12 71.9626 464.472 71.5921 464.931 71.3551C465.393 71.1181 465.947 70.9996 466.592 70.9996C466.85 70.9996 467.096 71.0161 467.33 71.0491C467.567 71.0821 467.801 71.1301 468.032 71.1931V71.8321C467.798 71.7601 467.564 71.7091 467.33 71.6791C467.099 71.6491 466.862 71.6341 466.619 71.6341C466.115 71.6341 465.687 71.7241 465.336 71.9041C464.988 72.0811 464.724 72.3736 464.544 72.7816C464.364 73.1866 464.274 73.7296 464.274 74.4106C464.274 75.1126 464.366 75.6676 464.549 76.0756C464.732 76.4806 464.994 76.7686 465.336 76.9396C465.681 77.1106 466.094 77.1961 466.574 77.1961C466.82 77.1961 467.058 77.1766 467.289 77.1376C467.52 77.0986 467.768 77.0356 468.032 76.9486V77.5831C467.81 77.6611 467.571 77.7211 467.316 77.7631C467.064 77.8081 466.799 77.8306 466.52 77.8306ZM470.509 77.8306C470.089 77.8306 469.723 77.7436 469.411 77.5696C469.099 77.3926 468.857 77.1196 468.686 76.7506C468.515 76.3786 468.43 75.8971 468.43 75.3061C468.43 74.7211 468.514 74.2426 468.682 73.8706C468.853 73.4986 469.094 73.2256 469.406 73.0516C469.718 72.8746 470.086 72.7861 470.509 72.7861C470.932 72.7861 471.299 72.8746 471.611 73.0516C471.923 73.2256 472.163 73.4986 472.331 73.8706C472.502 74.2396 472.588 74.7181 472.588 75.3061C472.588 75.8911 472.501 76.3696 472.327 76.7416C472.156 77.1136 471.914 77.3881 471.602 77.5651C471.293 77.7421 470.929 77.8306 470.509 77.8306ZM470.509 77.2456C470.785 77.2456 471.023 77.1856 471.224 77.0656C471.425 76.9456 471.58 76.7461 471.688 76.4671C471.799 76.1851 471.854 75.8026 471.854 75.3196C471.854 74.8276 471.799 74.4406 471.688 74.1586C471.58 73.8736 471.424 73.6726 471.22 73.5556C471.019 73.4356 470.782 73.3756 470.509 73.3756C470.233 73.3756 469.994 73.4356 469.793 73.5556C469.592 73.6726 469.436 73.8721 469.325 74.1541C469.217 74.4331 469.163 74.8141 469.163 75.2971C469.163 75.7861 469.217 76.1731 469.325 76.4581C469.436 76.7401 469.592 76.9426 469.793 77.0656C469.994 77.1856 470.233 77.2456 470.509 77.2456ZM473.687 77.7451V72.8626H474.295L474.344 73.4116H474.394C474.592 73.2106 474.823 73.0561 475.087 72.9481C475.351 72.8401 475.631 72.7861 475.928 72.7861C476.234 72.7861 476.504 72.8431 476.738 72.9571C476.975 73.0681 477.16 73.2511 477.292 73.5061C477.427 73.7581 477.494 74.0956 477.494 74.5186V77.7451H476.779V74.5501C476.779 74.1301 476.686 73.8391 476.5 73.6771C476.317 73.5121 476.068 73.4296 475.753 73.4296C475.609 73.4296 475.456 73.4506 475.294 73.4926C475.132 73.5346 474.973 73.6036 474.817 73.6996C474.664 73.7956 474.527 73.9231 474.407 74.0821V77.7451H473.687ZM478.803 77.7451V72.8626H479.41L479.46 73.4116H479.509C479.707 73.2106 479.938 73.0561 480.202 72.9481C480.466 72.8401 480.747 72.7861 481.044 72.7861C481.35 72.7861 481.62 72.8431 481.854 72.9571C482.091 73.0681 482.275 73.2511 482.407 73.5061C482.542 73.7581 482.61 74.0956 482.61 74.5186V77.7451H481.894V74.5501C481.894 74.1301 481.801 73.8391 481.615 73.6771C481.432 73.5121 481.183 73.4296 480.868 73.4296C480.724 73.4296 480.571 73.4506 480.409 73.4926C480.247 73.5346 480.088 73.6036 479.932 73.6996C479.779 73.7956 479.643 73.9231 479.523 74.0821V77.7451H478.803ZM485.974 77.8306C485.467 77.8306 485.041 77.7451 484.696 77.5741C484.354 77.4001 484.096 77.1286 483.922 76.7596C483.748 76.3876 483.661 75.9016 483.661 75.3016C483.661 74.7286 483.741 74.2561 483.9 73.8841C484.062 73.5121 484.29 73.2361 484.584 73.0561C484.881 72.8761 485.232 72.7861 485.637 72.7861C486.036 72.7861 486.375 72.8776 486.654 73.0606C486.936 73.2406 487.15 73.5181 487.297 73.8931C487.444 74.2651 487.518 74.7406 487.518 75.3196V75.5401H484.053V75.0496H486.987L486.829 75.1576C486.829 74.7016 486.781 74.3386 486.685 74.0686C486.592 73.7986 486.456 73.6051 486.276 73.4881C486.099 73.3681 485.883 73.3081 485.628 73.3081C485.376 73.3081 485.157 73.3666 484.971 73.4836C484.785 73.6006 484.641 73.7941 484.539 74.0641C484.44 74.3341 484.39 74.6986 484.39 75.1576V75.4096C484.39 75.8596 484.45 76.2196 484.57 76.4896C484.693 76.7566 484.878 76.9501 485.124 77.0701C485.37 77.1871 485.682 77.2456 486.06 77.2456C486.246 77.2456 486.438 77.2291 486.636 77.1961C486.837 77.1601 487.05 77.1106 487.275 77.0476V77.6371C487.041 77.7031 486.817 77.7511 486.604 77.7811C486.394 77.8141 486.184 77.8306 485.974 77.8306ZM490.453 77.8306C489.991 77.8306 489.6 77.7436 489.279 77.5696C488.958 77.3926 488.713 77.1196 488.545 76.7506C488.377 76.3786 488.293 75.8971 488.293 75.3061C488.293 74.7151 488.383 74.2351 488.563 73.8661C488.746 73.4941 489.012 73.2211 489.36 73.0471C489.708 72.8731 490.134 72.7861 490.638 72.7861C490.809 72.7861 490.98 72.7966 491.151 72.8176C491.322 72.8386 491.485 72.8701 491.641 72.9121V73.5241C491.482 73.4821 491.325 73.4506 491.169 73.4296C491.016 73.4086 490.864 73.3981 490.714 73.3981C490.339 73.3981 490.027 73.4596 489.778 73.5826C489.529 73.7056 489.343 73.9051 489.22 74.1811C489.1 74.4571 489.04 74.8261 489.04 75.2881C489.04 75.7621 489.097 76.1401 489.211 76.4221C489.325 76.7041 489.495 76.9081 489.72 77.0341C489.948 77.1571 490.227 77.2186 490.557 77.2186C490.716 77.2186 490.882 77.2036 491.056 77.1736C491.23 77.1406 491.425 77.0896 491.641 77.0206V77.6281C491.449 77.6971 491.253 77.7481 491.052 77.7811C490.854 77.8141 490.654 77.8306 490.453 77.8306ZM494.456 77.8306C493.958 77.8306 493.571 77.7031 493.295 77.4481C493.019 77.1901 492.881 76.7791 492.881 76.2151V72.8626L492.998 71.0851H493.601V76.0981C493.601 76.5091 493.685 76.7971 493.853 76.9621C494.024 77.1271 494.277 77.2096 494.613 77.2096C494.703 77.2096 494.796 77.2036 494.892 77.1916C494.988 77.1766 495.093 77.1571 495.207 77.1331V77.7406C495.087 77.7706 494.964 77.7931 494.838 77.8081C494.712 77.8231 494.585 77.8306 494.456 77.8306ZM491.963 73.4566V72.8626H495.135V73.4566H491.963ZM495.976 77.7451V72.8626H496.696V77.7451H495.976ZM496.336 71.8006C496.174 71.8006 496.05 71.7616 495.963 71.6836C495.879 71.6026 495.837 71.4916 495.837 71.3506C495.837 71.2066 495.879 71.0941 495.963 71.0131C496.05 70.9321 496.174 70.8916 496.336 70.8916C496.498 70.8916 496.621 70.9321 496.705 71.0131C496.792 71.0941 496.836 71.2066 496.836 71.3506C496.836 71.4916 496.792 71.6026 496.705 71.6836C496.621 71.7616 496.498 71.8006 496.336 71.8006ZM499.882 77.8306C499.462 77.8306 499.096 77.7436 498.784 77.5696C498.472 77.3926 498.23 77.1196 498.059 76.7506C497.888 76.3786 497.803 75.8971 497.803 75.3061C497.803 74.7211 497.887 74.2426 498.055 73.8706C498.226 73.4986 498.467 73.2256 498.779 73.0516C499.091 72.8746 499.459 72.7861 499.882 72.7861C500.305 72.7861 500.672 72.8746 500.984 73.0516C501.296 73.2256 501.536 73.4986 501.704 73.8706C501.875 74.2396 501.961 74.7181 501.961 75.3061C501.961 75.8911 501.874 76.3696 501.7 76.7416C501.529 77.1136 501.287 77.3881 500.975 77.5651C500.666 77.7421 500.302 77.8306 499.882 77.8306ZM499.882 77.2456C500.158 77.2456 500.396 77.1856 500.597 77.0656C500.798 76.9456 500.953 76.7461 501.061 76.4671C501.172 76.1851 501.227 75.8026 501.227 75.3196C501.227 74.8276 501.172 74.4406 501.061 74.1586C500.953 73.8736 500.797 73.6726 500.593 73.5556C500.392 73.4356 500.155 73.3756 499.882 73.3756C499.606 73.3756 499.367 73.4356 499.166 73.5556C498.965 73.6726 498.809 73.8721 498.698 74.1541C498.59 74.4331 498.536 74.8141 498.536 75.2971C498.536 75.7861 498.59 76.1731 498.698 76.4581C498.809 76.7401 498.965 76.9426 499.166 77.0656C499.367 77.1856 499.606 77.2456 499.882 77.2456ZM503.06 77.7451V72.8626H503.668L503.717 73.4116H503.767C503.965 73.2106 504.196 73.0561 504.46 72.9481C504.724 72.8401 505.004 72.7861 505.301 72.7861C505.607 72.7861 505.877 72.8431 506.111 72.9571C506.348 73.0681 506.533 73.2511 506.665 73.5061C506.8 73.7581 506.867 74.0956 506.867 74.5186V77.7451H506.152V74.5501C506.152 74.1301 506.059 73.8391 505.873 73.6771C505.69 73.5121 505.441 73.4296 505.126 73.4296C504.982 73.4296 504.829 73.4506 504.667 73.4926C504.505 73.5346 504.346 73.6036 504.19 73.6996C504.037 73.7956 503.9 73.9231 503.78 74.0821V77.7451H503.06Z",
    fill: "#003087"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M76.514 182.281V175.72C76.79 175.666 77.066 175.624 77.342 175.594C77.621 175.564 77.915 175.549 78.224 175.549C79.103 175.549 79.7675 175.732 80.2175 176.098C80.6705 176.461 80.897 177.036 80.897 177.822C80.897 178.56 80.672 179.124 80.222 179.514C79.775 179.904 79.0745 180.099 78.1205 180.099C77.9645 180.099 77.8175 180.096 77.6795 180.09C77.5445 180.081 77.399 180.07 77.243 180.058V182.281H76.514ZM78.134 179.505C78.851 179.505 79.37 179.368 79.691 179.095C80.012 178.819 80.1725 178.399 80.1725 177.835C80.1725 177.244 80.015 176.815 79.7 176.548C79.388 176.278 78.9125 176.143 78.2735 176.143C78.0785 176.143 77.897 176.151 77.729 176.166C77.564 176.178 77.402 176.197 77.243 176.224V179.451C77.39 179.472 77.534 179.487 77.675 179.496C77.819 179.502 77.972 179.505 78.134 179.505ZM83.7311 182.367C83.3111 182.367 82.9451 182.28 82.6331 182.106C82.3211 181.929 82.0796 181.656 81.9086 181.287C81.7376 180.915 81.6521 180.433 81.6521 179.842C81.6521 179.257 81.7361 178.779 81.9041 178.407C82.0751 178.035 82.3166 177.762 82.6286 177.588C82.9406 177.411 83.3081 177.322 83.7311 177.322C84.1541 177.322 84.5216 177.411 84.8336 177.588C85.1456 177.762 85.3856 178.035 85.5536 178.407C85.7246 178.776 85.8101 179.254 85.8101 179.842C85.8101 180.427 85.7231 180.906 85.5491 181.278C85.3781 181.65 85.1366 181.924 84.8246 182.101C84.5156 182.278 84.1511 182.367 83.7311 182.367ZM83.7311 181.782C84.0071 181.782 84.2456 181.722 84.4466 181.602C84.6476 181.482 84.8021 181.282 84.9101 181.003C85.0211 180.721 85.0766 180.339 85.0766 179.856C85.0766 179.364 85.0211 178.977 84.9101 178.695C84.8021 178.41 84.6461 178.209 84.4421 178.092C84.2411 177.972 84.0041 177.912 83.7311 177.912C83.4551 177.912 83.2166 177.972 83.0156 178.092C82.8146 178.209 82.6586 178.408 82.5476 178.69C82.4396 178.969 82.3856 179.35 82.3856 179.833C82.3856 180.322 82.4396 180.709 82.5476 180.994C82.6586 181.276 82.8146 181.479 83.0156 181.602C83.2166 181.722 83.4551 181.782 83.7311 181.782ZM87.8256 182.281L86.3946 177.399H87.1011L88.3206 181.656H88.2486L89.5221 177.399H90.3726L91.6461 181.656H91.5651L92.7891 177.399H93.4686L92.0466 182.281H91.1961L89.9001 177.975H89.9811L88.6761 182.281H87.8256ZM96.4543 182.367C95.9473 182.367 95.5213 182.281 95.1763 182.11C94.8343 181.936 94.5763 181.665 94.4023 181.296C94.2283 180.924 94.1413 180.438 94.1413 179.838C94.1413 179.265 94.2208 178.792 94.3798 178.42C94.5418 178.048 94.7698 177.772 95.0638 177.592C95.3608 177.412 95.7118 177.322 96.1168 177.322C96.5158 177.322 96.8548 177.414 97.1338 177.597C97.4158 177.777 97.6303 178.054 97.7773 178.429C97.9243 178.801 97.9978 179.277 97.9978 179.856V180.076H94.5328V179.586H97.4668L97.3093 179.694C97.3093 179.238 97.2613 178.875 97.1653 178.605C97.0723 178.335 96.9358 178.141 96.7558 178.024C96.5788 177.904 96.3628 177.844 96.1078 177.844C95.8558 177.844 95.6368 177.903 95.4508 178.02C95.2648 178.137 95.1208 178.33 95.0188 178.6C94.9198 178.87 94.8703 179.235 94.8703 179.694V179.946C94.8703 180.396 94.9303 180.756 95.0503 181.026C95.1733 181.293 95.3578 181.486 95.6038 181.606C95.8498 181.723 96.1618 181.782 96.5398 181.782C96.7258 181.782 96.9178 181.765 97.1158 181.732C97.3168 181.696 97.5298 181.647 97.7548 181.584V182.173C97.5208 182.239 97.2973 182.287 97.0843 182.317C96.8743 182.35 96.6643 182.367 96.4543 182.367ZM99.0297 182.281V177.399H99.6327L99.6912 178.051H99.7362C99.9042 177.82 100.114 177.646 100.366 177.529C100.621 177.409 100.887 177.349 101.163 177.349C101.238 177.349 101.305 177.352 101.365 177.358C101.428 177.364 101.49 177.373 101.55 177.385V178.051C101.481 178.039 101.412 178.032 101.343 178.029C101.277 178.026 101.205 178.024 101.127 178.024C100.968 178.024 100.801 178.05 100.627 178.101C100.456 178.149 100.294 178.225 100.141 178.33C99.9882 178.432 99.8577 178.561 99.7497 178.717V182.281H99.0297ZM49.6287 191.281V184.621H50.4972L52.9047 189.792H52.7472L55.1232 184.621H55.9917V191.281H55.3032V185.256H55.5102L53.1387 190.359H52.4817L50.0832 185.256H50.3172V191.281H49.6287ZM58.6591 191.362C58.2001 191.362 57.8386 191.244 57.5746 191.007C57.3136 190.77 57.1831 190.444 57.1831 190.03C57.1831 189.604 57.3226 189.273 57.6016 189.036C57.8836 188.796 58.3351 188.646 58.9561 188.586L60.2656 188.446L60.3331 188.923L59.0011 189.067C58.6141 189.106 58.3351 189.201 58.1641 189.351C57.9961 189.498 57.9121 189.702 57.9121 189.963C57.9121 190.236 57.9901 190.444 58.1461 190.588C58.3021 190.732 58.5346 190.804 58.8436 190.804C59.0566 190.804 59.2711 190.759 59.4871 190.669C59.7031 190.576 59.8966 190.422 60.0676 190.206V188.05C60.0676 187.75 60.0211 187.519 59.9281 187.357C59.8351 187.192 59.6956 187.077 59.5096 187.011C59.3236 186.945 59.0896 186.912 58.8076 186.912C58.6246 186.912 58.4161 186.928 58.1821 186.961C57.9511 186.994 57.7201 187.05 57.4891 187.128V186.538C57.6991 186.469 57.9301 186.417 58.1821 186.381C58.4371 186.342 58.6771 186.322 58.9021 186.322C59.3161 186.322 59.6611 186.376 59.9371 186.484C60.2161 186.592 60.4246 186.775 60.5626 187.033C60.7036 187.288 60.7741 187.638 60.7741 188.082V191.281H60.1711L60.1171 190.737H60.0721C59.9131 190.938 59.7091 191.092 59.4601 191.2C59.2141 191.308 58.9471 191.362 58.6591 191.362ZM62.0804 191.281V186.399H62.6879L62.7374 186.948H62.7869C62.9849 186.747 63.2159 186.592 63.4799 186.484C63.7439 186.376 64.0244 186.322 64.3214 186.322C64.6274 186.322 64.8974 186.379 65.1314 186.493C65.3684 186.604 65.5529 186.787 65.6849 187.042C65.8199 187.294 65.8874 187.632 65.8874 188.055V191.281H65.1719V188.086C65.1719 187.666 65.0789 187.375 64.8929 187.213C64.7099 187.048 64.4609 186.966 64.1459 186.966C64.0019 186.966 63.8489 186.987 63.6869 187.029C63.5249 187.071 63.3659 187.14 63.2099 187.236C63.0569 187.332 62.9204 187.459 62.8004 187.618V191.281H62.0804ZM68.4062 191.362C67.9472 191.362 67.5857 191.244 67.3217 191.007C67.0607 190.77 66.9302 190.444 66.9302 190.03C66.9302 189.604 67.0697 189.273 67.3487 189.036C67.6307 188.796 68.0822 188.646 68.7032 188.586L70.0127 188.446L70.0802 188.923L68.7482 189.067C68.3612 189.106 68.0822 189.201 67.9112 189.351C67.7432 189.498 67.6592 189.702 67.6592 189.963C67.6592 190.236 67.7372 190.444 67.8932 190.588C68.0492 190.732 68.2817 190.804 68.5907 190.804C68.8037 190.804 69.0182 190.759 69.2342 190.669C69.4502 190.576 69.6437 190.422 69.8147 190.206V188.05C69.8147 187.75 69.7682 187.519 69.6752 187.357C69.5822 187.192 69.4427 187.077 69.2567 187.011C69.0707 186.945 68.8367 186.912 68.5547 186.912C68.3717 186.912 68.1632 186.928 67.9292 186.961C67.6982 186.994 67.4672 187.05 67.2362 187.128V186.538C67.4462 186.469 67.6772 186.417 67.9292 186.381C68.1842 186.342 68.4242 186.322 68.6492 186.322C69.0632 186.322 69.4082 186.376 69.6842 186.484C69.9632 186.592 70.1717 186.775 70.3097 187.033C70.4507 187.288 70.5212 187.638 70.5212 188.082V191.281H69.9182L69.8642 190.737H69.8192C69.6602 190.938 69.4562 191.092 69.2072 191.2C68.9612 191.308 68.6942 191.362 68.4062 191.362ZM73.3215 193.351C73.0965 193.351 72.855 193.332 72.597 193.293C72.342 193.257 72.1035 193.203 71.8815 193.131V192.528C72.1365 192.606 72.3795 192.663 72.6105 192.699C72.8445 192.738 73.068 192.757 73.281 192.757C73.809 192.757 74.199 192.643 74.451 192.415C74.703 192.19 74.829 191.799 74.829 191.241V190.764H74.7885C74.6415 190.935 74.4525 191.074 74.2215 191.182C73.9935 191.29 73.7325 191.344 73.4385 191.344C73.0995 191.344 72.789 191.266 72.507 191.11C72.225 190.951 71.9985 190.696 71.8275 190.345C71.6565 189.991 71.571 189.522 71.571 188.937C71.571 188.061 71.7795 187.407 72.1965 186.975C72.6165 186.54 73.233 186.322 74.046 186.322C74.214 186.322 74.385 186.331 74.559 186.349C74.736 186.367 74.9085 186.393 75.0765 186.426C75.2445 186.459 75.402 186.498 75.549 186.543V191.133C75.549 191.925 75.363 192.492 74.991 192.834C74.619 193.179 74.0625 193.351 73.3215 193.351ZM73.65 190.728C73.869 190.728 74.0835 190.681 74.2935 190.588C74.5065 190.495 74.685 190.353 74.829 190.161V187.011C74.721 186.984 74.5935 186.961 74.4465 186.943C74.2995 186.922 74.1465 186.912 73.9875 186.912C73.4415 186.912 73.0245 187.065 72.7365 187.371C72.4485 187.674 72.3045 188.173 72.3045 188.869C72.3045 189.352 72.363 189.729 72.48 189.999C72.597 190.269 72.756 190.458 72.957 190.566C73.161 190.674 73.392 190.728 73.65 190.728ZM78.9641 191.367C78.4571 191.367 78.0311 191.281 77.6861 191.11C77.3441 190.936 77.0861 190.665 76.9121 190.296C76.7381 189.924 76.6511 189.438 76.6511 188.838C76.6511 188.265 76.7306 187.792 76.8896 187.42C77.0516 187.048 77.2796 186.772 77.5736 186.592C77.8706 186.412 78.2216 186.322 78.6266 186.322C79.0256 186.322 79.3646 186.414 79.6436 186.597C79.9256 186.777 80.1401 187.054 80.2871 187.429C80.4341 187.801 80.5076 188.277 80.5076 188.856V189.076H77.0426V188.586H79.9766L79.8191 188.694C79.8191 188.238 79.7711 187.875 79.6751 187.605C79.5821 187.335 79.4456 187.141 79.2656 187.024C79.0886 186.904 78.8726 186.844 78.6176 186.844C78.3656 186.844 78.1466 186.903 77.9606 187.02C77.7746 187.137 77.6306 187.33 77.5286 187.6C77.4296 187.87 77.3801 188.235 77.3801 188.694V188.946C77.3801 189.396 77.4401 189.756 77.5601 190.026C77.6831 190.293 77.8676 190.486 78.1136 190.606C78.3596 190.723 78.6716 190.782 79.0496 190.782C79.2356 190.782 79.4276 190.765 79.6256 190.732C79.8266 190.696 80.0396 190.647 80.2646 190.584V191.173C80.0306 191.239 79.8071 191.287 79.5941 191.317C79.3841 191.35 79.1741 191.367 78.9641 191.367ZM81.5394 191.281V186.399H82.1469L82.1964 186.952H82.2459C82.4319 186.742 82.6449 186.585 82.8849 186.48C83.1279 186.375 83.3859 186.322 83.6589 186.322C83.9289 186.322 84.1704 186.378 84.3834 186.489C84.5964 186.6 84.7644 186.781 84.8874 187.033C85.0104 187.282 85.0719 187.617 85.0719 188.037V191.281H84.3609V188.082C84.3609 187.662 84.2784 187.371 84.1134 187.209C83.9484 187.047 83.7309 186.966 83.4609 186.966C83.3259 186.966 83.1849 186.988 83.0379 187.033C82.8939 187.078 82.7544 187.15 82.6194 187.249C82.4844 187.345 82.3644 187.474 82.2594 187.636V191.281H81.5394ZM87.1419 191.281V188.082C87.1419 187.662 87.0549 187.371 86.8809 187.209C86.7099 187.047 86.4894 186.966 86.2194 186.966C86.0814 186.966 85.9344 186.99 85.7784 187.038C85.6254 187.083 85.4754 187.162 85.3284 187.276C85.1844 187.387 85.0584 187.54 84.9504 187.735L84.7704 187.155C85.0074 186.846 85.2699 186.63 85.5579 186.507C85.8459 186.384 86.1234 186.322 86.3904 186.322C86.6724 186.322 86.9244 186.379 87.1464 186.493C87.3684 186.604 87.5424 186.786 87.6684 187.038C87.7974 187.29 87.8619 187.627 87.8619 188.05V191.281H87.1419ZM91.2248 191.367C90.7178 191.367 90.2918 191.281 89.9468 191.11C89.6048 190.936 89.3468 190.665 89.1728 190.296C88.9988 189.924 88.9118 189.438 88.9118 188.838C88.9118 188.265 88.9913 187.792 89.1503 187.42C89.3123 187.048 89.5403 186.772 89.8343 186.592C90.1313 186.412 90.4823 186.322 90.8873 186.322C91.2863 186.322 91.6253 186.414 91.9043 186.597C92.1863 186.777 92.4008 187.054 92.5478 187.429C92.6948 187.801 92.7683 188.277 92.7683 188.856V189.076H89.3033V188.586H92.2373L92.0798 188.694C92.0798 188.238 92.0318 187.875 91.9358 187.605C91.8428 187.335 91.7063 187.141 91.5263 187.024C91.3493 186.904 91.1333 186.844 90.8783 186.844C90.6263 186.844 90.4073 186.903 90.2213 187.02C90.0353 187.137 89.8913 187.33 89.7893 187.6C89.6903 187.87 89.6408 188.235 89.6408 188.694V188.946C89.6408 189.396 89.7008 189.756 89.8208 190.026C89.9438 190.293 90.1283 190.486 90.3743 190.606C90.6203 190.723 90.9323 190.782 91.3103 190.782C91.4963 190.782 91.6883 190.765 91.8863 190.732C92.0873 190.696 92.3003 190.647 92.5253 190.584V191.173C92.2913 191.239 92.0678 191.287 91.8548 191.317C91.6448 191.35 91.4348 191.367 91.2248 191.367ZM93.8002 191.281V186.399H94.4077L94.4572 186.948H94.5067C94.7047 186.747 94.9357 186.592 95.1997 186.484C95.4637 186.376 95.7442 186.322 96.0412 186.322C96.3472 186.322 96.6172 186.379 96.8512 186.493C97.0882 186.604 97.2727 186.787 97.4047 187.042C97.5397 187.294 97.6072 187.632 97.6072 188.055V191.281H96.8917V188.086C96.8917 187.666 96.7987 187.375 96.6127 187.213C96.4297 187.048 96.1807 186.966 95.8657 186.966C95.7217 186.966 95.5687 186.987 95.4067 187.029C95.2447 187.071 95.0857 187.14 94.9297 187.236C94.7767 187.332 94.6402 187.459 94.5202 187.618V191.281H93.8002ZM100.778 191.367C100.28 191.367 99.8934 191.239 99.6174 190.984C99.3414 190.726 99.2034 190.315 99.2034 189.751V186.399L99.3204 184.621H99.9234V189.634C99.9234 190.045 100.007 190.333 100.175 190.498C100.346 190.663 100.6 190.746 100.936 190.746C101.026 190.746 101.119 190.74 101.215 190.728C101.311 190.713 101.416 190.693 101.53 190.669V191.277C101.41 191.307 101.287 191.329 101.161 191.344C101.035 191.359 100.907 191.367 100.778 191.367ZM98.2854 186.993V186.399H101.458V186.993H98.2854Z",
    fill: "#003087"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M109.564 133.392C109.387 133.392 109.207 133.388 109.024 133.379C108.844 133.37 108.662 133.358 108.479 133.343C108.296 133.328 108.11 133.308 107.921 133.284V126.786C108.104 126.747 108.292 126.714 108.484 126.687C108.679 126.66 108.881 126.639 109.091 126.624C109.301 126.609 109.522 126.602 109.753 126.602C110.35 126.602 110.836 126.668 111.211 126.8C111.589 126.929 111.866 127.125 112.043 127.389C112.22 127.65 112.309 127.98 112.309 128.379C112.309 128.634 112.262 128.871 112.169 129.09C112.076 129.306 111.929 129.488 111.728 129.635C111.527 129.782 111.265 129.881 110.941 129.932L110.95 129.869C111.472 129.929 111.86 130.104 112.115 130.395C112.37 130.686 112.498 131.063 112.498 131.525C112.498 131.828 112.444 132.096 112.336 132.33C112.231 132.561 112.061 132.756 111.827 132.915C111.596 133.071 111.293 133.19 110.918 133.271C110.546 133.352 110.095 133.392 109.564 133.392ZM109.712 132.812C110.237 132.812 110.651 132.764 110.954 132.668C111.26 132.572 111.478 132.428 111.607 132.236C111.739 132.041 111.805 131.796 111.805 131.502C111.805 131.061 111.665 130.736 111.386 130.526C111.11 130.316 110.672 130.211 110.072 130.211H108.538V129.621H109.942C110.344 129.621 110.666 129.576 110.909 129.486C111.155 129.396 111.332 129.261 111.44 129.081C111.551 128.901 111.607 128.676 111.607 128.406C111.607 127.971 111.47 127.659 111.197 127.47C110.927 127.278 110.467 127.182 109.816 127.182C109.573 127.182 109.358 127.191 109.172 127.209C108.986 127.224 108.809 127.247 108.641 127.277V132.749C108.815 132.773 108.988 132.789 109.159 132.798C109.333 132.807 109.517 132.812 109.712 132.812ZM115.017 133.415C114.714 133.415 114.445 133.359 114.211 133.248C113.977 133.137 113.793 132.956 113.658 132.704C113.523 132.452 113.455 132.114 113.455 131.691V128.451H114.175V131.66C114.175 132.077 114.268 132.368 114.454 132.533C114.64 132.695 114.88 132.776 115.174 132.776C115.321 132.776 115.474 132.753 115.633 132.708C115.795 132.663 115.951 132.593 116.101 132.497C116.251 132.401 116.385 132.276 116.502 132.123V128.451H117.222V133.334H116.614L116.565 132.798H116.52C116.316 133.002 116.085 133.157 115.827 133.262C115.569 133.364 115.299 133.415 115.017 133.415ZM118.58 133.334V128.451H119.3V133.334H118.58ZM118.94 127.389C118.778 127.389 118.654 127.35 118.567 127.272C118.483 127.191 118.441 127.08 118.441 126.939C118.441 126.795 118.483 126.683 118.567 126.602C118.654 126.521 118.778 126.48 118.94 126.48C119.102 126.48 119.225 126.521 119.309 126.602C119.396 126.683 119.44 126.795 119.44 126.939C119.44 127.08 119.396 127.191 119.309 127.272C119.225 127.35 119.102 127.389 118.94 127.389ZM120.663 133.334V126.062H121.383V133.334H120.663ZM124.411 133.419C124.057 133.419 123.735 133.34 123.444 133.181C123.153 133.019 122.92 132.761 122.746 132.407C122.575 132.053 122.49 131.582 122.49 130.994C122.49 130.406 122.583 129.918 122.769 129.531C122.958 129.144 123.235 128.855 123.601 128.663C123.967 128.471 124.417 128.375 124.951 128.375C125.089 128.375 125.227 128.381 125.365 128.393C125.503 128.405 125.631 128.42 125.748 128.438V126.062H126.468V133.334H125.856L125.806 132.807H125.757C125.613 132.984 125.425 133.131 125.194 133.248C124.966 133.362 124.705 133.419 124.411 133.419ZM124.573 132.798C124.792 132.798 125.007 132.75 125.217 132.654C125.427 132.558 125.604 132.405 125.748 132.195V129.05C125.64 129.023 125.514 129.002 125.37 128.987C125.226 128.972 125.083 128.964 124.942 128.964C124.375 128.964 123.946 129.117 123.655 129.423C123.367 129.729 123.223 130.232 123.223 130.931C123.223 131.411 123.28 131.787 123.394 132.06C123.511 132.33 123.67 132.521 123.871 132.632C124.075 132.743 124.309 132.798 124.573 132.798ZM127.827 133.334V128.451H128.547V133.334H127.827ZM128.187 127.389C128.025 127.389 127.9 127.35 127.813 127.272C127.729 127.191 127.687 127.08 127.687 126.939C127.687 126.795 127.729 126.683 127.813 126.602C127.9 126.521 128.025 126.48 128.187 126.48C128.349 126.48 128.472 126.521 128.556 126.602C128.643 126.683 128.686 126.795 128.686 126.939C128.686 127.08 128.643 127.191 128.556 127.272C128.472 127.35 128.349 127.389 128.187 127.389ZM129.91 133.334V128.451H130.517L130.567 129H130.616C130.814 128.799 131.045 128.645 131.309 128.537C131.573 128.429 131.854 128.375 132.151 128.375C132.457 128.375 132.727 128.432 132.961 128.546C133.198 128.657 133.382 128.84 133.514 129.095C133.649 129.347 133.717 129.684 133.717 130.107V133.334H133.001V130.139C133.001 129.719 132.908 129.428 132.722 129.266C132.539 129.101 132.29 129.018 131.975 129.018C131.831 129.018 131.678 129.039 131.516 129.081C131.354 129.123 131.195 129.192 131.039 129.288C130.886 129.384 130.75 129.512 130.63 129.671V133.334H129.91ZM136.519 135.404C136.294 135.404 136.052 135.384 135.794 135.345C135.539 135.309 135.301 135.255 135.079 135.183V134.58C135.334 134.658 135.577 134.715 135.808 134.751C136.042 134.79 136.265 134.81 136.478 134.81C137.006 134.81 137.396 134.696 137.648 134.468C137.9 134.243 138.026 133.851 138.026 133.293V132.816H137.986C137.839 132.987 137.65 133.127 137.419 133.235C137.191 133.343 136.93 133.397 136.636 133.397C136.297 133.397 135.986 133.319 135.704 133.163C135.422 133.004 135.196 132.749 135.025 132.398C134.854 132.044 134.768 131.574 134.768 130.989C134.768 130.113 134.977 129.459 135.394 129.027C135.814 128.592 136.43 128.375 137.243 128.375C137.411 128.375 137.582 128.384 137.756 128.402C137.933 128.42 138.106 128.445 138.274 128.478C138.442 128.511 138.599 128.55 138.746 128.595V133.185C138.746 133.977 138.56 134.544 138.188 134.886C137.816 135.231 137.26 135.404 136.519 135.404ZM136.847 132.78C137.066 132.78 137.281 132.734 137.491 132.641C137.704 132.548 137.882 132.405 138.026 132.213V129.063C137.918 129.036 137.791 129.014 137.644 128.996C137.497 128.975 137.344 128.964 137.185 128.964C136.639 128.964 136.222 129.117 135.934 129.423C135.646 129.726 135.502 130.226 135.502 130.922C135.502 131.405 135.56 131.781 135.677 132.051C135.794 132.321 135.953 132.51 136.154 132.618C136.358 132.726 136.589 132.78 136.847 132.78ZM92.2268 142.334L94.6163 135.674H95.6468L98.0363 142.334H97.2938L95.0618 136.02H95.1878L92.9558 142.334H92.2268ZM93.4778 140.178L93.6488 139.562H96.6098L96.7808 140.178H93.4778ZM100.356 142.415C100.053 142.415 99.785 142.359 99.551 142.248C99.317 142.137 99.1325 141.956 98.9975 141.704C98.8625 141.452 98.795 141.114 98.795 140.691V137.451H99.515V140.66C99.515 141.077 99.608 141.368 99.794 141.533C99.98 141.695 100.22 141.776 100.514 141.776C100.661 141.776 100.814 141.753 100.973 141.708C101.135 141.663 101.291 141.593 101.441 141.497C101.591 141.401 101.724 141.276 101.841 141.123V137.451H102.561V142.334H101.954L101.904 141.798H101.859C101.655 142.002 101.424 142.157 101.166 142.262C100.908 142.364 100.638 142.415 100.356 142.415ZM105.81 142.419C105.312 142.419 104.925 142.292 104.649 142.037C104.373 141.779 104.235 141.368 104.235 140.804V137.451L104.352 135.674H104.955V140.687C104.955 141.098 105.039 141.386 105.207 141.551C105.378 141.716 105.631 141.798 105.967 141.798C106.057 141.798 106.15 141.792 106.246 141.78C106.342 141.765 106.447 141.746 106.561 141.722V142.329C106.441 142.359 106.318 142.382 106.192 142.397C106.066 142.412 105.939 142.419 105.81 142.419ZM103.317 138.045V137.451H106.489V138.045H103.317ZM109.083 142.419C108.663 142.419 108.297 142.332 107.985 142.158C107.673 141.981 107.431 141.708 107.26 141.339C107.089 140.967 107.004 140.486 107.004 139.895C107.004 139.31 107.088 138.831 107.256 138.459C107.427 138.087 107.668 137.814 107.98 137.64C108.292 137.463 108.66 137.375 109.083 137.375C109.506 137.375 109.873 137.463 110.185 137.64C110.497 137.814 110.737 138.087 110.905 138.459C111.076 138.828 111.162 139.307 111.162 139.895C111.162 140.48 111.075 140.958 110.901 141.33C110.73 141.702 110.488 141.977 110.176 142.154C109.867 142.331 109.503 142.419 109.083 142.419ZM109.083 141.834C109.359 141.834 109.597 141.774 109.798 141.654C109.999 141.534 110.154 141.335 110.262 141.056C110.373 140.774 110.428 140.391 110.428 139.908C110.428 139.416 110.373 139.029 110.262 138.747C110.154 138.462 109.998 138.261 109.794 138.144C109.593 138.024 109.356 137.964 109.083 137.964C108.807 137.964 108.568 138.024 108.367 138.144C108.166 138.261 108.01 138.461 107.899 138.743C107.791 139.022 107.737 139.403 107.737 139.886C107.737 140.375 107.791 140.762 107.899 141.047C108.01 141.329 108.166 141.531 108.367 141.654C108.568 141.774 108.807 141.834 109.083 141.834ZM112.261 142.334V137.451H112.869L112.918 138.005H112.968C113.154 137.795 113.367 137.637 113.607 137.532C113.85 137.427 114.108 137.375 114.381 137.375C114.651 137.375 114.892 137.43 115.105 137.541C115.318 137.652 115.486 137.834 115.609 138.086C115.732 138.335 115.794 138.669 115.794 139.089V142.334H115.083V139.134C115.083 138.714 115 138.423 114.835 138.261C114.67 138.099 114.453 138.018 114.183 138.018C114.048 138.018 113.907 138.041 113.76 138.086C113.616 138.131 113.476 138.203 113.341 138.302C113.206 138.398 113.086 138.527 112.981 138.689V142.334H112.261ZM117.864 142.334V139.134C117.864 138.714 117.777 138.423 117.603 138.261C117.432 138.099 117.211 138.018 116.941 138.018C116.803 138.018 116.656 138.042 116.5 138.09C116.347 138.135 116.197 138.215 116.05 138.329C115.906 138.44 115.78 138.593 115.672 138.788L115.492 138.207C115.729 137.898 115.992 137.682 116.28 137.559C116.568 137.436 116.845 137.375 117.112 137.375C117.394 137.375 117.646 137.432 117.868 137.546C118.09 137.657 118.264 137.838 118.39 138.09C118.519 138.342 118.584 138.68 118.584 139.103V142.334H117.864ZM121.101 142.415C120.642 142.415 120.28 142.296 120.016 142.059C119.755 141.822 119.625 141.497 119.625 141.083C119.625 140.657 119.764 140.325 120.043 140.088C120.325 139.848 120.777 139.698 121.398 139.638L122.707 139.499L122.775 139.976L121.443 140.12C121.056 140.159 120.777 140.253 120.606 140.403C120.438 140.55 120.354 140.754 120.354 141.015C120.354 141.288 120.432 141.497 120.588 141.641C120.744 141.785 120.976 141.857 121.285 141.857C121.498 141.857 121.713 141.812 121.929 141.722C122.145 141.629 122.338 141.474 122.509 141.258V139.103C122.509 138.803 122.463 138.572 122.37 138.41C122.277 138.245 122.137 138.129 121.951 138.063C121.765 137.997 121.531 137.964 121.249 137.964C121.066 137.964 120.858 137.981 120.624 138.014C120.393 138.047 120.162 138.102 119.931 138.18V137.591C120.141 137.522 120.372 137.469 120.624 137.433C120.879 137.394 121.119 137.375 121.344 137.375C121.758 137.375 122.103 137.429 122.379 137.537C122.658 137.645 122.866 137.828 123.004 138.086C123.145 138.341 123.216 138.69 123.216 139.134V142.334H122.613L122.559 141.789H122.514C122.355 141.99 122.151 142.145 121.902 142.253C121.656 142.361 121.389 142.415 121.101 142.415ZM126.385 142.419C125.887 142.419 125.5 142.292 125.224 142.037C124.948 141.779 124.81 141.368 124.81 140.804V137.451L124.927 135.674H125.53V140.687C125.53 141.098 125.614 141.386 125.782 141.551C125.953 141.716 126.206 141.798 126.542 141.798C126.632 141.798 126.725 141.792 126.821 141.78C126.917 141.765 127.022 141.746 127.136 141.722V142.329C127.016 142.359 126.893 142.382 126.767 142.397C126.641 142.412 126.514 142.419 126.385 142.419ZM123.892 138.045V137.451H127.064V138.045H123.892ZM127.906 142.334V137.451H128.626V142.334H127.906ZM128.266 136.389C128.104 136.389 127.979 136.35 127.892 136.272C127.808 136.191 127.766 136.08 127.766 135.939C127.766 135.795 127.808 135.683 127.892 135.602C127.979 135.521 128.104 135.48 128.266 135.48C128.428 135.48 128.551 135.521 128.635 135.602C128.722 135.683 128.765 135.795 128.765 135.939C128.765 136.08 128.722 136.191 128.635 136.272C128.551 136.35 128.428 136.389 128.266 136.389ZM131.811 142.419C131.391 142.419 131.025 142.332 130.713 142.158C130.401 141.981 130.16 141.708 129.989 141.339C129.818 140.967 129.732 140.486 129.732 139.895C129.732 139.31 129.816 138.831 129.984 138.459C130.155 138.087 130.397 137.814 130.709 137.64C131.021 137.463 131.388 137.375 131.811 137.375C132.234 137.375 132.602 137.463 132.914 137.64C133.226 137.814 133.466 138.087 133.634 138.459C133.805 138.828 133.89 139.307 133.89 139.895C133.89 140.48 133.803 140.958 133.629 141.33C133.458 141.702 133.217 141.977 132.905 142.154C132.596 142.331 132.231 142.419 131.811 142.419ZM131.811 141.834C132.087 141.834 132.326 141.774 132.527 141.654C132.728 141.534 132.882 141.335 132.99 141.056C133.101 140.774 133.157 140.391 133.157 139.908C133.157 139.416 133.101 139.029 132.99 138.747C132.882 138.462 132.726 138.261 132.522 138.144C132.321 138.024 132.084 137.964 131.811 137.964C131.535 137.964 131.297 138.024 131.096 138.144C130.895 138.261 130.739 138.461 130.628 138.743C130.52 139.022 130.466 139.403 130.466 139.886C130.466 140.375 130.52 140.762 130.628 141.047C130.739 141.329 130.895 141.531 131.096 141.654C131.297 141.774 131.535 141.834 131.811 141.834ZM134.99 142.334V137.451H135.597L135.647 138H135.696C135.894 137.799 136.125 137.645 136.389 137.537C136.653 137.429 136.934 137.375 137.231 137.375C137.537 137.375 137.807 137.432 138.041 137.546C138.278 137.657 138.462 137.84 138.594 138.095C138.729 138.347 138.797 138.684 138.797 139.107V142.334H138.081V139.139C138.081 138.719 137.988 138.428 137.802 138.266C137.619 138.101 137.37 138.018 137.055 138.018C136.911 138.018 136.758 138.039 136.596 138.081C136.434 138.123 136.275 138.192 136.119 138.288C135.966 138.384 135.83 138.512 135.71 138.671V142.334H134.99Z",
    fill: "#003087"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M175.569 73.3212C175.392 73.3212 175.212 73.3167 175.029 73.3077C174.849 73.2987 174.667 73.2867 174.484 73.2717C174.301 73.2567 174.115 73.2372 173.926 73.2132V66.7152C174.109 66.6762 174.297 66.6432 174.489 66.6162C174.684 66.5892 174.886 66.5682 175.096 66.5532C175.306 66.5382 175.527 66.5307 175.758 66.5307C176.355 66.5307 176.841 66.5967 177.216 66.7287C177.594 66.8577 177.871 67.0542 178.048 67.3182C178.225 67.5792 178.314 67.9092 178.314 68.3082C178.314 68.5632 178.267 68.8002 178.174 69.0192C178.081 69.2352 177.934 69.4167 177.733 69.5637C177.532 69.7107 177.27 69.8097 176.946 69.8607L176.955 69.7977C177.477 69.8577 177.865 70.0332 178.12 70.3242C178.375 70.6152 178.503 70.9917 178.503 71.4537C178.503 71.7567 178.449 72.0252 178.341 72.2592C178.236 72.4902 178.066 72.6852 177.832 72.8442C177.601 73.0002 177.298 73.1187 176.923 73.1997C176.551 73.2807 176.1 73.3212 175.569 73.3212ZM175.717 72.7407C176.242 72.7407 176.656 72.6927 176.959 72.5967C177.265 72.5007 177.483 72.3567 177.612 72.1647C177.744 71.9697 177.81 71.7252 177.81 71.4312C177.81 70.9902 177.67 70.6647 177.391 70.4547C177.115 70.2447 176.677 70.1397 176.077 70.1397H174.543V69.5502H175.947C176.349 69.5502 176.671 69.5052 176.914 69.4152C177.16 69.3252 177.337 69.1902 177.445 69.0102C177.556 68.8302 177.612 68.6052 177.612 68.3352C177.612 67.9002 177.475 67.5882 177.202 67.3992C176.932 67.2072 176.472 67.1112 175.821 67.1112C175.578 67.1112 175.363 67.1202 175.177 67.1382C174.991 67.1532 174.814 67.1757 174.646 67.2057V72.6777C174.82 72.7017 174.993 72.7182 175.164 72.7272C175.338 72.7362 175.522 72.7407 175.717 72.7407ZM181.022 73.3437C180.719 73.3437 180.45 73.2882 180.216 73.1772C179.982 73.0662 179.798 72.8847 179.663 72.6327C179.528 72.3807 179.46 72.0432 179.46 71.6202V68.3802H180.18V71.5887C180.18 72.0057 180.273 72.2967 180.459 72.4617C180.645 72.6237 180.885 72.7047 181.179 72.7047C181.326 72.7047 181.479 72.6822 181.638 72.6372C181.8 72.5922 181.956 72.5217 182.106 72.4257C182.256 72.3297 182.39 72.2052 182.507 72.0522V68.3802H183.227V73.2627H182.619L182.57 72.7272H182.525C182.321 72.9312 182.09 73.0857 181.832 73.1907C181.574 73.2927 181.304 73.3437 181.022 73.3437ZM184.585 73.2627V68.3802H185.305V73.2627H184.585ZM184.945 67.3182C184.783 67.3182 184.659 67.2792 184.572 67.2012C184.488 67.1202 184.446 67.0092 184.446 66.8682C184.446 66.7242 184.488 66.6117 184.572 66.5307C184.659 66.4497 184.783 66.4092 184.945 66.4092C185.107 66.4092 185.23 66.4497 185.314 66.5307C185.401 66.6117 185.445 66.7242 185.445 66.8682C185.445 67.0092 185.401 67.1202 185.314 67.2012C185.23 67.2792 185.107 67.3182 184.945 67.3182ZM186.668 73.2627V65.9907H187.388V73.2627H186.668ZM190.416 73.3482C190.062 73.3482 189.74 73.2687 189.449 73.1097C189.158 72.9477 188.925 72.6897 188.751 72.3357C188.58 71.9817 188.495 71.5107 188.495 70.9227C188.495 70.3347 188.588 69.8472 188.774 69.4602C188.963 69.0732 189.24 68.7837 189.606 68.5917C189.972 68.3997 190.422 68.3037 190.956 68.3037C191.094 68.3037 191.232 68.3097 191.37 68.3217C191.508 68.3337 191.636 68.3487 191.753 68.3667V65.9907H192.473V73.2627H191.861L191.811 72.7362H191.762C191.618 72.9132 191.43 73.0602 191.199 73.1772C190.971 73.2912 190.71 73.3482 190.416 73.3482ZM190.578 72.7272C190.797 72.7272 191.012 72.6792 191.222 72.5832C191.432 72.4872 191.609 72.3342 191.753 72.1242V68.9787C191.645 68.9517 191.519 68.9307 191.375 68.9157C191.231 68.9007 191.088 68.8932 190.947 68.8932C190.38 68.8932 189.951 69.0462 189.66 69.3522C189.372 69.6582 189.228 70.1607 189.228 70.8597C189.228 71.3397 189.285 71.7162 189.399 71.9892C189.516 72.2592 189.675 72.4497 189.876 72.5607C190.08 72.6717 190.314 72.7272 190.578 72.7272ZM193.831 73.2627V68.3802H194.551V73.2627H193.831ZM194.191 67.3182C194.029 67.3182 193.905 67.2792 193.818 67.2012C193.734 67.1202 193.692 67.0092 193.692 66.8682C193.692 66.7242 193.734 66.6117 193.818 66.5307C193.905 66.4497 194.029 66.4092 194.191 66.4092C194.353 66.4092 194.476 66.4497 194.56 66.5307C194.647 66.6117 194.691 66.7242 194.691 66.8682C194.691 67.0092 194.647 67.1202 194.56 67.2012C194.476 67.2792 194.353 67.3182 194.191 67.3182ZM195.914 73.2627V68.3802H196.522L196.571 68.9292H196.621C196.819 68.7282 197.05 68.5737 197.314 68.4657C197.578 68.3577 197.858 68.3037 198.155 68.3037C198.461 68.3037 198.731 68.3607 198.965 68.4747C199.202 68.5857 199.387 68.7687 199.519 69.0237C199.654 69.2757 199.721 69.6132 199.721 70.0362V73.2627H199.006V70.0677C199.006 69.6477 198.913 69.3567 198.727 69.1947C198.544 69.0297 198.295 68.9472 197.98 68.9472C197.836 68.9472 197.683 68.9682 197.521 69.0102C197.359 69.0522 197.2 69.1212 197.044 69.2172C196.891 69.3132 196.754 69.4407 196.634 69.5997V73.2627H195.914ZM202.524 75.3327C202.299 75.3327 202.057 75.3132 201.799 75.2742C201.544 75.2382 201.306 75.1842 201.084 75.1122V74.5092C201.339 74.5872 201.582 74.6442 201.813 74.6802C202.047 74.7192 202.27 74.7387 202.483 74.7387C203.011 74.7387 203.401 74.6247 203.653 74.3967C203.905 74.1717 204.031 73.7802 204.031 73.2222V72.7452H203.991C203.844 72.9162 203.655 73.0557 203.424 73.1637C203.196 73.2717 202.935 73.3257 202.641 73.3257C202.302 73.3257 201.991 73.2477 201.709 73.0917C201.427 72.9327 201.201 72.6777 201.03 72.3267C200.859 71.9727 200.773 71.5032 200.773 70.9182C200.773 70.0422 200.982 69.3882 201.399 68.9562C201.819 68.5212 202.435 68.3037 203.248 68.3037C203.416 68.3037 203.587 68.3127 203.761 68.3307C203.938 68.3487 204.111 68.3742 204.279 68.4072C204.447 68.4402 204.604 68.4792 204.751 68.5242V73.1142C204.751 73.9062 204.565 74.4732 204.193 74.8152C203.821 75.1602 203.265 75.3327 202.524 75.3327ZM202.852 72.7092C203.071 72.7092 203.286 72.6627 203.496 72.5697C203.709 72.4767 203.887 72.3342 204.031 72.1422V68.9922C203.923 68.9652 203.796 68.9427 203.649 68.9247C203.502 68.9037 203.349 68.8932 203.19 68.8932C202.644 68.8932 202.227 69.0462 201.939 69.3522C201.651 69.6552 201.507 70.1547 201.507 70.8507C201.507 71.3337 201.565 71.7102 201.682 71.9802C201.799 72.2502 201.958 72.4392 202.159 72.5472C202.363 72.6552 202.594 72.7092 202.852 72.7092ZM169.508 82.2627L171.898 75.6027H172.928L175.318 82.2627H174.575L172.343 75.9492H172.469L170.237 82.2627H169.508ZM170.759 80.1072L170.93 79.4907H173.891L174.062 80.1072H170.759ZM176.13 82.2627V77.3802H176.738L176.787 77.9292H176.837C177.035 77.7282 177.266 77.5737 177.53 77.4657C177.794 77.3577 178.074 77.3037 178.371 77.3037C178.677 77.3037 178.947 77.3607 179.181 77.4747C179.418 77.5857 179.603 77.7687 179.735 78.0237C179.87 78.2757 179.937 78.6132 179.937 79.0362V82.2627H179.222V79.0677C179.222 78.6477 179.129 78.3567 178.943 78.1947C178.76 78.0297 178.511 77.9472 178.196 77.9472C178.052 77.9472 177.899 77.9682 177.737 78.0102C177.575 78.0522 177.416 78.1212 177.26 78.2172C177.107 78.3132 176.97 78.4407 176.85 78.5997V82.2627H176.13ZM182.456 82.3437C181.997 82.3437 181.635 82.2252 181.371 81.9882C181.11 81.7512 180.98 81.4257 180.98 81.0117C180.98 80.5857 181.119 80.2542 181.398 80.0172C181.68 79.7772 182.132 79.6272 182.753 79.5672L184.062 79.4277L184.13 79.9047L182.798 80.0487C182.411 80.0877 182.132 80.1822 181.961 80.3322C181.793 80.4792 181.709 80.6832 181.709 80.9442C181.709 81.2172 181.787 81.4257 181.943 81.5697C182.099 81.7137 182.331 81.7857 182.64 81.7857C182.853 81.7857 183.068 81.7407 183.284 81.6507C183.5 81.5577 183.693 81.4032 183.864 81.1872V79.0317C183.864 78.7317 183.818 78.5007 183.725 78.3387C183.632 78.1737 183.492 78.0582 183.306 77.9922C183.12 77.9262 182.886 77.8932 182.604 77.8932C182.421 77.8932 182.213 77.9097 181.979 77.9427C181.748 77.9757 181.517 78.0312 181.286 78.1092V77.5197C181.496 77.4507 181.727 77.3982 181.979 77.3622C182.234 77.3232 182.474 77.3037 182.699 77.3037C183.113 77.3037 183.458 77.3577 183.734 77.4657C184.013 77.5737 184.221 77.7567 184.359 78.0147C184.5 78.2697 184.571 78.6192 184.571 79.0632V82.2627H183.968L183.914 81.7182H183.869C183.71 81.9192 183.506 82.0737 183.257 82.1817C183.011 82.2897 182.744 82.3437 182.456 82.3437ZM185.877 82.2627V74.9907H186.597V82.2627H185.877ZM188.653 84.2427L189.405 82.2627L189.634 81.7452L191.245 77.3802H191.97L189.373 84.2427H188.653ZM189.198 82.2627L187.348 77.3802H188.118L189.886 82.2627H189.198ZM194.561 82.3482C194.063 82.3482 193.676 82.2207 193.4 81.9657C193.124 81.7077 192.986 81.2967 192.986 80.7327V77.3802L193.103 75.6027H193.706V80.6157C193.706 81.0267 193.79 81.3147 193.958 81.4797C194.129 81.6447 194.382 81.7272 194.718 81.7272C194.808 81.7272 194.901 81.7212 194.997 81.7092C195.093 81.6942 195.198 81.6747 195.312 81.6507V82.2582C195.192 82.2882 195.069 82.3107 194.943 82.3257C194.817 82.3407 194.69 82.3482 194.561 82.3482ZM192.068 77.9742V77.3802H195.24V77.9742H192.068ZM196.081 82.2627V77.3802H196.801V82.2627H196.081ZM196.441 76.3182C196.279 76.3182 196.155 76.2792 196.068 76.2012C195.984 76.1202 195.942 76.0092 195.942 75.8682C195.942 75.7242 195.984 75.6117 196.068 75.5307C196.155 75.4497 196.279 75.4092 196.441 75.4092C196.603 75.4092 196.726 75.4497 196.81 75.5307C196.897 75.6117 196.941 75.7242 196.941 75.8682C196.941 76.0092 196.897 76.1202 196.81 76.2012C196.726 76.2792 196.603 76.3182 196.441 76.3182ZM200.068 82.3482C199.606 82.3482 199.214 82.2612 198.893 82.0872C198.572 81.9102 198.328 81.6372 198.16 81.2682C197.992 80.8962 197.908 80.4147 197.908 79.8237C197.908 79.2327 197.998 78.7527 198.178 78.3837C198.361 78.0117 198.626 77.7387 198.974 77.5647C199.322 77.3907 199.748 77.3037 200.252 77.3037C200.423 77.3037 200.594 77.3142 200.765 77.3352C200.936 77.3562 201.1 77.3877 201.256 77.4297V78.0417C201.097 77.9997 200.939 77.9682 200.783 77.9472C200.63 77.9262 200.479 77.9157 200.329 77.9157C199.954 77.9157 199.642 77.9772 199.393 78.1002C199.144 78.2232 198.958 78.4227 198.835 78.6987C198.715 78.9747 198.655 79.3437 198.655 79.8057C198.655 80.2797 198.712 80.6577 198.826 80.9397C198.94 81.2217 199.109 81.4257 199.334 81.5517C199.562 81.6747 199.841 81.7362 200.171 81.7362C200.33 81.7362 200.497 81.7212 200.671 81.6912C200.845 81.6582 201.04 81.6072 201.256 81.5382V82.1457C201.064 82.2147 200.867 82.2657 200.666 82.2987C200.468 82.3317 200.269 82.3482 200.068 82.3482ZM203.223 82.3482C202.977 82.3482 202.742 82.3317 202.517 82.2987C202.295 82.2657 202.079 82.2162 201.869 82.1502V81.5742C202.109 81.6462 202.338 81.6987 202.557 81.7317C202.776 81.7617 202.998 81.7767 203.223 81.7767C203.646 81.7767 203.952 81.7047 204.141 81.5607C204.333 81.4167 204.429 81.2142 204.429 80.9532C204.429 80.7312 204.372 80.5617 204.258 80.4447C204.144 80.3247 203.951 80.2362 203.678 80.1792L203.016 80.0442C202.572 79.9482 202.254 79.7907 202.062 79.5717C201.873 79.3497 201.779 79.0647 201.779 78.7167C201.779 78.3057 201.936 77.9682 202.251 77.7042C202.569 77.4372 203.057 77.3037 203.714 77.3037C203.924 77.3037 204.123 77.3157 204.312 77.3397C204.504 77.3637 204.689 77.3997 204.866 77.4477V78.0282C204.668 77.9742 204.477 77.9352 204.294 77.9112C204.114 77.8872 203.925 77.8752 203.727 77.8752C203.418 77.8752 203.171 77.9127 202.985 77.9877C202.802 78.0597 202.67 78.1587 202.589 78.2847C202.508 78.4077 202.467 78.5457 202.467 78.6987C202.467 78.8907 202.521 79.0497 202.629 79.1757C202.737 79.3017 202.926 79.3947 203.196 79.4547L203.858 79.5897C204.308 79.6827 204.63 79.8357 204.825 80.0487C205.023 80.2617 205.122 80.5512 205.122 80.9172C205.122 81.3582 204.96 81.7077 204.636 81.9657C204.315 82.2207 203.844 82.3482 203.223 82.3482Z",
    fill: "#003087"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M301.276 71.0966C301.099 71.0966 300.919 71.0921 300.736 71.0831C300.556 71.0741 300.375 71.0621 300.192 71.0471C300.009 71.0321 299.823 71.0126 299.634 70.9886V64.4906C299.817 64.4516 300.004 64.4186 300.196 64.3916C300.391 64.3646 300.594 64.3436 300.804 64.3286C301.014 64.3136 301.234 64.3061 301.465 64.3061C302.062 64.3061 302.548 64.3721 302.923 64.5041C303.301 64.6331 303.579 64.8296 303.756 65.0936C303.933 65.3546 304.021 65.6846 304.021 66.0836C304.021 66.3386 303.975 66.5756 303.882 66.7946C303.789 67.0106 303.642 67.1921 303.441 67.3391C303.24 67.4861 302.977 67.5851 302.653 67.6361L302.662 67.5731C303.184 67.6331 303.573 67.8086 303.828 68.0996C304.083 68.3906 304.21 68.7671 304.21 69.2291C304.21 69.5321 304.156 69.8006 304.048 70.0346C303.943 70.2656 303.774 70.4606 303.54 70.6196C303.309 70.7756 303.006 70.8941 302.631 70.9751C302.259 71.0561 301.807 71.0966 301.276 71.0966ZM301.425 70.5161C301.95 70.5161 302.364 70.4681 302.667 70.3721C302.973 70.2761 303.19 70.1321 303.319 69.9401C303.451 69.7451 303.517 69.5006 303.517 69.2066C303.517 68.7656 303.378 68.4401 303.099 68.2301C302.823 68.0201 302.385 67.9151 301.785 67.9151H300.25V67.3256H301.654C302.056 67.3256 302.379 67.2806 302.622 67.1906C302.868 67.1006 303.045 66.9656 303.153 66.7856C303.264 66.6056 303.319 66.3806 303.319 66.1106C303.319 65.6756 303.183 65.3636 302.91 65.1746C302.64 64.9826 302.179 64.8866 301.528 64.8866C301.285 64.8866 301.071 64.8956 300.885 64.9136C300.699 64.9286 300.522 64.9511 300.354 64.9811V70.4531C300.528 70.4771 300.7 70.4936 300.871 70.5026C301.045 70.5116 301.23 70.5161 301.425 70.5161ZM306.729 71.1191C306.426 71.1191 306.157 71.0636 305.923 70.9526C305.689 70.8416 305.505 70.6601 305.37 70.4081C305.235 70.1561 305.167 69.8186 305.167 69.3956V66.1556H305.887V69.3641C305.887 69.7811 305.98 70.0721 306.166 70.2371C306.352 70.3991 306.592 70.4801 306.886 70.4801C307.033 70.4801 307.186 70.4576 307.345 70.4126C307.507 70.3676 307.663 70.2971 307.813 70.2011C307.963 70.1051 308.097 69.9806 308.214 69.8276V66.1556H308.934V71.0381H308.326L308.277 70.5026H308.232C308.028 70.7066 307.797 70.8611 307.539 70.9661C307.281 71.0681 307.011 71.1191 306.729 71.1191ZM310.293 71.0381V66.1556H311.013V71.0381H310.293ZM310.653 65.0936C310.491 65.0936 310.366 65.0546 310.279 64.9766C310.195 64.8956 310.153 64.7846 310.153 64.6436C310.153 64.4996 310.195 64.3871 310.279 64.3061C310.366 64.2251 310.491 64.1846 310.653 64.1846C310.815 64.1846 310.938 64.2251 311.022 64.3061C311.109 64.3871 311.152 64.4996 311.152 64.6436C311.152 64.7846 311.109 64.8956 311.022 64.9766C310.938 65.0546 310.815 65.0936 310.653 65.0936ZM312.376 71.0381V63.7661H313.096V71.0381H312.376ZM316.124 71.1236C315.77 71.1236 315.447 71.0441 315.156 70.8851C314.865 70.7231 314.633 70.4651 314.459 70.1111C314.288 69.7571 314.202 69.2861 314.202 68.6981C314.202 68.1101 314.295 67.6226 314.481 67.2356C314.67 66.8486 314.948 66.5591 315.314 66.3671C315.68 66.1751 316.13 66.0791 316.664 66.0791C316.802 66.0791 316.94 66.0851 317.078 66.0971C317.216 66.1091 317.343 66.1241 317.46 66.1421V63.7661H318.18V71.0381H317.568L317.519 70.5116H317.469C317.325 70.6886 317.138 70.8356 316.907 70.9526C316.679 71.0666 316.418 71.1236 316.124 71.1236ZM316.286 70.5026C316.505 70.5026 316.719 70.4546 316.929 70.3586C317.139 70.2626 317.316 70.1096 317.46 69.8996V66.7541C317.352 66.7271 317.226 66.7061 317.082 66.6911C316.938 66.6761 316.796 66.6686 316.655 66.6686C316.088 66.6686 315.659 66.8216 315.368 67.1276C315.08 67.4336 314.936 67.9361 314.936 68.6351C314.936 69.1151 314.993 69.4916 315.107 69.7646C315.224 70.0346 315.383 70.2251 315.584 70.3361C315.788 70.4471 316.022 70.5026 316.286 70.5026ZM319.539 71.0381V66.1556H320.259V71.0381H319.539ZM319.899 65.0936C319.737 65.0936 319.612 65.0546 319.525 64.9766C319.441 64.8956 319.399 64.7846 319.399 64.6436C319.399 64.4996 319.441 64.3871 319.525 64.3061C319.612 64.2251 319.737 64.1846 319.899 64.1846C320.061 64.1846 320.184 64.2251 320.268 64.3061C320.355 64.3871 320.398 64.4996 320.398 64.6436C320.398 64.7846 320.355 64.8956 320.268 64.9766C320.184 65.0546 320.061 65.0936 319.899 65.0936ZM321.622 71.0381V66.1556H322.229L322.279 66.7046H322.328C322.526 66.5036 322.757 66.3491 323.021 66.2411C323.285 66.1331 323.566 66.0791 323.863 66.0791C324.169 66.0791 324.439 66.1361 324.673 66.2501C324.91 66.3611 325.094 66.5441 325.226 66.7991C325.361 67.0511 325.429 67.3886 325.429 67.8116V71.0381H324.713V67.8431C324.713 67.4231 324.62 67.1321 324.434 66.9701C324.251 66.8051 324.002 66.7226 323.687 66.7226C323.543 66.7226 323.39 66.7436 323.228 66.7856C323.066 66.8276 322.907 66.8966 322.751 66.9926C322.598 67.0886 322.462 67.2161 322.342 67.3751V71.0381H321.622ZM328.231 73.1081C328.006 73.1081 327.765 73.0886 327.507 73.0496C327.252 73.0136 327.013 72.9596 326.791 72.8876V72.2846C327.046 72.3626 327.289 72.4196 327.52 72.4556C327.754 72.4946 327.978 72.5141 328.191 72.5141C328.719 72.5141 329.109 72.4001 329.361 72.1721C329.613 71.9471 329.739 71.5556 329.739 70.9976V70.5206H329.698C329.551 70.6916 329.362 70.8311 329.131 70.9391C328.903 71.0471 328.642 71.1011 328.348 71.1011C328.009 71.1011 327.699 71.0231 327.417 70.8671C327.135 70.7081 326.908 70.4531 326.737 70.1021C326.566 69.7481 326.481 69.2786 326.481 68.6936C326.481 67.8176 326.689 67.1636 327.106 66.7316C327.526 66.2966 328.143 66.0791 328.956 66.0791C329.124 66.0791 329.295 66.0881 329.469 66.1061C329.646 66.1241 329.818 66.1496 329.986 66.1826C330.154 66.2156 330.312 66.2546 330.459 66.2996V70.8896C330.459 71.6816 330.273 72.2486 329.901 72.5906C329.529 72.9356 328.972 73.1081 328.231 73.1081ZM328.56 70.4846C328.779 70.4846 328.993 70.4381 329.203 70.3451C329.416 70.2521 329.595 70.1096 329.739 69.9176V66.7676C329.631 66.7406 329.503 66.7181 329.356 66.7001C329.209 66.6791 329.056 66.6686 328.897 66.6686C328.351 66.6686 327.934 66.8216 327.646 67.1276C327.358 67.4306 327.214 67.9301 327.214 68.6261C327.214 69.1091 327.273 69.4856 327.39 69.7556C327.507 70.0256 327.666 70.2146 327.867 70.3226C328.071 70.4306 328.302 70.4846 328.56 70.4846ZM299.004 80.0381L301.393 73.3781H302.424L304.813 80.0381H304.071L301.839 73.7246H301.965L299.733 80.0381H299.004ZM300.255 77.8826L300.426 77.2661H303.387L303.558 77.8826H300.255ZM306.791 80.1236C306.545 80.1236 306.31 80.1071 306.085 80.0741C305.863 80.0411 305.647 79.9916 305.437 79.9256V79.3496C305.677 79.4216 305.906 79.4741 306.125 79.5071C306.344 79.5371 306.566 79.5521 306.791 79.5521C307.214 79.5521 307.52 79.4801 307.709 79.3361C307.901 79.1921 307.997 78.9896 307.997 78.7286C307.997 78.5066 307.94 78.3371 307.826 78.2201C307.712 78.1001 307.519 78.0116 307.246 77.9546L306.584 77.8196C306.14 77.7236 305.822 77.5661 305.63 77.3471C305.441 77.1251 305.347 76.8401 305.347 76.4921C305.347 76.0811 305.504 75.7436 305.819 75.4796C306.137 75.2126 306.625 75.0791 307.282 75.0791C307.492 75.0791 307.691 75.0911 307.88 75.1151C308.072 75.1391 308.257 75.1751 308.434 75.2231V75.8036C308.236 75.7496 308.045 75.7106 307.862 75.6866C307.682 75.6626 307.493 75.6506 307.295 75.6506C306.986 75.6506 306.739 75.6881 306.553 75.7631C306.37 75.8351 306.238 75.9341 306.157 76.0601C306.076 76.1831 306.035 76.3211 306.035 76.4741C306.035 76.6661 306.089 76.8251 306.197 76.9511C306.305 77.0771 306.494 77.1701 306.764 77.2301L307.426 77.3651C307.876 77.4581 308.198 77.6111 308.393 77.8241C308.591 78.0371 308.69 78.3266 308.69 78.6926C308.69 79.1336 308.528 79.4831 308.204 79.7411C307.883 79.9961 307.412 80.1236 306.791 80.1236ZM310.843 80.1236C310.597 80.1236 310.362 80.1071 310.137 80.0741C309.915 80.0411 309.699 79.9916 309.489 79.9256V79.3496C309.729 79.4216 309.958 79.4741 310.177 79.5071C310.396 79.5371 310.618 79.5521 310.843 79.5521C311.266 79.5521 311.572 79.4801 311.761 79.3361C311.953 79.1921 312.049 78.9896 312.049 78.7286C312.049 78.5066 311.992 78.3371 311.878 78.2201C311.764 78.1001 311.571 78.0116 311.298 77.9546L310.636 77.8196C310.192 77.7236 309.874 77.5661 309.682 77.3471C309.493 77.1251 309.399 76.8401 309.399 76.4921C309.399 76.0811 309.556 75.7436 309.871 75.4796C310.189 75.2126 310.677 75.0791 311.334 75.0791C311.544 75.0791 311.743 75.0911 311.932 75.1151C312.124 75.1391 312.309 75.1751 312.486 75.2231V75.8036C312.288 75.7496 312.097 75.7106 311.914 75.6866C311.734 75.6626 311.545 75.6506 311.347 75.6506C311.038 75.6506 310.791 75.6881 310.605 75.7631C310.422 75.8351 310.29 75.9341 310.209 76.0601C310.128 76.1831 310.087 76.3211 310.087 76.4741C310.087 76.6661 310.141 76.8251 310.249 76.9511C310.357 77.0771 310.546 77.1701 310.816 77.2301L311.478 77.3651C311.928 77.4581 312.25 77.6111 312.445 77.8241C312.643 78.0371 312.742 78.3266 312.742 78.6926C312.742 79.1336 312.58 79.4831 312.256 79.7411C311.935 79.9961 311.464 80.1236 310.843 80.1236ZM315.786 80.1236C315.279 80.1236 314.853 80.0381 314.508 79.8671C314.166 79.6931 313.908 79.4216 313.734 79.0526C313.56 78.6806 313.473 78.1946 313.473 77.5946C313.473 77.0216 313.552 76.5491 313.711 76.1771C313.873 75.8051 314.101 75.5291 314.395 75.3491C314.692 75.1691 315.043 75.0791 315.448 75.0791C315.847 75.0791 316.186 75.1706 316.465 75.3536C316.747 75.5336 316.962 75.8111 317.109 76.1861C317.256 76.5581 317.329 77.0336 317.329 77.6126V77.8331H313.864V77.3426H316.798L316.641 77.4506C316.641 76.9946 316.593 76.6316 316.497 76.3616C316.404 76.0916 316.267 75.8981 316.087 75.7811C315.91 75.6611 315.694 75.6011 315.439 75.6011C315.187 75.6011 314.968 75.6596 314.782 75.7766C314.596 75.8936 314.452 76.0871 314.35 76.3571C314.251 76.6271 314.202 76.9916 314.202 77.4506V77.7026C314.202 78.1526 314.262 78.5126 314.382 78.7826C314.505 79.0496 314.689 79.2431 314.935 79.3631C315.181 79.4801 315.493 79.5386 315.871 79.5386C316.057 79.5386 316.249 79.5221 316.447 79.4891C316.648 79.4531 316.861 79.4036 317.086 79.3406V79.9301C316.852 79.9961 316.629 80.0441 316.416 80.0741C316.206 80.1071 315.996 80.1236 315.786 80.1236ZM319.527 80.1236C319.281 80.1236 319.045 80.1071 318.82 80.0741C318.598 80.0411 318.382 79.9916 318.172 79.9256V79.3496C318.412 79.4216 318.642 79.4741 318.861 79.5071C319.08 79.5371 319.302 79.5521 319.527 79.5521C319.95 79.5521 320.256 79.4801 320.445 79.3361C320.637 79.1921 320.733 78.9896 320.733 78.7286C320.733 78.5066 320.676 78.3371 320.562 78.2201C320.448 78.1001 320.254 78.0116 319.981 77.9546L319.32 77.8196C318.876 77.7236 318.558 77.5661 318.366 77.3471C318.177 77.1251 318.082 76.8401 318.082 76.4921C318.082 76.0811 318.24 75.7436 318.555 75.4796C318.873 75.2126 319.36 75.0791 320.017 75.0791C320.227 75.0791 320.427 75.0911 320.616 75.1151C320.808 75.1391 320.992 75.1751 321.169 75.2231V75.8036C320.971 75.7496 320.781 75.7106 320.598 75.6866C320.418 75.6626 320.229 75.6506 320.031 75.6506C319.722 75.6506 319.474 75.6881 319.288 75.7631C319.105 75.8351 318.973 75.9341 318.892 76.0601C318.811 76.1831 318.771 76.3211 318.771 76.4741C318.771 76.6661 318.825 76.8251 318.933 76.9511C319.041 77.0771 319.23 77.1701 319.5 77.2301L320.161 77.3651C320.611 77.4581 320.934 77.6111 321.129 77.8241C321.327 78.0371 321.426 78.3266 321.426 78.6926C321.426 79.1336 321.264 79.4831 320.94 79.7411C320.619 79.9961 320.148 80.1236 319.527 80.1236ZM323.578 80.1236C323.332 80.1236 323.097 80.1071 322.872 80.0741C322.65 80.0411 322.434 79.9916 322.224 79.9256V79.3496C322.464 79.4216 322.693 79.4741 322.912 79.5071C323.131 79.5371 323.353 79.5521 323.578 79.5521C324.001 79.5521 324.307 79.4801 324.496 79.3361C324.688 79.1921 324.784 78.9896 324.784 78.7286C324.784 78.5066 324.727 78.3371 324.613 78.2201C324.499 78.1001 324.306 78.0116 324.033 77.9546L323.371 77.8196C322.927 77.7236 322.609 77.5661 322.417 77.3471C322.228 77.1251 322.134 76.8401 322.134 76.4921C322.134 76.0811 322.291 75.7436 322.606 75.4796C322.924 75.2126 323.412 75.0791 324.069 75.0791C324.279 75.0791 324.478 75.0911 324.667 75.1151C324.859 75.1391 325.044 75.1751 325.221 75.2231V75.8036C325.023 75.7496 324.832 75.7106 324.649 75.6866C324.469 75.6626 324.28 75.6506 324.082 75.6506C323.773 75.6506 323.526 75.6881 323.34 75.7631C323.157 75.8351 323.025 75.9341 322.944 76.0601C322.863 76.1831 322.822 76.3211 322.822 76.4741C322.822 76.6661 322.876 76.8251 322.984 76.9511C323.092 77.0771 323.281 77.1701 323.551 77.2301L324.213 77.3651C324.663 77.4581 324.985 77.6111 325.18 77.8241C325.378 78.0371 325.477 78.3266 325.477 78.6926C325.477 79.1336 325.315 79.4831 324.991 79.7411C324.67 79.9961 324.199 80.1236 323.578 80.1236ZM326.465 80.0381V75.1556H327.072L327.122 75.7091H327.171C327.357 75.4991 327.57 75.3416 327.81 75.2366C328.053 75.1316 328.311 75.0791 328.584 75.0791C328.854 75.0791 329.096 75.1346 329.309 75.2456C329.522 75.3566 329.69 75.5381 329.813 75.7901C329.936 76.0391 329.997 76.3736 329.997 76.7936V80.0381H329.286V76.8386C329.286 76.4186 329.204 76.1276 329.039 75.9656C328.874 75.8036 328.656 75.7226 328.386 75.7226C328.251 75.7226 328.11 75.7451 327.963 75.7901C327.819 75.8351 327.68 75.9071 327.545 76.0061C327.41 76.1021 327.29 76.2311 327.185 76.3931V80.0381H326.465ZM332.067 80.0381V76.8386C332.067 76.4186 331.98 76.1276 331.806 75.9656C331.635 75.8036 331.415 75.7226 331.145 75.7226C331.007 75.7226 330.86 75.7466 330.704 75.7946C330.551 75.8396 330.401 75.9191 330.254 76.0331C330.11 76.1441 329.984 76.2971 329.876 76.4921L329.696 75.9116C329.933 75.6026 330.195 75.3866 330.483 75.2636C330.771 75.1406 331.049 75.0791 331.316 75.0791C331.598 75.0791 331.85 75.1361 332.072 75.2501C332.294 75.3611 332.468 75.5426 332.594 75.7946C332.723 76.0466 332.787 76.3841 332.787 76.8071V80.0381H332.067ZM336.15 80.1236C335.643 80.1236 335.217 80.0381 334.872 79.8671C334.53 79.6931 334.272 79.4216 334.098 79.0526C333.924 78.6806 333.837 78.1946 333.837 77.5946C333.837 77.0216 333.917 76.5491 334.076 76.1771C334.238 75.8051 334.466 75.5291 334.76 75.3491C335.057 75.1691 335.408 75.0791 335.813 75.0791C336.212 75.0791 336.551 75.1706 336.83 75.3536C337.112 75.5336 337.326 75.8111 337.473 76.1861C337.62 76.5581 337.694 77.0336 337.694 77.6126V77.8331H334.229V77.3426H337.163L337.005 77.4506C337.005 76.9946 336.957 76.6316 336.861 76.3616C336.768 76.0916 336.632 75.8981 336.452 75.7811C336.275 75.6611 336.059 75.6011 335.804 75.6011C335.552 75.6011 335.333 75.6596 335.147 75.7766C334.961 75.8936 334.817 76.0871 334.715 76.3571C334.616 76.6271 334.566 76.9916 334.566 77.4506V77.7026C334.566 78.1526 334.626 78.5126 334.746 78.7826C334.869 79.0496 335.054 79.2431 335.3 79.3631C335.546 79.4801 335.858 79.5386 336.236 79.5386C336.422 79.5386 336.614 79.5221 336.812 79.4891C337.013 79.4531 337.226 79.4036 337.451 79.3406V79.9301C337.217 79.9961 336.993 80.0441 336.78 80.0741C336.57 80.1071 336.36 80.1236 336.15 80.1236ZM338.725 80.0381V75.1556H339.333L339.382 75.7046H339.432C339.63 75.5036 339.861 75.3491 340.125 75.2411C340.389 75.1331 340.669 75.0791 340.966 75.0791C341.272 75.0791 341.542 75.1361 341.776 75.2501C342.013 75.3611 342.198 75.5441 342.33 75.7991C342.465 76.0511 342.532 76.3886 342.532 76.8116V80.0381H341.817V76.8431C341.817 76.4231 341.724 76.1321 341.538 75.9701C341.355 75.8051 341.106 75.7226 340.791 75.7226C340.647 75.7226 340.494 75.7436 340.332 75.7856C340.17 75.8276 340.011 75.8966 339.855 75.9926C339.702 76.0886 339.565 76.2161 339.445 76.3751V80.0381H338.725ZM345.704 80.1236C345.206 80.1236 344.819 79.9961 344.543 79.7411C344.267 79.4831 344.129 79.0721 344.129 78.5081V75.1556L344.246 73.3781H344.849V78.3911C344.849 78.8021 344.933 79.0901 345.101 79.2551C345.272 79.4201 345.525 79.5026 345.861 79.5026C345.951 79.5026 346.044 79.4966 346.14 79.4846C346.236 79.4696 346.341 79.4501 346.455 79.4261V80.0336C346.335 80.0636 346.212 80.0861 346.086 80.1011C345.96 80.1161 345.833 80.1236 345.704 80.1236ZM343.211 75.7496V75.1556H346.383V75.7496H343.211Z",
    fill: "#003087"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M358.964 100.703V94.1421C359.24 94.0881 359.516 94.0461 359.792 94.0161C360.071 93.9861 360.365 93.9711 360.674 93.9711C361.553 93.9711 362.217 94.1541 362.667 94.5201C363.12 94.8831 363.347 95.4576 363.347 96.2436C363.347 96.9816 363.122 97.5456 362.672 97.9356C362.225 98.3256 361.524 98.5206 360.57 98.5206C360.414 98.5206 360.267 98.5176 360.129 98.5116C359.994 98.5026 359.849 98.4921 359.693 98.4801V100.703H358.964ZM360.584 97.9266C361.301 97.9266 361.82 97.7901 362.141 97.5171C362.462 97.2411 362.622 96.8211 362.622 96.2571C362.622 95.6661 362.465 95.2371 362.15 94.9701C361.838 94.7001 361.362 94.5651 360.723 94.5651C360.528 94.5651 360.347 94.5726 360.179 94.5876C360.014 94.5996 359.852 94.6191 359.693 94.6461V97.8726C359.84 97.8936 359.984 97.9086 360.125 97.9176C360.269 97.9236 360.422 97.9266 360.584 97.9266ZM366.181 100.789C365.761 100.789 365.395 100.702 365.083 100.528C364.771 100.351 364.529 100.078 364.358 99.7086C364.187 99.3366 364.102 98.8551 364.102 98.2641C364.102 97.6791 364.186 97.2006 364.354 96.8286C364.525 96.4566 364.766 96.1836 365.078 96.0096C365.39 95.8326 365.758 95.7441 366.181 95.7441C366.604 95.7441 366.971 95.8326 367.283 96.0096C367.595 96.1836 367.835 96.4566 368.003 96.8286C368.174 97.1976 368.26 97.6761 368.26 98.2641C368.26 98.8491 368.173 99.3276 367.999 99.6996C367.828 100.072 367.586 100.346 367.274 100.523C366.965 100.7 366.601 100.789 366.181 100.789ZM366.181 100.204C366.457 100.204 366.695 100.144 366.896 100.024C367.097 99.9036 367.252 99.7041 367.36 99.4251C367.471 99.1431 367.526 98.7606 367.526 98.2776C367.526 97.7856 367.471 97.3986 367.36 97.1166C367.252 96.8316 367.096 96.6306 366.892 96.5136C366.691 96.3936 366.454 96.3336 366.181 96.3336C365.905 96.3336 365.666 96.3936 365.465 96.5136C365.264 96.6306 365.108 96.8301 364.997 97.1121C364.889 97.3911 364.835 97.7721 364.835 98.2551C364.835 98.7441 364.889 99.1311 364.997 99.4161C365.108 99.6981 365.264 99.9006 365.465 100.024C365.666 100.144 365.905 100.204 366.181 100.204ZM370.275 100.703L368.844 95.8206H369.551L370.77 100.078H370.698L371.972 95.8206H372.822L374.096 100.078H374.015L375.239 95.8206H375.918L374.496 100.703H373.646L372.35 96.3966H372.431L371.126 100.703H370.275ZM378.904 100.789C378.397 100.789 377.971 100.703 377.626 100.532C377.284 100.358 377.026 100.087 376.852 99.7176C376.678 99.3456 376.591 98.8596 376.591 98.2596C376.591 97.6866 376.67 97.2141 376.829 96.8421C376.991 96.4701 377.219 96.1941 377.513 96.0141C377.81 95.8341 378.161 95.7441 378.566 95.7441C378.965 95.7441 379.304 95.8356 379.583 96.0186C379.865 96.1986 380.08 96.4761 380.227 96.8511C380.374 97.2231 380.447 97.6986 380.447 98.2776V98.4981H376.982V98.0076H379.916L379.759 98.1156C379.759 97.6596 379.711 97.2966 379.615 97.0266C379.522 96.7566 379.385 96.5631 379.205 96.4461C379.028 96.3261 378.812 96.2661 378.557 96.2661C378.305 96.2661 378.086 96.3246 377.9 96.4416C377.714 96.5586 377.57 96.7521 377.468 97.0221C377.369 97.2921 377.32 97.6566 377.32 98.1156V98.3676C377.32 98.8176 377.38 99.1776 377.5 99.4476C377.623 99.7146 377.807 99.9081 378.053 100.028C378.299 100.145 378.611 100.204 378.989 100.204C379.175 100.204 379.367 100.187 379.565 100.154C379.766 100.118 379.979 100.069 380.204 100.006V100.595C379.97 100.661 379.747 100.709 379.534 100.739C379.324 100.772 379.114 100.789 378.904 100.789ZM381.479 100.703V95.8206H382.082L382.141 96.4731H382.186C382.354 96.2421 382.564 96.0681 382.816 95.9511C383.071 95.8311 383.336 95.7711 383.612 95.7711C383.687 95.7711 383.755 95.7741 383.815 95.7801C383.878 95.7861 383.939 95.7951 383.999 95.8071V96.4731C383.93 96.4611 383.861 96.4536 383.792 96.4506C383.726 96.4476 383.654 96.4461 383.576 96.4461C383.417 96.4461 383.251 96.4716 383.077 96.5226C382.906 96.5706 382.744 96.6471 382.591 96.7521C382.438 96.8541 382.307 96.9831 382.199 97.1391V100.703H381.479ZM387.028 100.703V94.0431H387.896L390.304 99.2136H390.146L392.522 94.0431H393.391V100.703H392.702V94.6776H392.909L390.538 99.7806H389.881L387.482 94.6776H387.716V100.703H387.028ZM396.058 100.784C395.599 100.784 395.237 100.666 394.973 100.429C394.712 100.192 394.582 99.8661 394.582 99.4521C394.582 99.0261 394.721 98.6946 395 98.4576C395.282 98.2176 395.734 98.0676 396.355 98.0076L397.664 97.8681L397.732 98.3451L396.4 98.4891C396.013 98.5281 395.734 98.6226 395.563 98.7726C395.395 98.9196 395.311 99.1236 395.311 99.3846C395.311 99.6576 395.389 99.8661 395.545 100.01C395.701 100.154 395.933 100.226 396.242 100.226C396.455 100.226 396.67 100.181 396.886 100.091C397.102 99.9981 397.295 99.8436 397.466 99.6276V97.4721C397.466 97.1721 397.42 96.9411 397.327 96.7791C397.234 96.6141 397.094 96.4986 396.908 96.4326C396.722 96.3666 396.488 96.3336 396.206 96.3336C396.023 96.3336 395.815 96.3501 395.581 96.3831C395.35 96.4161 395.119 96.4716 394.888 96.5496V95.9601C395.098 95.8911 395.329 95.8386 395.581 95.8026C395.836 95.7636 396.076 95.7441 396.301 95.7441C396.715 95.7441 397.06 95.7981 397.336 95.9061C397.615 96.0141 397.823 96.1971 397.961 96.4551C398.102 96.7101 398.173 97.0596 398.173 97.5036V100.703H397.57L397.516 100.159H397.471C397.312 100.36 397.108 100.514 396.859 100.622C396.613 100.73 396.346 100.784 396.058 100.784ZM399.479 100.703V95.8206H400.087L400.136 96.3696H400.186C400.384 96.1686 400.615 96.0141 400.879 95.9061C401.143 95.7981 401.423 95.7441 401.72 95.7441C402.026 95.7441 402.296 95.8011 402.53 95.9151C402.767 96.0261 402.952 96.2091 403.084 96.4641C403.219 96.7161 403.286 97.0536 403.286 97.4766V100.703H402.571V97.5081C402.571 97.0881 402.478 96.7971 402.292 96.6351C402.109 96.4701 401.86 96.3876 401.545 96.3876C401.401 96.3876 401.248 96.4086 401.086 96.4506C400.924 96.4926 400.765 96.5616 400.609 96.6576C400.456 96.7536 400.319 96.8811 400.199 97.0401V100.703H399.479ZM405.805 100.784C405.346 100.784 404.985 100.666 404.721 100.429C404.46 100.192 404.329 99.8661 404.329 99.4521C404.329 99.0261 404.469 98.6946 404.748 98.4576C405.03 98.2176 405.481 98.0676 406.102 98.0076L407.412 97.8681L407.479 98.3451L406.147 98.4891C405.76 98.5281 405.481 98.6226 405.31 98.7726C405.142 98.9196 405.058 99.1236 405.058 99.3846C405.058 99.6576 405.136 99.8661 405.292 100.01C405.448 100.154 405.681 100.226 405.99 100.226C406.203 100.226 406.417 100.181 406.633 100.091C406.849 99.9981 407.043 99.8436 407.214 99.6276V97.4721C407.214 97.1721 407.167 96.9411 407.074 96.7791C406.981 96.6141 406.842 96.4986 406.656 96.4326C406.47 96.3666 406.236 96.3336 405.954 96.3336C405.771 96.3336 405.562 96.3501 405.328 96.3831C405.097 96.4161 404.866 96.4716 404.635 96.5496V95.9601C404.845 95.8911 405.076 95.8386 405.328 95.8026C405.583 95.7636 405.823 95.7441 406.048 95.7441C406.462 95.7441 406.807 95.7981 407.083 95.9061C407.362 96.0141 407.571 96.1971 407.709 96.4551C407.85 96.7101 407.92 97.0596 407.92 97.5036V100.703H407.317L407.263 100.159H407.218C407.059 100.36 406.855 100.514 406.606 100.622C406.36 100.73 406.093 100.784 405.805 100.784ZM410.72 102.773C410.495 102.773 410.254 102.754 409.996 102.715C409.741 102.679 409.502 102.625 409.28 102.553V101.95C409.535 102.028 409.778 102.085 410.009 102.121C410.243 102.16 410.467 102.179 410.68 102.179C411.208 102.179 411.598 102.065 411.85 101.837C412.102 101.612 412.228 101.221 412.228 100.663V100.186H412.187C412.04 100.357 411.851 100.496 411.62 100.604C411.392 100.712 411.131 100.766 410.837 100.766C410.498 100.766 410.188 100.688 409.906 100.532C409.624 100.373 409.397 100.118 409.226 99.7671C409.055 99.4131 408.97 98.9436 408.97 98.3586C408.97 97.4826 409.178 96.8286 409.595 96.3966C410.015 95.9616 410.632 95.7441 411.445 95.7441C411.613 95.7441 411.784 95.7531 411.958 95.7711C412.135 95.7891 412.307 95.8146 412.475 95.8476C412.643 95.8806 412.801 95.9196 412.948 95.9646V100.555C412.948 101.347 412.762 101.914 412.39 102.256C412.018 102.601 411.461 102.773 410.72 102.773ZM411.049 100.15C411.268 100.15 411.482 100.103 411.692 100.01C411.905 99.9171 412.084 99.7746 412.228 99.5826V96.4326C412.12 96.4056 411.992 96.3831 411.845 96.3651C411.698 96.3441 411.545 96.3336 411.386 96.3336C410.84 96.3336 410.423 96.4866 410.135 96.7926C409.847 97.0956 409.703 97.5951 409.703 98.2911C409.703 98.7741 409.762 99.1506 409.879 99.4206C409.996 99.6906 410.155 99.8796 410.356 99.9876C410.56 100.096 410.791 100.15 411.049 100.15ZM416.363 100.789C415.856 100.789 415.43 100.703 415.085 100.532C414.743 100.358 414.485 100.087 414.311 99.7176C414.137 99.3456 414.05 98.8596 414.05 98.2596C414.05 97.6866 414.129 97.2141 414.288 96.8421C414.45 96.4701 414.678 96.1941 414.972 96.0141C415.269 95.8341 415.62 95.7441 416.025 95.7441C416.424 95.7441 416.763 95.8356 417.042 96.0186C417.324 96.1986 417.539 96.4761 417.686 96.8511C417.833 97.2231 417.906 97.6986 417.906 98.2776V98.4981H414.441V98.0076H417.375L417.218 98.1156C417.218 97.6596 417.17 97.2966 417.074 97.0266C416.981 96.7566 416.844 96.5631 416.664 96.4461C416.487 96.3261 416.271 96.2661 416.016 96.2661C415.764 96.2661 415.545 96.3246 415.359 96.4416C415.173 96.5586 415.029 96.7521 414.927 97.0221C414.828 97.2921 414.779 97.6566 414.779 98.1156V98.3676C414.779 98.8176 414.839 99.1776 414.959 99.4476C415.082 99.7146 415.266 99.9081 415.512 100.028C415.758 100.145 416.07 100.204 416.448 100.204C416.634 100.204 416.826 100.187 417.024 100.154C417.225 100.118 417.438 100.069 417.663 100.006V100.595C417.429 100.661 417.206 100.709 416.993 100.739C416.783 100.772 416.573 100.789 416.363 100.789ZM418.938 100.703V95.8206H419.546L419.595 96.3741H419.645C419.831 96.1641 420.044 96.0066 420.284 95.9016C420.527 95.7966 420.785 95.7441 421.058 95.7441C421.328 95.7441 421.569 95.7996 421.782 95.9106C421.995 96.0216 422.163 96.2031 422.286 96.4551C422.409 96.7041 422.471 97.0386 422.471 97.4586V100.703H421.76V97.5036C421.76 97.0836 421.677 96.7926 421.512 96.6306C421.347 96.4686 421.13 96.3876 420.86 96.3876C420.725 96.3876 420.584 96.4101 420.437 96.4551C420.293 96.5001 420.153 96.5721 420.018 96.6711C419.883 96.7671 419.763 96.8961 419.658 97.0581V100.703H418.938ZM424.541 100.703V97.5036C424.541 97.0836 424.454 96.7926 424.28 96.6306C424.109 96.4686 423.888 96.3876 423.618 96.3876C423.48 96.3876 423.333 96.4116 423.177 96.4596C423.024 96.5046 422.874 96.5841 422.727 96.6981C422.583 96.8091 422.457 96.9621 422.349 97.1571L422.169 96.5766C422.406 96.2676 422.669 96.0516 422.957 95.9286C423.245 95.8056 423.522 95.7441 423.789 95.7441C424.071 95.7441 424.323 95.8011 424.545 95.9151C424.767 96.0261 424.941 96.2076 425.067 96.4596C425.196 96.7116 425.261 97.0491 425.261 97.4721V100.703H424.541ZM428.624 100.789C428.117 100.789 427.691 100.703 427.346 100.532C427.004 100.358 426.746 100.087 426.572 99.7176C426.398 99.3456 426.311 98.8596 426.311 98.2596C426.311 97.6866 426.39 97.2141 426.549 96.8421C426.711 96.4701 426.939 96.1941 427.233 96.0141C427.53 95.8341 427.881 95.7441 428.286 95.7441C428.685 95.7441 429.024 95.8356 429.303 96.0186C429.585 96.1986 429.8 96.4761 429.947 96.8511C430.094 97.2231 430.167 97.6986 430.167 98.2776V98.4981H426.702V98.0076H429.636L429.479 98.1156C429.479 97.6596 429.431 97.2966 429.335 97.0266C429.242 96.7566 429.105 96.5631 428.925 96.4461C428.748 96.3261 428.532 96.2661 428.277 96.2661C428.025 96.2661 427.806 96.3246 427.62 96.4416C427.434 96.5586 427.29 96.7521 427.188 97.0221C427.089 97.2921 427.04 97.6566 427.04 98.1156V98.3676C427.04 98.8176 427.1 99.1776 427.22 99.4476C427.343 99.7146 427.527 99.9081 427.773 100.028C428.019 100.145 428.331 100.204 428.709 100.204C428.895 100.204 429.087 100.187 429.285 100.154C429.486 100.118 429.699 100.069 429.924 100.006V100.595C429.69 100.661 429.467 100.709 429.254 100.739C429.044 100.772 428.834 100.789 428.624 100.789ZM431.199 100.703V95.8206H431.807L431.856 96.3696H431.906C432.104 96.1686 432.335 96.0141 432.599 95.9061C432.863 95.7981 433.143 95.7441 433.44 95.7441C433.746 95.7441 434.016 95.8011 434.25 95.9151C434.487 96.0261 434.672 96.2091 434.804 96.4641C434.939 96.7161 435.006 97.0536 435.006 97.4766V100.703H434.291V97.5081C434.291 97.0881 434.198 96.7971 434.012 96.6351C433.829 96.4701 433.58 96.3876 433.265 96.3876C433.121 96.3876 432.968 96.4086 432.806 96.4506C432.644 96.4926 432.485 96.5616 432.329 96.6576C432.176 96.7536 432.039 96.8811 431.919 97.0401V100.703H431.199ZM438.177 100.789C437.679 100.789 437.292 100.661 437.016 100.406C436.74 100.148 436.602 99.7371 436.602 99.1731V95.8206L436.719 94.0431H437.322V99.0561C437.322 99.4671 437.406 99.7551 437.574 99.9201C437.745 100.085 437.999 100.168 438.335 100.168C438.425 100.168 438.518 100.162 438.614 100.15C438.71 100.135 438.815 100.115 438.929 100.091V100.699C438.809 100.729 438.686 100.751 438.56 100.766C438.434 100.781 438.306 100.789 438.177 100.789ZM435.684 96.4146V95.8206H438.857V96.4146H435.684Z",
    fill: "#003087"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M426.705 11.7925C426.15 11.7925 425.665 11.6755 425.251 11.4415C424.837 11.2045 424.515 10.8355 424.284 10.3345C424.053 9.83053 423.937 9.17803 423.937 8.37703C423.937 7.57603 424.053 6.92503 424.284 6.42403C424.515 5.92003 424.837 5.55103 425.251 5.31703C425.668 5.08003 426.153 4.96153 426.705 4.96153C427.257 4.96153 427.74 5.08003 428.154 5.31703C428.568 5.55103 428.89 5.92003 429.121 6.42403C429.352 6.92503 429.468 7.57603 429.468 8.37703C429.468 9.17803 429.352 9.83053 429.121 10.3345C428.89 10.8355 428.566 11.2045 428.149 11.4415C427.735 11.6755 427.254 11.7925 426.705 11.7925ZM426.705 11.167C427.107 11.167 427.458 11.0785 427.758 10.9015C428.061 10.7215 428.295 10.429 428.46 10.024C428.628 9.61903 428.712 9.07753 428.712 8.39953C428.712 7.70653 428.628 7.15453 428.46 6.74353C428.295 6.33253 428.061 6.03703 427.758 5.85703C427.458 5.67703 427.107 5.58703 426.705 5.58703C426.3 5.58703 425.946 5.67553 425.643 5.85253C425.343 6.02953 425.109 6.32053 424.941 6.72553C424.776 7.13053 424.693 7.67353 424.693 8.35453C424.693 9.05053 424.776 9.60403 424.941 10.015C425.109 10.423 425.343 10.717 425.643 10.897C425.946 11.077 426.3 11.167 426.705 11.167ZM430.622 11.707V6.82453H431.229L431.279 7.37353H431.328C431.526 7.17253 431.757 7.01803 432.021 6.91003C432.285 6.80203 432.566 6.74803 432.863 6.74803C433.169 6.74803 433.439 6.80503 433.673 6.91903C433.91 7.03003 434.094 7.21303 434.226 7.46803C434.361 7.72003 434.429 8.05753 434.429 8.48053V11.707H433.713V8.51203C433.713 8.09203 433.62 7.80103 433.434 7.63903C433.251 7.47403 433.002 7.39153 432.687 7.39153C432.543 7.39153 432.39 7.41253 432.228 7.45453C432.066 7.49653 431.907 7.56553 431.751 7.66153C431.598 7.75753 431.462 7.88503 431.342 8.04403V11.707H430.622ZM437.794 11.7925C437.287 11.7925 436.861 11.707 436.516 11.536C436.174 11.362 435.916 11.0905 435.742 10.7215C435.568 10.3495 435.481 9.86353 435.481 9.26353C435.481 8.69053 435.56 8.21803 435.719 7.84603C435.881 7.47403 436.109 7.19803 436.403 7.01803C436.7 6.83803 437.051 6.74803 437.456 6.74803C437.855 6.74803 438.194 6.83953 438.473 7.02253C438.755 7.20253 438.97 7.48003 439.117 7.85503C439.264 8.22703 439.337 8.70253 439.337 9.28153V9.50203H435.872V9.01153H438.806L438.649 9.11953C438.649 8.66353 438.601 8.30053 438.505 8.03053C438.412 7.76053 438.275 7.56703 438.095 7.45003C437.918 7.33003 437.702 7.27003 437.447 7.27003C437.195 7.27003 436.976 7.32853 436.79 7.44553C436.604 7.56253 436.46 7.75603 436.358 8.02603C436.259 8.29603 436.21 8.66053 436.21 9.11953V9.37153C436.21 9.82153 436.27 10.1815 436.39 10.4515C436.513 10.7185 436.697 10.912 436.943 11.032C437.189 11.149 437.501 11.2075 437.879 11.2075C438.065 11.2075 438.257 11.191 438.455 11.158C438.656 11.122 438.869 11.0725 439.094 11.0095V11.599C438.86 11.665 438.637 11.713 438.424 11.743C438.214 11.776 438.004 11.7925 437.794 11.7925ZM445.374 11.7925C444.915 11.7925 444.5 11.7325 444.128 11.6125C443.759 11.4895 443.442 11.2945 443.178 11.0275C442.914 10.7605 442.712 10.4095 442.571 9.97453C442.43 9.53953 442.359 9.01153 442.359 8.39053C442.359 7.58653 442.482 6.93253 442.728 6.42853C442.974 5.92453 443.327 5.55403 443.786 5.31703C444.248 5.08003 444.801 4.96153 445.446 4.96153C445.704 4.96153 445.95 4.97803 446.184 5.01103C446.421 5.04403 446.655 5.09203 446.886 5.15503V5.79403C446.652 5.72203 446.418 5.67103 446.184 5.64103C445.953 5.61103 445.716 5.59603 445.473 5.59603C444.969 5.59603 444.542 5.68603 444.191 5.86603C443.843 6.04303 443.579 6.33553 443.399 6.74353C443.219 7.14853 443.129 7.69153 443.129 8.37253C443.129 9.07453 443.22 9.62953 443.403 10.0375C443.586 10.4425 443.849 10.7305 444.191 10.9015C444.536 11.0725 444.948 11.158 445.428 11.158C445.674 11.158 445.913 11.1385 446.144 11.0995C446.375 11.0605 446.622 10.9975 446.886 10.9105V11.545C446.664 11.623 446.426 11.683 446.171 11.725C445.919 11.77 445.653 11.7925 445.374 11.7925ZM447.822 11.707V4.43503H448.542V11.707H447.822ZM449.905 11.707V6.82453H450.625V11.707H449.905ZM450.265 5.76253C450.103 5.76253 449.979 5.72353 449.892 5.64553C449.808 5.56453 449.766 5.45353 449.766 5.31253C449.766 5.16853 449.808 5.05603 449.892 4.97503C449.979 4.89403 450.103 4.85353 450.265 4.85353C450.427 4.85353 450.55 4.89403 450.634 4.97503C450.721 5.05603 450.765 5.16853 450.765 5.31253C450.765 5.45353 450.721 5.56453 450.634 5.64553C450.55 5.72353 450.427 5.76253 450.265 5.76253ZM453.892 11.7925C453.43 11.7925 453.038 11.7055 452.717 11.5315C452.396 11.3545 452.152 11.0815 451.984 10.7125C451.816 10.3405 451.732 9.85903 451.732 9.26803C451.732 8.67703 451.822 8.19703 452.002 7.82803C452.185 7.45603 452.45 7.18303 452.798 7.00903C453.146 6.83503 453.572 6.74803 454.076 6.74803C454.247 6.74803 454.418 6.75853 454.589 6.77953C454.76 6.80053 454.924 6.83203 455.08 6.87403V7.48603C454.921 7.44403 454.763 7.41253 454.607 7.39153C454.454 7.37053 454.303 7.36003 454.153 7.36003C453.778 7.36003 453.466 7.42153 453.217 7.54453C452.968 7.66753 452.782 7.86703 452.659 8.14303C452.539 8.41903 452.479 8.78803 452.479 9.25003C452.479 9.72403 452.536 10.102 452.65 10.384C452.764 10.666 452.933 10.87 453.158 10.996C453.386 11.119 453.665 11.1805 453.995 11.1805C454.154 11.1805 454.321 11.1655 454.495 11.1355C454.669 11.1025 454.864 11.0515 455.08 10.9825V11.59C454.888 11.659 454.691 11.71 454.49 11.743C454.292 11.776 454.093 11.7925 453.892 11.7925ZM459.237 11.707L457.275 9.20503L459.102 6.82453H459.903L458.026 9.29503V9.09703L460.051 11.707H459.237ZM456.591 9.50653V8.90353H457.585V9.50653H456.591ZM455.961 11.707V4.43503H456.681V11.707H455.961ZM462.906 11.707V5.04703H463.635V11.707H462.906ZM465.084 11.707V6.82453H465.691L465.741 7.37353H465.79C465.988 7.17253 466.219 7.01803 466.483 6.91003C466.747 6.80203 467.028 6.74803 467.325 6.74803C467.631 6.74803 467.901 6.80503 468.135 6.91903C468.372 7.03003 468.556 7.21303 468.688 7.46803C468.823 7.72003 468.891 8.05753 468.891 8.48053V11.707H468.175V8.51203C468.175 8.09203 468.082 7.80103 467.896 7.63903C467.713 7.47403 467.464 7.39153 467.149 7.39153C467.005 7.39153 466.852 7.41253 466.69 7.45453C466.528 7.49653 466.369 7.56553 466.213 7.66153C466.06 7.75753 465.924 7.88503 465.804 8.04403V11.707H465.084ZM471.365 11.7925C471.119 11.7925 470.883 11.776 470.658 11.743C470.436 11.71 470.22 11.6605 470.01 11.5945V11.0185C470.25 11.0905 470.48 11.143 470.699 11.176C470.918 11.206 471.14 11.221 471.365 11.221C471.788 11.221 472.094 11.149 472.283 11.005C472.475 10.861 472.571 10.6585 472.571 10.3975C472.571 10.1755 472.514 10.006 472.4 9.88903C472.286 9.76903 472.092 9.68053 471.819 9.62353L471.158 9.48853C470.714 9.39253 470.396 9.23503 470.204 9.01603C470.015 8.79403 469.92 8.50903 469.92 8.16103C469.92 7.75003 470.078 7.41253 470.393 7.14853C470.711 6.88153 471.198 6.74803 471.855 6.74803C472.065 6.74803 472.265 6.76003 472.454 6.78403C472.646 6.80803 472.83 6.84403 473.007 6.89203V7.47253C472.809 7.41853 472.619 7.37953 472.436 7.35553C472.256 7.33153 472.067 7.31953 471.869 7.31953C471.56 7.31953 471.312 7.35703 471.126 7.43203C470.943 7.50403 470.811 7.60303 470.73 7.72903C470.649 7.85203 470.609 7.99003 470.609 8.14303C470.609 8.33503 470.663 8.49403 470.771 8.62003C470.879 8.74603 471.068 8.83903 471.338 8.89903L471.999 9.03403C472.449 9.12703 472.772 9.28003 472.967 9.49303C473.165 9.70603 473.264 9.99553 473.264 10.3615C473.264 10.8025 473.102 11.152 472.778 11.41C472.457 11.665 471.986 11.7925 471.365 11.7925ZM476.061 11.7925C475.563 11.7925 475.176 11.665 474.9 11.41C474.624 11.152 474.486 10.741 474.486 10.177V6.82453L474.603 5.04703H475.206V10.06C475.206 10.471 475.29 10.759 475.458 10.924C475.629 11.089 475.883 11.1715 476.219 11.1715C476.309 11.1715 476.402 11.1655 476.498 11.1535C476.594 11.1385 476.699 11.119 476.813 11.095V11.7025C476.693 11.7325 476.57 11.755 476.444 11.77C476.318 11.785 476.19 11.7925 476.061 11.7925ZM473.568 7.41853V6.82453H476.741V7.41853H473.568ZM478.775 11.788C478.316 11.788 477.954 11.6695 477.69 11.4325C477.429 11.1955 477.299 10.87 477.299 10.456C477.299 10.03 477.438 9.69853 477.717 9.46153C477.999 9.22153 478.451 9.07153 479.072 9.01153L480.381 8.87203L480.449 9.34903L479.117 9.49303C478.73 9.53203 478.451 9.62653 478.28 9.77653C478.112 9.92353 478.028 10.1275 478.028 10.3885C478.028 10.6615 478.106 10.87 478.262 11.014C478.418 11.158 478.65 11.23 478.959 11.23C479.172 11.23 479.387 11.185 479.603 11.095C479.819 11.002 480.012 10.8475 480.183 10.6315V8.47603C480.183 8.17603 480.137 7.94503 480.044 7.78303C479.951 7.61803 479.811 7.50253 479.625 7.43653C479.439 7.37053 479.205 7.33753 478.923 7.33753C478.74 7.33753 478.532 7.35403 478.298 7.38703C478.067 7.42003 477.836 7.47553 477.605 7.55353V6.96403C477.815 6.89503 478.046 6.84253 478.298 6.80653C478.553 6.76753 478.793 6.74803 479.018 6.74803C479.432 6.74803 479.777 6.80203 480.053 6.91003C480.332 7.01803 480.54 7.20103 480.678 7.45903C480.819 7.71403 480.89 8.06353 480.89 8.50753V11.707H480.287L480.233 11.1625H480.188C480.029 11.3635 479.825 11.518 479.576 11.626C479.33 11.734 479.063 11.788 478.775 11.788ZM482.196 11.707V4.43503H482.916V11.707H482.196ZM484.279 11.707V4.43503H484.999V11.707H484.279ZM487.573 11.788C487.114 11.788 486.752 11.6695 486.488 11.4325C486.227 11.1955 486.097 10.87 486.097 10.456C486.097 10.03 486.236 9.69853 486.515 9.46153C486.797 9.22153 487.249 9.07153 487.87 9.01153L489.179 8.87203L489.247 9.34903L487.915 9.49303C487.528 9.53203 487.249 9.62653 487.078 9.77653C486.91 9.92353 486.826 10.1275 486.826 10.3885C486.826 10.6615 486.904 10.87 487.06 11.014C487.216 11.158 487.448 11.23 487.757 11.23C487.97 11.23 488.185 11.185 488.401 11.095C488.617 11.002 488.81 10.8475 488.981 10.6315V8.47603C488.981 8.17603 488.935 7.94503 488.842 7.78303C488.749 7.61803 488.609 7.50253 488.423 7.43653C488.237 7.37053 488.003 7.33753 487.721 7.33753C487.538 7.33753 487.33 7.35403 487.096 7.38703C486.865 7.42003 486.634 7.47553 486.403 7.55353V6.96403C486.613 6.89503 486.844 6.84253 487.096 6.80653C487.351 6.76753 487.591 6.74803 487.816 6.74803C488.23 6.74803 488.575 6.80203 488.851 6.91003C489.13 7.01803 489.338 7.20103 489.476 7.45903C489.617 7.71403 489.688 8.06353 489.688 8.50753V11.707H489.085L489.031 11.1625H488.986C488.827 11.3635 488.623 11.518 488.374 11.626C488.128 11.734 487.861 11.788 487.573 11.788ZM492.857 11.7925C492.359 11.7925 491.972 11.665 491.696 11.41C491.42 11.152 491.282 10.741 491.282 10.177V6.82453L491.399 5.04703H492.002V10.06C492.002 10.471 492.086 10.759 492.254 10.924C492.425 11.089 492.678 11.1715 493.014 11.1715C493.104 11.1715 493.197 11.1655 493.293 11.1535C493.389 11.1385 493.494 11.119 493.608 11.095V11.7025C493.488 11.7325 493.365 11.755 493.239 11.77C493.113 11.785 492.986 11.7925 492.857 11.7925ZM490.364 7.41853V6.82453H493.536V7.41853H490.364ZM494.378 11.707V6.82453H495.098V11.707H494.378ZM494.738 5.76253C494.576 5.76253 494.451 5.72353 494.364 5.64553C494.28 5.56453 494.238 5.45353 494.238 5.31253C494.238 5.16853 494.28 5.05603 494.364 4.97503C494.451 4.89403 494.576 4.85353 494.738 4.85353C494.9 4.85353 495.023 4.89403 495.107 4.97503C495.194 5.05603 495.237 5.16853 495.237 5.31253C495.237 5.45353 495.194 5.56453 495.107 5.64553C495.023 5.72353 494.9 5.76253 494.738 5.76253ZM498.283 11.7925C497.863 11.7925 497.497 11.7055 497.185 11.5315C496.873 11.3545 496.632 11.0815 496.461 10.7125C496.29 10.3405 496.204 9.85903 496.204 9.26803C496.204 8.68303 496.288 8.20453 496.456 7.83253C496.627 7.46053 496.869 7.18753 497.181 7.01353C497.493 6.83653 497.86 6.74803 498.283 6.74803C498.706 6.74803 499.074 6.83653 499.386 7.01353C499.698 7.18753 499.938 7.46053 500.106 7.83253C500.277 8.20153 500.362 8.68003 500.362 9.26803C500.362 9.85303 500.275 10.3315 500.101 10.7035C499.93 11.0755 499.689 11.35 499.377 11.527C499.068 11.704 498.703 11.7925 498.283 11.7925ZM498.283 11.2075C498.559 11.2075 498.798 11.1475 498.999 11.0275C499.2 10.9075 499.354 10.708 499.462 10.429C499.573 10.147 499.629 9.76453 499.629 9.28153C499.629 8.78953 499.573 8.40253 499.462 8.12053C499.354 7.83553 499.198 7.63453 498.994 7.51753C498.793 7.39753 498.556 7.33753 498.283 7.33753C498.007 7.33753 497.769 7.39753 497.568 7.51753C497.367 7.63453 497.211 7.83403 497.1 8.11603C496.992 8.39503 496.938 8.77603 496.938 9.25903C496.938 9.74803 496.992 10.135 497.1 10.42C497.211 10.702 497.367 10.9045 497.568 11.0275C497.769 11.1475 498.007 11.2075 498.283 11.2075ZM501.462 11.707V6.82453H502.069L502.119 7.37353H502.168C502.366 7.17253 502.597 7.01803 502.861 6.91003C503.125 6.80203 503.406 6.74803 503.703 6.74803C504.009 6.74803 504.279 6.80503 504.513 6.91903C504.75 7.03003 504.934 7.21303 505.066 7.46803C505.201 7.72003 505.269 8.05753 505.269 8.48053V11.707H504.553V8.51203C504.553 8.09203 504.46 7.80103 504.274 7.63903C504.091 7.47403 503.842 7.39153 503.527 7.39153C503.383 7.39153 503.23 7.41253 503.068 7.45453C502.906 7.49653 502.747 7.56553 502.591 7.66153C502.438 7.75753 502.302 7.88503 502.182 8.04403V11.707H501.462Z",
    fill: "#003087"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M483.834 125.695V119.035H484.563V121.947H488.082V119.035H488.815V125.695H488.082V122.608H484.563V125.695H483.834ZM491.467 125.776C491.008 125.776 490.647 125.658 490.383 125.421C490.122 125.184 489.991 124.858 489.991 124.444C489.991 124.018 490.131 123.687 490.41 123.45C490.692 123.21 491.143 123.06 491.764 123L493.074 122.86L493.141 123.337L491.809 123.481C491.422 123.52 491.143 123.615 490.972 123.765C490.804 123.912 490.72 124.116 490.72 124.377C490.72 124.65 490.798 124.858 490.954 125.002C491.11 125.146 491.343 125.218 491.652 125.218C491.865 125.218 492.079 125.173 492.295 125.083C492.511 124.99 492.705 124.836 492.876 124.62V122.464C492.876 122.164 492.829 121.933 492.736 121.771C492.643 121.606 492.504 121.491 492.318 121.425C492.132 121.359 491.898 121.326 491.616 121.326C491.433 121.326 491.224 121.342 490.99 121.375C490.759 121.408 490.528 121.464 490.297 121.542V120.952C490.507 120.883 490.738 120.831 490.99 120.795C491.245 120.756 491.485 120.736 491.71 120.736C492.124 120.736 492.469 120.79 492.745 120.898C493.024 121.006 493.233 121.189 493.371 121.447C493.512 121.702 493.582 122.052 493.582 122.496V125.695H492.979L492.925 125.151H492.88C492.721 125.352 492.517 125.506 492.268 125.614C492.022 125.722 491.755 125.776 491.467 125.776ZM494.492 125.695V125.25L497.255 121.24V121.407H494.542V120.813H498.047V121.258L495.284 125.268V125.097H498.101V125.695H494.492ZM500.142 125.776C499.683 125.776 499.321 125.658 499.057 125.421C498.796 125.184 498.666 124.858 498.666 124.444C498.666 124.018 498.805 123.687 499.084 123.45C499.366 123.21 499.818 123.06 500.439 123L501.748 122.86L501.816 123.337L500.484 123.481C500.097 123.52 499.818 123.615 499.647 123.765C499.479 123.912 499.395 124.116 499.395 124.377C499.395 124.65 499.473 124.858 499.629 125.002C499.785 125.146 500.017 125.218 500.326 125.218C500.539 125.218 500.754 125.173 500.97 125.083C501.186 124.99 501.379 124.836 501.55 124.62V122.464C501.55 122.164 501.504 121.933 501.411 121.771C501.318 121.606 501.178 121.491 500.992 121.425C500.806 121.359 500.572 121.326 500.29 121.326C500.107 121.326 499.899 121.342 499.665 121.375C499.434 121.408 499.203 121.464 498.972 121.542V120.952C499.182 120.883 499.413 120.831 499.665 120.795C499.92 120.756 500.16 120.736 500.385 120.736C500.799 120.736 501.144 120.79 501.42 120.898C501.699 121.006 501.907 121.189 502.045 121.447C502.186 121.702 502.257 122.052 502.257 122.496V125.695H501.654L501.6 125.151H501.555C501.396 125.352 501.192 125.506 500.943 125.614C500.697 125.722 500.43 125.776 500.142 125.776ZM503.563 125.695V120.813H504.166L504.225 121.465H504.27C504.438 121.234 504.648 121.06 504.9 120.943C505.155 120.823 505.42 120.763 505.696 120.763C505.771 120.763 505.839 120.766 505.899 120.772C505.962 120.778 506.023 120.787 506.083 120.799V121.465C506.014 121.453 505.945 121.446 505.876 121.443C505.81 121.44 505.738 121.438 505.66 121.438C505.501 121.438 505.335 121.464 505.161 121.515C504.99 121.563 504.828 121.639 504.675 121.744C504.522 121.846 504.391 121.975 504.283 122.131V125.695H503.563ZM508.464 125.695L510.853 119.035H511.884L514.273 125.695H513.531L511.299 119.382H511.425L509.193 125.695H508.464ZM509.715 123.54L509.886 122.923H512.847L513.018 123.54H509.715ZM515.086 125.695V118.423H515.806V125.695H515.086ZM518.379 125.776C517.92 125.776 517.559 125.658 517.295 125.421C517.034 125.184 516.903 124.858 516.903 124.444C516.903 124.018 517.043 123.687 517.322 123.45C517.604 123.21 518.055 123.06 518.676 123L519.986 122.86L520.053 123.337L518.721 123.481C518.334 123.52 518.055 123.615 517.884 123.765C517.716 123.912 517.632 124.116 517.632 124.377C517.632 124.65 517.71 124.858 517.866 125.002C518.022 125.146 518.255 125.218 518.564 125.218C518.777 125.218 518.991 125.173 519.207 125.083C519.423 124.99 519.617 124.836 519.788 124.62V122.464C519.788 122.164 519.741 121.933 519.648 121.771C519.555 121.606 519.416 121.491 519.23 121.425C519.044 121.359 518.81 121.326 518.528 121.326C518.345 121.326 518.136 121.342 517.902 121.375C517.671 121.408 517.44 121.464 517.209 121.542V120.952C517.419 120.883 517.65 120.831 517.902 120.795C518.157 120.756 518.397 120.736 518.622 120.736C519.036 120.736 519.381 120.79 519.657 120.898C519.936 121.006 520.145 121.189 520.283 121.447C520.424 121.702 520.494 122.052 520.494 122.496V125.695H519.891L519.837 125.151H519.792C519.633 125.352 519.429 125.506 519.18 125.614C518.934 125.722 518.667 125.776 518.379 125.776ZM521.801 125.695V120.813H522.404L522.462 121.465H522.507C522.675 121.234 522.885 121.06 523.137 120.943C523.392 120.823 523.658 120.763 523.934 120.763C524.009 120.763 524.076 120.766 524.136 120.772C524.199 120.778 524.261 120.787 524.321 120.799V121.465C524.252 121.453 524.183 121.446 524.114 121.443C524.048 121.44 523.976 121.438 523.898 121.438C523.739 121.438 523.572 121.464 523.398 121.515C523.227 121.563 523.065 121.639 522.912 121.744C522.759 121.846 522.629 121.975 522.521 122.131V125.695H521.801ZM525.053 125.695V120.813H525.66L525.71 121.366H525.759C525.945 121.156 526.158 120.999 526.398 120.894C526.641 120.789 526.899 120.736 527.172 120.736C527.442 120.736 527.684 120.792 527.897 120.903C528.11 121.014 528.278 121.195 528.401 121.447C528.524 121.696 528.585 122.031 528.585 122.451V125.695H527.874V122.496C527.874 122.076 527.792 121.785 527.627 121.623C527.462 121.461 527.244 121.38 526.974 121.38C526.839 121.38 526.698 121.402 526.551 121.447C526.407 121.492 526.268 121.564 526.133 121.663C525.998 121.759 525.878 121.888 525.773 122.05V125.695H525.053ZM530.655 125.695V122.496C530.655 122.076 530.568 121.785 530.394 121.623C530.223 121.461 530.003 121.38 529.733 121.38C529.595 121.38 529.448 121.404 529.292 121.452C529.139 121.497 528.989 121.576 528.842 121.69C528.698 121.801 528.572 121.954 528.464 122.149L528.284 121.569C528.521 121.26 528.783 121.044 529.071 120.921C529.359 120.798 529.637 120.736 529.904 120.736C530.186 120.736 530.438 120.793 530.66 120.907C530.882 121.018 531.056 121.2 531.182 121.452C531.311 121.704 531.375 122.041 531.375 122.464V125.695H530.655ZM483.834 134.695V128.035H484.563V134.695H483.834ZM486.012 134.695V129.813H486.619L486.669 130.362H486.718C486.916 130.161 487.147 130.006 487.411 129.898C487.675 129.79 487.956 129.736 488.253 129.736C488.559 129.736 488.829 129.793 489.063 129.907C489.3 130.018 489.484 130.201 489.616 130.456C489.751 130.708 489.819 131.046 489.819 131.469V134.695H489.103V131.5C489.103 131.08 489.01 130.789 488.824 130.627C488.641 130.462 488.392 130.38 488.077 130.38C487.933 130.38 487.78 130.401 487.618 130.443C487.456 130.485 487.297 130.554 487.141 130.65C486.988 130.746 486.852 130.873 486.732 131.032V134.695H486.012ZM492.99 134.781C492.492 134.781 492.105 134.653 491.829 134.398C491.553 134.14 491.415 133.729 491.415 133.165V129.813L491.532 128.035H492.135V133.048C492.135 133.459 492.219 133.747 492.387 133.912C492.558 134.077 492.811 134.16 493.147 134.16C493.237 134.16 493.33 134.154 493.426 134.142C493.522 134.127 493.627 134.107 493.741 134.083V134.691C493.621 134.721 493.498 134.743 493.372 134.758C493.246 134.773 493.119 134.781 492.99 134.781ZM490.497 130.407V129.813H493.669V130.407H490.497ZM496.497 134.781C495.99 134.781 495.564 134.695 495.219 134.524C494.877 134.35 494.619 134.079 494.445 133.71C494.271 133.338 494.184 132.852 494.184 132.252C494.184 131.679 494.263 131.206 494.422 130.834C494.584 130.462 494.812 130.186 495.106 130.006C495.403 129.826 495.754 129.736 496.159 129.736C496.558 129.736 496.897 129.828 497.176 130.011C497.458 130.191 497.673 130.468 497.82 130.843C497.967 131.215 498.04 131.691 498.04 132.27V132.49H494.575V132H497.509L497.352 132.108C497.352 131.652 497.304 131.289 497.208 131.019C497.115 130.749 496.978 130.555 496.798 130.438C496.621 130.318 496.405 130.258 496.15 130.258C495.898 130.258 495.679 130.317 495.493 130.434C495.307 130.551 495.163 130.744 495.061 131.014C494.962 131.284 494.913 131.649 494.913 132.108V132.36C494.913 132.81 494.973 133.17 495.093 133.44C495.216 133.707 495.4 133.9 495.646 134.02C495.892 134.137 496.204 134.196 496.582 134.196C496.768 134.196 496.96 134.179 497.158 134.146C497.359 134.11 497.572 134.061 497.797 133.998V134.587C497.563 134.653 497.34 134.701 497.127 134.731C496.917 134.764 496.707 134.781 496.497 134.781ZM500.566 136.765C500.341 136.765 500.1 136.746 499.842 136.707C499.587 136.671 499.348 136.617 499.126 136.545V135.942C499.381 136.02 499.624 136.077 499.855 136.113C500.089 136.152 500.313 136.171 500.526 136.171C501.054 136.171 501.444 136.057 501.696 135.829C501.948 135.604 502.074 135.213 502.074 134.655V134.178H502.033C501.886 134.349 501.697 134.488 501.466 134.596C501.238 134.704 500.977 134.758 500.683 134.758C500.344 134.758 500.034 134.68 499.752 134.524C499.47 134.365 499.243 134.11 499.072 133.759C498.901 133.405 498.816 132.936 498.816 132.351C498.816 131.475 499.024 130.821 499.441 130.389C499.861 129.954 500.478 129.736 501.291 129.736C501.459 129.736 501.63 129.745 501.804 129.763C501.981 129.781 502.153 129.807 502.321 129.84C502.489 129.873 502.647 129.912 502.794 129.957V134.547C502.794 135.339 502.608 135.906 502.236 136.248C501.864 136.593 501.307 136.765 500.566 136.765ZM500.895 134.142C501.114 134.142 501.328 134.095 501.538 134.002C501.751 133.909 501.93 133.767 502.074 133.575V130.425C501.966 130.398 501.838 130.375 501.691 130.357C501.544 130.336 501.391 130.326 501.232 130.326C500.686 130.326 500.269 130.479 499.981 130.785C499.693 131.088 499.549 131.587 499.549 132.283C499.549 132.766 499.608 133.143 499.725 133.413C499.842 133.683 500.001 133.872 500.202 133.98C500.406 134.088 500.637 134.142 500.895 134.142ZM504.152 134.695V129.813H504.755L504.814 130.465H504.859C505.027 130.234 505.237 130.06 505.489 129.943C505.744 129.823 506.009 129.763 506.285 129.763C506.36 129.763 506.428 129.766 506.488 129.772C506.551 129.778 506.612 129.787 506.672 129.799V130.465C506.603 130.453 506.534 130.446 506.465 130.443C506.399 130.44 506.327 130.438 506.249 130.438C506.09 130.438 505.924 130.464 505.75 130.515C505.579 130.563 505.417 130.639 505.264 130.744C505.111 130.846 504.98 130.975 504.872 131.131V134.695H504.152ZM508.456 134.776C507.997 134.776 507.636 134.658 507.372 134.421C507.111 134.184 506.98 133.858 506.98 133.444C506.98 133.018 507.12 132.687 507.399 132.45C507.681 132.21 508.132 132.06 508.753 132L510.063 131.86L510.13 132.337L508.798 132.481C508.411 132.52 508.132 132.615 507.961 132.765C507.793 132.912 507.709 133.116 507.709 133.377C507.709 133.65 507.787 133.858 507.943 134.002C508.099 134.146 508.332 134.218 508.641 134.218C508.854 134.218 509.068 134.173 509.284 134.083C509.5 133.99 509.694 133.836 509.865 133.62V131.464C509.865 131.164 509.818 130.933 509.725 130.771C509.632 130.606 509.493 130.491 509.307 130.425C509.121 130.359 508.887 130.326 508.605 130.326C508.422 130.326 508.213 130.342 507.979 130.375C507.748 130.408 507.517 130.464 507.286 130.542V129.952C507.496 129.883 507.727 129.831 507.979 129.795C508.234 129.756 508.474 129.736 508.699 129.736C509.113 129.736 509.458 129.79 509.734 129.898C510.013 130.006 510.222 130.189 510.36 130.447C510.501 130.702 510.571 131.052 510.571 131.496V134.695H509.968L509.914 134.151H509.869C509.71 134.352 509.506 134.506 509.257 134.614C509.011 134.722 508.744 134.776 508.456 134.776ZM513.741 134.781C513.243 134.781 512.856 134.653 512.58 134.398C512.304 134.14 512.166 133.729 512.166 133.165V129.813L512.283 128.035H512.886V133.048C512.886 133.459 512.97 133.747 513.138 133.912C513.309 134.077 513.562 134.16 513.898 134.16C513.988 134.16 514.081 134.154 514.177 134.142C514.273 134.127 514.378 134.107 514.492 134.083V134.691C514.372 134.721 514.249 134.743 514.123 134.758C513.997 134.773 513.87 134.781 513.741 134.781ZM511.248 130.407V129.813H514.42V130.407H511.248ZM515.262 134.695V129.813H515.982V134.695H515.262ZM515.622 128.751C515.46 128.751 515.335 128.712 515.248 128.634C515.164 128.553 515.122 128.442 515.122 128.301C515.122 128.157 515.164 128.044 515.248 127.963C515.335 127.882 515.46 127.842 515.622 127.842C515.784 127.842 515.907 127.882 515.991 127.963C516.078 128.044 516.121 128.157 516.121 128.301C516.121 128.442 516.078 128.553 515.991 128.634C515.907 128.712 515.784 128.751 515.622 128.751ZM519.167 134.781C518.747 134.781 518.381 134.694 518.069 134.52C517.757 134.343 517.516 134.07 517.345 133.701C517.174 133.329 517.088 132.847 517.088 132.256C517.088 131.671 517.172 131.193 517.34 130.821C517.511 130.449 517.753 130.176 518.065 130.002C518.377 129.825 518.744 129.736 519.167 129.736C519.59 129.736 519.958 129.825 520.27 130.002C520.582 130.176 520.822 130.449 520.99 130.821C521.161 131.19 521.246 131.668 521.246 132.256C521.246 132.841 521.159 133.32 520.985 133.692C520.814 134.064 520.573 134.338 520.261 134.515C519.952 134.692 519.587 134.781 519.167 134.781ZM519.167 134.196C519.443 134.196 519.682 134.136 519.883 134.016C520.084 133.896 520.238 133.696 520.346 133.417C520.457 133.135 520.513 132.753 520.513 132.27C520.513 131.778 520.457 131.391 520.346 131.109C520.238 130.824 520.082 130.623 519.878 130.506C519.677 130.386 519.44 130.326 519.167 130.326C518.891 130.326 518.653 130.386 518.452 130.506C518.251 130.623 518.095 130.822 517.984 131.104C517.876 131.383 517.822 131.764 517.822 132.247C517.822 132.736 517.876 133.123 517.984 133.408C518.095 133.69 518.251 133.893 518.452 134.016C518.653 134.136 518.891 134.196 519.167 134.196ZM522.346 134.695V129.813H522.953L523.003 130.362H523.052C523.25 130.161 523.481 130.006 523.745 129.898C524.009 129.79 524.29 129.736 524.587 129.736C524.893 129.736 525.163 129.793 525.397 129.907C525.634 130.018 525.818 130.201 525.95 130.456C526.085 130.708 526.153 131.046 526.153 131.469V134.695H525.437V131.5C525.437 131.08 525.344 130.789 525.158 130.627C524.975 130.462 524.726 130.38 524.411 130.38C524.267 130.38 524.114 130.401 523.952 130.443C523.79 130.485 523.631 130.554 523.475 130.65C523.322 130.746 523.186 130.873 523.066 131.032V134.695H522.346Z",
    fill: "#003087"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M522.48 176.637V170.076C522.756 170.022 523.032 169.98 523.308 169.95C523.587 169.92 523.881 169.905 524.19 169.905C525.069 169.905 525.734 170.088 526.184 170.454C526.637 170.817 526.863 171.391 526.863 172.177C526.863 172.915 526.638 173.479 526.188 173.869C525.741 174.259 525.041 174.454 524.087 174.454C523.931 174.454 523.784 174.451 523.646 174.445C523.511 174.436 523.365 174.426 523.209 174.414V176.637H522.48ZM524.1 173.86C524.817 173.86 525.336 173.724 525.657 173.451C525.978 173.175 526.139 172.755 526.139 172.191C526.139 171.6 525.981 171.171 525.666 170.904C525.354 170.634 524.879 170.499 524.24 170.499C524.045 170.499 523.863 170.506 523.695 170.521C523.53 170.533 523.368 170.553 523.209 170.58V173.806C523.356 173.827 523.5 173.842 523.641 173.851C523.785 173.857 523.938 173.86 524.1 173.86ZM529.697 176.722C529.277 176.722 528.911 176.635 528.599 176.461C528.287 176.284 528.046 176.011 527.875 175.642C527.704 175.27 527.618 174.789 527.618 174.198C527.618 173.613 527.702 173.134 527.87 172.762C528.041 172.39 528.283 172.117 528.595 171.943C528.907 171.766 529.274 171.678 529.697 171.678C530.12 171.678 530.488 171.766 530.8 171.943C531.112 172.117 531.352 172.39 531.52 172.762C531.691 173.131 531.776 173.61 531.776 174.198C531.776 174.783 531.689 175.261 531.515 175.633C531.344 176.005 531.103 176.28 530.791 176.457C530.482 176.634 530.117 176.722 529.697 176.722ZM529.697 176.137C529.973 176.137 530.212 176.077 530.413 175.957C530.614 175.837 530.768 175.638 530.876 175.359C530.987 175.077 531.043 174.694 531.043 174.211C531.043 173.719 530.987 173.332 530.876 173.05C530.768 172.765 530.612 172.564 530.408 172.447C530.207 172.327 529.97 172.267 529.697 172.267C529.421 172.267 529.183 172.327 528.982 172.447C528.781 172.564 528.625 172.764 528.514 173.046C528.406 173.325 528.352 173.706 528.352 174.189C528.352 174.678 528.406 175.065 528.514 175.35C528.625 175.632 528.781 175.834 528.982 175.957C529.183 176.077 529.421 176.137 529.697 176.137ZM533.792 176.637L532.361 171.754H533.067L534.287 176.011H534.215L535.488 171.754H536.339L537.612 176.011H537.531L538.755 171.754H539.435L538.013 176.637H537.162L535.866 172.33H535.947L534.642 176.637H533.792ZM542.421 176.722C541.914 176.722 541.488 176.637 541.143 176.466C540.801 176.292 540.543 176.02 540.369 175.651C540.195 175.279 540.108 174.793 540.108 174.193C540.108 173.62 540.187 173.148 540.346 172.776C540.508 172.404 540.736 172.128 541.03 171.948C541.327 171.768 541.678 171.678 542.083 171.678C542.482 171.678 542.821 171.769 543.1 171.952C543.382 172.132 543.597 172.41 543.744 172.785C543.891 173.157 543.964 173.632 543.964 174.211V174.432H540.499V173.941H543.433L543.276 174.049C543.276 173.593 543.228 173.23 543.132 172.96C543.039 172.69 542.902 172.497 542.722 172.38C542.545 172.26 542.329 172.2 542.074 172.2C541.822 172.2 541.603 172.258 541.417 172.375C541.231 172.492 541.087 172.686 540.985 172.956C540.886 173.226 540.837 173.59 540.837 174.049V174.301C540.837 174.751 540.897 175.111 541.017 175.381C541.14 175.648 541.324 175.842 541.57 175.962C541.816 176.079 542.128 176.137 542.506 176.137C542.692 176.137 542.884 176.121 543.082 176.088C543.283 176.052 543.496 176.002 543.721 175.939V176.529C543.487 176.595 543.264 176.643 543.051 176.673C542.841 176.706 542.631 176.722 542.421 176.722ZM544.996 176.637V171.754H545.599L545.657 172.407H545.702C545.87 172.176 546.08 172.002 546.332 171.885C546.587 171.765 546.853 171.705 547.129 171.705C547.204 171.705 547.271 171.708 547.331 171.714C547.394 171.72 547.456 171.729 547.516 171.741V172.407C547.447 172.395 547.378 172.387 547.309 172.384C547.243 172.381 547.171 172.38 547.093 172.38C546.934 172.38 546.767 172.405 546.593 172.456C546.422 172.504 546.26 172.581 546.107 172.686C545.954 172.788 545.824 172.917 545.716 173.073V176.637H544.996ZM550.544 176.637V169.977H551.413L553.82 175.147H553.663L556.039 169.977H556.907V176.637H556.219V170.611H556.426L554.054 175.714H553.397L550.999 170.611H551.233V176.637H550.544ZM559.575 176.718C559.116 176.718 558.754 176.599 558.49 176.362C558.229 176.125 558.099 175.8 558.099 175.386C558.099 174.96 558.238 174.628 558.517 174.391C558.799 174.151 559.251 174.001 559.872 173.941L561.181 173.802L561.249 174.279L559.917 174.423C559.53 174.462 559.251 174.556 559.08 174.706C558.912 174.853 558.828 175.057 558.828 175.318C558.828 175.591 558.906 175.8 559.062 175.944C559.218 176.088 559.45 176.16 559.759 176.16C559.972 176.16 560.187 176.115 560.403 176.025C560.619 175.932 560.812 175.777 560.983 175.561V173.406C560.983 173.106 560.937 172.875 560.844 172.713C560.751 172.548 560.611 172.432 560.425 172.366C560.239 172.3 560.005 172.267 559.723 172.267C559.54 172.267 559.332 172.284 559.098 172.317C558.867 172.35 558.636 172.405 558.405 172.483V171.894C558.615 171.825 558.846 171.772 559.098 171.736C559.353 171.697 559.593 171.678 559.818 171.678C560.232 171.678 560.577 171.732 560.853 171.84C561.132 171.948 561.34 172.131 561.478 172.389C561.619 172.644 561.69 172.993 561.69 173.437V176.637H561.087L561.033 176.092H560.988C560.829 176.293 560.625 176.448 560.376 176.556C560.13 176.664 559.863 176.718 559.575 176.718ZM562.996 176.637V171.754H563.603L563.653 172.303H563.702C563.9 172.102 564.131 171.948 564.395 171.84C564.659 171.732 564.94 171.678 565.237 171.678C565.543 171.678 565.813 171.735 566.047 171.849C566.284 171.96 566.468 172.143 566.6 172.398C566.735 172.65 566.803 172.987 566.803 173.41V176.637H566.087V173.442C566.087 173.022 565.994 172.731 565.808 172.569C565.625 172.404 565.376 172.321 565.061 172.321C564.917 172.321 564.764 172.342 564.602 172.384C564.44 172.426 564.281 172.495 564.125 172.591C563.972 172.687 563.836 172.815 563.716 172.974V176.637H562.996ZM569.322 176.718C568.863 176.718 568.501 176.599 568.237 176.362C567.976 176.125 567.846 175.8 567.846 175.386C567.846 174.96 567.985 174.628 568.264 174.391C568.546 174.151 568.998 174.001 569.619 173.941L570.928 173.802L570.996 174.279L569.664 174.423C569.277 174.462 568.998 174.556 568.827 174.706C568.659 174.853 568.575 175.057 568.575 175.318C568.575 175.591 568.653 175.8 568.809 175.944C568.965 176.088 569.197 176.16 569.506 176.16C569.719 176.16 569.934 176.115 570.15 176.025C570.366 175.932 570.559 175.777 570.73 175.561V173.406C570.73 173.106 570.684 172.875 570.591 172.713C570.498 172.548 570.358 172.432 570.172 172.366C569.986 172.3 569.752 172.267 569.47 172.267C569.287 172.267 569.079 172.284 568.845 172.317C568.614 172.35 568.383 172.405 568.152 172.483V171.894C568.362 171.825 568.593 171.772 568.845 171.736C569.1 171.697 569.34 171.678 569.565 171.678C569.979 171.678 570.324 171.732 570.6 171.84C570.879 171.948 571.087 172.131 571.225 172.389C571.366 172.644 571.437 172.993 571.437 173.437V176.637H570.834L570.78 176.092H570.735C570.576 176.293 570.372 176.448 570.123 176.556C569.877 176.664 569.61 176.718 569.322 176.718ZM574.237 178.707C574.012 178.707 573.77 178.687 573.512 178.648C573.257 178.612 573.019 178.558 572.797 178.486V177.883C573.052 177.961 573.295 178.018 573.526 178.054C573.76 178.093 573.983 178.113 574.196 178.113C574.724 178.113 575.114 177.999 575.366 177.771C575.618 177.546 575.744 177.154 575.744 176.596V176.119H575.704C575.557 176.29 575.368 176.43 575.137 176.538C574.909 176.646 574.648 176.7 574.354 176.7C574.015 176.7 573.704 176.622 573.422 176.466C573.14 176.307 572.914 176.052 572.743 175.701C572.572 175.347 572.486 174.877 572.486 174.292C572.486 173.416 572.695 172.762 573.112 172.33C573.532 171.895 574.148 171.678 574.961 171.678C575.129 171.678 575.3 171.687 575.474 171.705C575.651 171.723 575.824 171.748 575.992 171.781C576.16 171.814 576.317 171.853 576.464 171.898V176.488C576.464 177.28 576.278 177.847 575.906 178.189C575.534 178.534 574.978 178.707 574.237 178.707ZM574.565 176.083C574.784 176.083 574.999 176.037 575.209 175.944C575.422 175.851 575.6 175.708 575.744 175.516V172.366C575.636 172.339 575.509 172.317 575.362 172.299C575.215 172.278 575.062 172.267 574.903 172.267C574.357 172.267 573.94 172.42 573.652 172.726C573.364 173.029 573.22 173.529 573.22 174.225C573.22 174.708 573.278 175.084 573.395 175.354C573.512 175.624 573.671 175.813 573.872 175.921C574.076 176.029 574.307 176.083 574.565 176.083ZM579.88 176.722C579.373 176.722 578.947 176.637 578.602 176.466C578.26 176.292 578.002 176.02 577.828 175.651C577.654 175.279 577.567 174.793 577.567 174.193C577.567 173.62 577.646 173.148 577.805 172.776C577.967 172.404 578.195 172.128 578.489 171.948C578.786 171.768 579.137 171.678 579.542 171.678C579.941 171.678 580.28 171.769 580.559 171.952C580.841 172.132 581.056 172.41 581.203 172.785C581.35 173.157 581.423 173.632 581.423 174.211V174.432H577.958V173.941H580.892L580.735 174.049C580.735 173.593 580.687 173.23 580.591 172.96C580.498 172.69 580.361 172.497 580.181 172.38C580.004 172.26 579.788 172.2 579.533 172.2C579.281 172.2 579.062 172.258 578.876 172.375C578.69 172.492 578.546 172.686 578.444 172.956C578.345 173.226 578.296 173.59 578.296 174.049V174.301C578.296 174.751 578.356 175.111 578.476 175.381C578.599 175.648 578.783 175.842 579.029 175.962C579.275 176.079 579.587 176.137 579.965 176.137C580.151 176.137 580.343 176.121 580.541 176.088C580.742 176.052 580.955 176.002 581.18 175.939V176.529C580.946 176.595 580.723 176.643 580.51 176.673C580.3 176.706 580.09 176.722 579.88 176.722ZM582.455 176.637V171.754H583.062L583.112 172.308H583.161C583.347 172.098 583.56 171.94 583.8 171.835C584.043 171.73 584.301 171.678 584.574 171.678C584.844 171.678 585.086 171.733 585.299 171.844C585.512 171.955 585.68 172.137 585.803 172.389C585.926 172.638 585.987 172.972 585.987 173.392V176.637H585.276V173.437C585.276 173.017 585.194 172.726 585.029 172.564C584.864 172.402 584.646 172.321 584.376 172.321C584.241 172.321 584.1 172.344 583.953 172.389C583.809 172.434 583.67 172.506 583.535 172.605C583.4 172.701 583.28 172.83 583.175 172.992V176.637H582.455ZM588.057 176.637V173.437C588.057 173.017 587.97 172.726 587.796 172.564C587.625 172.402 587.405 172.321 587.135 172.321C586.997 172.321 586.85 172.345 586.694 172.393C586.541 172.438 586.391 172.518 586.244 172.632C586.1 172.743 585.974 172.896 585.866 173.091L585.686 172.51C585.923 172.201 586.185 171.985 586.473 171.862C586.761 171.739 587.039 171.678 587.306 171.678C587.588 171.678 587.84 171.735 588.062 171.849C588.284 171.96 588.458 172.141 588.584 172.393C588.713 172.645 588.777 172.983 588.777 173.406V176.637H588.057ZM592.14 176.722C591.633 176.722 591.207 176.637 590.862 176.466C590.52 176.292 590.262 176.02 590.088 175.651C589.914 175.279 589.827 174.793 589.827 174.193C589.827 173.62 589.907 173.148 590.066 172.776C590.228 172.404 590.456 172.128 590.75 171.948C591.047 171.768 591.398 171.678 591.803 171.678C592.202 171.678 592.541 171.769 592.82 171.952C593.102 172.132 593.316 172.41 593.463 172.785C593.61 173.157 593.684 173.632 593.684 174.211V174.432H590.219V173.941H593.153L592.995 174.049C592.995 173.593 592.947 173.23 592.851 172.96C592.758 172.69 592.622 172.497 592.442 172.38C592.265 172.26 592.049 172.2 591.794 172.2C591.542 172.2 591.323 172.258 591.137 172.375C590.951 172.492 590.807 172.686 590.705 172.956C590.606 173.226 590.556 173.59 590.556 174.049V174.301C590.556 174.751 590.616 175.111 590.736 175.381C590.859 175.648 591.044 175.842 591.29 175.962C591.536 176.079 591.848 176.137 592.226 176.137C592.412 176.137 592.604 176.121 592.802 176.088C593.003 176.052 593.216 176.002 593.441 175.939V176.529C593.207 176.595 592.983 176.643 592.77 176.673C592.56 176.706 592.35 176.722 592.14 176.722ZM594.716 176.637V171.754H595.323L595.373 172.303H595.422C595.62 172.102 595.851 171.948 596.115 171.84C596.379 171.732 596.66 171.678 596.957 171.678C597.263 171.678 597.533 171.735 597.767 171.849C598.004 171.96 598.188 172.143 598.32 172.398C598.455 172.65 598.523 172.987 598.523 173.41V176.637H597.807V173.442C597.807 173.022 597.714 172.731 597.528 172.569C597.345 172.404 597.096 172.321 596.781 172.321C596.637 172.321 596.484 172.342 596.322 172.384C596.16 172.426 596.001 172.495 595.845 172.591C595.692 172.687 595.556 172.815 595.436 172.974V176.637H594.716ZM601.694 176.722C601.196 176.722 600.809 176.595 600.533 176.34C600.257 176.082 600.119 175.671 600.119 175.107V171.754L600.236 169.977H600.839V174.99C600.839 175.401 600.923 175.689 601.091 175.854C601.262 176.019 601.515 176.101 601.851 176.101C601.941 176.101 602.034 176.095 602.13 176.083C602.226 176.068 602.331 176.049 602.445 176.025V176.632C602.325 176.662 602.202 176.685 602.076 176.7C601.95 176.715 601.823 176.722 601.694 176.722ZM599.201 172.348V171.754H602.373V172.348H599.201Z",
    fill: "#003087"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M592.308 238.205C592.044 238.205 591.768 238.182 591.48 238.137C591.195 238.092 590.924 238.025 590.666 237.935V237.305C590.852 237.368 591.039 237.42 591.228 237.462C591.42 237.501 591.608 237.531 591.791 237.552C591.974 237.573 592.149 237.584 592.317 237.584C592.869 237.584 593.277 237.48 593.541 237.273C593.805 237.063 593.937 236.759 593.937 236.36C593.937 236.021 593.837 235.763 593.636 235.586C593.438 235.406 593.099 235.253 592.619 235.127L592.259 235.032C591.692 234.888 591.267 234.671 590.985 234.38C590.703 234.086 590.562 233.699 590.562 233.219C590.562 232.646 590.76 232.196 591.156 231.869C591.555 231.539 592.148 231.374 592.934 231.374C593.192 231.374 593.447 231.392 593.699 231.428C593.951 231.461 594.18 231.51 594.387 231.576V232.206C594.159 232.134 593.924 232.082 593.681 232.049C593.441 232.013 593.198 231.995 592.952 231.995C592.571 231.995 592.259 232.041 592.016 232.134C591.773 232.227 591.593 232.362 591.476 232.539C591.359 232.716 591.3 232.929 591.3 233.178C591.3 233.505 591.392 233.759 591.575 233.939C591.758 234.119 592.074 234.269 592.524 234.389L592.889 234.479C593.297 234.584 593.633 234.719 593.897 234.884C594.161 235.046 594.357 235.245 594.486 235.482C594.615 235.716 594.68 235.994 594.68 236.315C594.68 236.717 594.587 237.059 594.401 237.341C594.215 237.62 593.945 237.834 593.591 237.984C593.237 238.131 592.809 238.205 592.308 238.205ZM597.198 238.2C596.895 238.2 596.626 238.145 596.392 238.034C596.158 237.923 595.974 237.741 595.839 237.489C595.704 237.237 595.636 236.9 595.636 236.477V233.237H596.356V236.445C596.356 236.862 596.449 237.153 596.635 237.318C596.821 237.48 597.061 237.561 597.355 237.561C597.502 237.561 597.655 237.539 597.814 237.494C597.976 237.449 598.132 237.378 598.282 237.282C598.432 237.186 598.566 237.062 598.683 236.909V233.237H599.403V238.119H598.795L598.746 237.584H598.701C598.497 237.788 598.266 237.942 598.008 238.047C597.75 238.149 597.48 238.2 597.198 238.2ZM601.927 238.205C601.681 238.205 601.446 238.188 601.221 238.155C600.999 238.122 600.783 238.073 600.573 238.007V237.431C600.813 237.503 601.042 237.555 601.261 237.588C601.48 237.618 601.702 237.633 601.927 237.633C602.35 237.633 602.656 237.561 602.845 237.417C603.037 237.273 603.133 237.071 603.133 236.81C603.133 236.588 603.076 236.418 602.962 236.301C602.848 236.181 602.655 236.093 602.382 236.036L601.72 235.901C601.276 235.805 600.958 235.647 600.766 235.428C600.577 235.206 600.483 234.921 600.483 234.573C600.483 234.162 600.64 233.825 600.955 233.561C601.273 233.294 601.761 233.16 602.418 233.16C602.628 233.16 602.827 233.172 603.016 233.196C603.208 233.22 603.393 233.256 603.57 233.304V233.885C603.372 233.831 603.181 233.792 602.998 233.768C602.818 233.744 602.629 233.732 602.431 233.732C602.122 233.732 601.875 233.769 601.689 233.844C601.506 233.916 601.374 234.015 601.293 234.141C601.212 234.264 601.171 234.402 601.171 234.555C601.171 234.747 601.225 234.906 601.333 235.032C601.441 235.158 601.63 235.251 601.9 235.311L602.562 235.446C603.012 235.539 603.334 235.692 603.529 235.905C603.727 236.118 603.826 236.408 603.826 236.774C603.826 237.215 603.664 237.564 603.34 237.822C603.019 238.077 602.548 238.205 601.927 238.205ZM606.624 238.205C606.126 238.205 605.739 238.077 605.463 237.822C605.187 237.564 605.049 237.153 605.049 236.589V233.237L605.166 231.459H605.769V236.472C605.769 236.883 605.853 237.171 606.021 237.336C606.192 237.501 606.445 237.584 606.781 237.584C606.871 237.584 606.964 237.578 607.06 237.566C607.156 237.551 607.261 237.531 607.375 237.507V238.115C607.255 238.145 607.132 238.167 607.006 238.182C606.88 238.197 606.753 238.205 606.624 238.205ZM604.131 233.831V233.237H607.303V233.831H604.131ZM609.337 238.2C608.878 238.2 608.517 238.082 608.253 237.845C607.992 237.608 607.861 237.282 607.861 236.868C607.861 236.442 608.001 236.111 608.28 235.874C608.562 235.634 609.013 235.484 609.634 235.424L610.944 235.284L611.011 235.761L609.679 235.905C609.292 235.944 609.013 236.039 608.842 236.189C608.674 236.336 608.59 236.54 608.59 236.801C608.59 237.074 608.668 237.282 608.824 237.426C608.98 237.57 609.213 237.642 609.522 237.642C609.735 237.642 609.949 237.597 610.165 237.507C610.381 237.414 610.575 237.26 610.746 237.044V234.888C610.746 234.588 610.699 234.357 610.606 234.195C610.513 234.03 610.374 233.915 610.188 233.849C610.002 233.783 609.768 233.75 609.486 233.75C609.303 233.75 609.094 233.766 608.86 233.799C608.629 233.832 608.398 233.888 608.167 233.966V233.376C608.377 233.307 608.608 233.255 608.86 233.219C609.115 233.18 609.355 233.16 609.58 233.16C609.994 233.16 610.339 233.214 610.615 233.322C610.894 233.43 611.103 233.613 611.241 233.871C611.382 234.126 611.452 234.476 611.452 234.92V238.119H610.849L610.795 237.575H610.75C610.591 237.776 610.387 237.93 610.138 238.038C609.892 238.146 609.625 238.2 609.337 238.2ZM612.759 238.119V233.237H613.479V238.119H612.759ZM613.119 232.175C612.957 232.175 612.832 232.136 612.745 232.058C612.661 231.977 612.619 231.866 612.619 231.725C612.619 231.581 612.661 231.468 612.745 231.387C612.832 231.306 612.957 231.266 613.119 231.266C613.281 231.266 613.404 231.306 613.488 231.387C613.575 231.468 613.618 231.581 613.618 231.725C613.618 231.866 613.575 231.977 613.488 232.058C613.404 232.136 613.281 232.175 613.119 232.175ZM614.842 238.119V233.237H615.449L615.499 233.786H615.548C615.746 233.585 615.977 233.43 616.241 233.322C616.505 233.214 616.786 233.16 617.083 233.16C617.389 233.16 617.659 233.217 617.893 233.331C618.13 233.442 618.314 233.625 618.446 233.88C618.581 234.132 618.649 234.47 618.649 234.893V238.119H617.933V234.924C617.933 234.504 617.84 234.213 617.654 234.051C617.471 233.886 617.222 233.804 616.907 233.804C616.763 233.804 616.61 233.825 616.448 233.867C616.286 233.909 616.127 233.978 615.971 234.074C615.818 234.17 615.682 234.297 615.562 234.456V238.119H614.842ZM621.167 238.2C620.708 238.2 620.347 238.082 620.083 237.845C619.822 237.608 619.691 237.282 619.691 236.868C619.691 236.442 619.831 236.111 620.11 235.874C620.392 235.634 620.843 235.484 621.464 235.424L622.774 235.284L622.841 235.761L621.509 235.905C621.122 235.944 620.843 236.039 620.672 236.189C620.504 236.336 620.42 236.54 620.42 236.801C620.42 237.074 620.498 237.282 620.654 237.426C620.81 237.57 621.043 237.642 621.352 237.642C621.565 237.642 621.779 237.597 621.995 237.507C622.211 237.414 622.405 237.26 622.576 237.044V234.888C622.576 234.588 622.529 234.357 622.436 234.195C622.343 234.03 622.204 233.915 622.018 233.849C621.832 233.783 621.598 233.75 621.316 233.75C621.133 233.75 620.924 233.766 620.69 233.799C620.459 233.832 620.228 233.888 619.997 233.966V233.376C620.207 233.307 620.438 233.255 620.69 233.219C620.945 233.18 621.185 233.16 621.41 233.16C621.824 233.16 622.169 233.214 622.445 233.322C622.724 233.43 622.933 233.613 623.071 233.871C623.212 234.126 623.282 234.476 623.282 234.92V238.119H622.679L622.625 237.575H622.58C622.421 237.776 622.217 237.93 621.968 238.038C621.722 238.146 621.455 238.2 621.167 238.2ZM626.096 238.205C625.841 238.205 625.583 238.185 625.322 238.146C625.061 238.11 624.817 238.056 624.589 237.984V230.847H625.309V233.741H625.349C625.499 233.57 625.688 233.43 625.916 233.322C626.147 233.214 626.41 233.16 626.704 233.16C627.043 233.16 627.353 233.24 627.635 233.399C627.917 233.555 628.142 233.811 628.31 234.168C628.481 234.522 628.567 234.995 628.567 235.586C628.567 236.468 628.357 237.125 627.937 237.557C627.52 237.989 626.906 238.205 626.096 238.205ZM626.15 237.615C626.702 237.615 627.121 237.462 627.406 237.156C627.691 236.85 627.833 236.348 627.833 235.649C627.833 235.163 627.775 234.785 627.658 234.515C627.541 234.245 627.38 234.056 627.176 233.948C626.975 233.837 626.747 233.781 626.492 233.781C626.27 233.781 626.053 233.828 625.84 233.921C625.63 234.011 625.453 234.153 625.309 234.348V237.507C625.417 237.537 625.544 237.563 625.691 237.584C625.841 237.605 625.994 237.615 626.15 237.615ZM629.651 238.119V233.237H630.371V238.119H629.651ZM630.011 232.175C629.849 232.175 629.725 232.136 629.638 232.058C629.554 231.977 629.512 231.866 629.512 231.725C629.512 231.581 629.554 231.468 629.638 231.387C629.725 231.306 629.849 231.266 630.011 231.266C630.173 231.266 630.296 231.306 630.38 231.387C630.467 231.468 630.511 231.581 630.511 231.725C630.511 231.866 630.467 231.977 630.38 232.058C630.296 232.136 630.173 232.175 630.011 232.175ZM631.734 238.119V230.847H632.454V238.119H631.734ZM633.817 238.119V233.237H634.537V238.119H633.817ZM634.177 232.175C634.015 232.175 633.891 232.136 633.804 232.058C633.72 231.977 633.678 231.866 633.678 231.725C633.678 231.581 633.72 231.468 633.804 231.387C633.891 231.306 634.015 231.266 634.177 231.266C634.339 231.266 634.462 231.306 634.546 231.387C634.633 231.468 634.677 231.581 634.677 231.725C634.677 231.866 634.633 231.977 634.546 232.058C634.462 232.136 634.339 232.175 634.177 232.175ZM637.763 238.205C637.265 238.205 636.878 238.077 636.602 237.822C636.326 237.564 636.188 237.153 636.188 236.589V233.237L636.305 231.459H636.908V236.472C636.908 236.883 636.992 237.171 637.16 237.336C637.331 237.501 637.585 237.584 637.921 237.584C638.011 237.584 638.104 237.578 638.2 237.566C638.296 237.551 638.401 237.531 638.515 237.507V238.115C638.395 238.145 638.272 238.167 638.146 238.182C638.02 238.197 637.892 238.205 637.763 238.205ZM635.27 233.831V233.237H638.443V233.831H635.27ZM639.74 240.099L640.491 238.119L640.721 237.602L642.332 233.237H643.056L640.46 240.099H639.74ZM640.284 238.119L638.435 233.237H639.204L640.973 238.119H640.284ZM590.99 247.119V240.459H595.076V241.085H591.719V247.119H590.99ZM591.503 244.068V243.447H594.639V244.068H591.503ZM597.694 247.205C597.187 247.205 596.761 247.119 596.416 246.948C596.074 246.774 595.816 246.503 595.642 246.134C595.468 245.762 595.381 245.276 595.381 244.676C595.381 244.103 595.461 243.63 595.62 243.258C595.782 242.886 596.01 242.61 596.304 242.43C596.601 242.25 596.952 242.16 597.357 242.16C597.756 242.16 598.095 242.252 598.374 242.435C598.656 242.615 598.87 242.892 599.017 243.267C599.164 243.639 599.238 244.115 599.238 244.694V244.914H595.773V244.424H598.707L598.549 244.532C598.549 244.076 598.501 243.713 598.405 243.443C598.312 243.173 598.176 242.979 597.996 242.862C597.819 242.742 597.603 242.682 597.348 242.682C597.096 242.682 596.877 242.741 596.691 242.858C596.505 242.975 596.361 243.168 596.259 243.438C596.16 243.708 596.11 244.073 596.11 244.532V244.784C596.11 245.234 596.17 245.594 596.29 245.864C596.413 246.131 596.598 246.324 596.844 246.444C597.09 246.561 597.402 246.62 597.78 246.62C597.966 246.62 598.158 246.603 598.356 246.57C598.557 246.534 598.77 246.485 598.995 246.422V247.011C598.761 247.077 598.537 247.125 598.324 247.155C598.114 247.188 597.904 247.205 597.694 247.205ZM601.445 247.2C600.986 247.2 600.624 247.082 600.36 246.845C600.099 246.608 599.969 246.282 599.969 245.868C599.969 245.442 600.108 245.111 600.387 244.874C600.669 244.634 601.121 244.484 601.742 244.424L603.051 244.284L603.119 244.761L601.787 244.905C601.4 244.944 601.121 245.039 600.95 245.189C600.782 245.336 600.698 245.54 600.698 245.801C600.698 246.074 600.776 246.282 600.932 246.426C601.088 246.57 601.32 246.642 601.629 246.642C601.842 246.642 602.057 246.597 602.273 246.507C602.489 246.414 602.682 246.26 602.853 246.044V243.888C602.853 243.588 602.807 243.357 602.714 243.195C602.621 243.03 602.481 242.915 602.295 242.849C602.109 242.783 601.875 242.75 601.593 242.75C601.41 242.75 601.202 242.766 600.968 242.799C600.737 242.832 600.506 242.888 600.275 242.966V242.376C600.485 242.307 600.716 242.255 600.968 242.219C601.223 242.18 601.463 242.16 601.688 242.16C602.102 242.16 602.447 242.214 602.723 242.322C603.002 242.43 603.21 242.613 603.348 242.871C603.489 243.126 603.56 243.476 603.56 243.92V247.119H602.957L602.903 246.575H602.858C602.699 246.776 602.495 246.93 602.246 247.038C602 247.146 601.733 247.2 601.445 247.2ZM606.729 247.205C606.231 247.205 605.844 247.077 605.568 246.822C605.292 246.564 605.154 246.153 605.154 245.589V242.237L605.271 240.459H605.874V245.472C605.874 245.883 605.958 246.171 606.126 246.336C606.297 246.501 606.551 246.584 606.887 246.584C606.977 246.584 607.07 246.578 607.166 246.566C607.262 246.551 607.367 246.531 607.481 246.507V247.115C607.361 247.145 607.238 247.167 607.112 247.182C606.986 247.197 606.858 247.205 606.729 247.205ZM604.236 242.831V242.237H607.409V242.831H604.236ZM609.74 247.2C609.437 247.2 609.168 247.145 608.934 247.034C608.7 246.923 608.516 246.741 608.381 246.489C608.246 246.237 608.178 245.9 608.178 245.477V242.237H608.898V245.445C608.898 245.862 608.991 246.153 609.177 246.318C609.363 246.48 609.603 246.561 609.897 246.561C610.044 246.561 610.197 246.539 610.356 246.494C610.518 246.449 610.674 246.378 610.824 246.282C610.974 246.186 611.108 246.062 611.225 245.909V242.237H611.945V247.119H611.337L611.288 246.584H611.243C611.039 246.788 610.808 246.942 610.55 247.047C610.292 247.149 610.022 247.2 609.74 247.2ZM613.304 247.119V242.237H613.907L613.965 242.889H614.01C614.178 242.658 614.388 242.484 614.64 242.367C614.895 242.247 615.161 242.187 615.437 242.187C615.512 242.187 615.579 242.19 615.639 242.196C615.702 242.202 615.764 242.211 615.824 242.223V242.889C615.755 242.877 615.686 242.87 615.617 242.867C615.551 242.864 615.479 242.862 615.401 242.862C615.242 242.862 615.075 242.888 614.901 242.939C614.73 242.987 614.568 243.063 614.415 243.168C614.262 243.27 614.132 243.399 614.024 243.555V247.119H613.304ZM618.489 247.205C617.982 247.205 617.556 247.119 617.211 246.948C616.869 246.774 616.611 246.503 616.437 246.134C616.263 245.762 616.176 245.276 616.176 244.676C616.176 244.103 616.255 243.63 616.414 243.258C616.576 242.886 616.804 242.61 617.098 242.43C617.395 242.25 617.746 242.16 618.151 242.16C618.55 242.16 618.889 242.252 619.168 242.435C619.45 242.615 619.665 242.892 619.812 243.267C619.959 243.639 620.032 244.115 620.032 244.694V244.914H616.567V244.424H619.501L619.344 244.532C619.344 244.076 619.296 243.713 619.2 243.443C619.107 243.173 618.97 242.979 618.79 242.862C618.613 242.742 618.397 242.682 618.142 242.682C617.89 242.682 617.671 242.741 617.485 242.858C617.299 242.975 617.155 243.168 617.053 243.438C616.954 243.708 616.905 244.073 616.905 244.532V244.784C616.905 245.234 616.965 245.594 617.085 245.864C617.208 246.131 617.392 246.324 617.638 246.444C617.884 246.561 618.196 246.62 618.574 246.62C618.76 246.62 618.952 246.603 619.15 246.57C619.351 246.534 619.564 246.485 619.789 246.422V247.011C619.555 247.077 619.332 247.125 619.119 247.155C618.909 247.188 618.699 247.205 618.489 247.205ZM622.23 247.205C621.984 247.205 621.748 247.188 621.523 247.155C621.301 247.122 621.085 247.073 620.875 247.007V246.431C621.115 246.503 621.345 246.555 621.564 246.588C621.783 246.618 622.005 246.633 622.23 246.633C622.653 246.633 622.959 246.561 623.148 246.417C623.34 246.273 623.436 246.071 623.436 245.81C623.436 245.588 623.379 245.418 623.265 245.301C623.151 245.181 622.957 245.093 622.684 245.036L622.023 244.901C621.579 244.805 621.261 244.647 621.069 244.428C620.88 244.206 620.785 243.921 620.785 243.573C620.785 243.162 620.943 242.825 621.258 242.561C621.576 242.294 622.063 242.16 622.72 242.16C622.93 242.16 623.13 242.172 623.319 242.196C623.511 242.22 623.695 242.256 623.872 242.304V242.885C623.674 242.831 623.484 242.792 623.301 242.768C623.121 242.744 622.932 242.732 622.734 242.732C622.425 242.732 622.177 242.769 621.991 242.844C621.808 242.916 621.676 243.015 621.595 243.141C621.514 243.264 621.474 243.402 621.474 243.555C621.474 243.747 621.528 243.906 621.636 244.032C621.744 244.158 621.933 244.251 622.203 244.311L622.864 244.446C623.314 244.539 623.637 244.692 623.832 244.905C624.03 245.118 624.129 245.408 624.129 245.774C624.129 246.215 623.967 246.564 623.643 246.822C623.322 247.077 622.851 247.205 622.23 247.205Z",
    fill: "#003087"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 508.011,
    y: 287.007,
    width: 56.3632,
    height: 2.22486,
    fill: "#003087"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1010_30625",
    x1: 422.857,
    y1: 199.397,
    x2: 471.584,
    y2: 199.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1010_30625",
    x1: 422.072,
    y1: 368.291,
    x2: 422.072,
    y2: 207.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1010_30625",
    x1: 422.072,
    y1: 361.78,
    x2: 422.072,
    y2: 217.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1010_30625",
    x1: 422.072,
    y1: 361.781,
    x2: 422.072,
    y2: 217.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1010_30625",
    x1: 422.072,
    y1: 361.781,
    x2: 422.072,
    y2: 217.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1010_30625",
    x1: 422.072,
    y1: 361.78,
    x2: 422.072,
    y2: 217.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1010_30625",
    x1: 422.072,
    y1: 361.78,
    x2: 422.072,
    y2: 217.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1010_30625",
    x1: 422.072,
    y1: 361.781,
    x2: 422.072,
    y2: 217.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1010_30625",
    x1: 422.072,
    y1: 361.781,
    x2: 422.072,
    y2: 217.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1010_30625",
    x1: 422.072,
    y1: 361.781,
    x2: 422.072,
    y2: 217.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1010_30625",
    x1: 422.072,
    y1: 361.781,
    x2: 422.072,
    y2: 217.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1010_30625",
    x1: 422.072,
    y1: 361.781,
    x2: 422.072,
    y2: 217.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1010_30625",
    x1: 422.072,
    y1: 361.78,
    x2: 422.072,
    y2: 217.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1010_30625",
    x1: 454.754,
    y1: 368.291,
    x2: 454.754,
    y2: 207.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1010_30625",
    x1: 454.754,
    y1: 360.549,
    x2: 454.754,
    y2: 221.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1010_30625",
    x1: 454.754,
    y1: 360.55,
    x2: 454.754,
    y2: 221.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1010_30625",
    x1: 454.754,
    y1: 360.55,
    x2: 454.754,
    y2: 221.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1010_30625",
    x1: 454.754,
    y1: 360.55,
    x2: 454.754,
    y2: 221.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1010_30625",
    x1: 454.754,
    y1: 360.549,
    x2: 454.754,
    y2: 221.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1010_30625",
    x1: 454.754,
    y1: 360.551,
    x2: 454.754,
    y2: 221.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1010_30625",
    x1: 454.754,
    y1: 360.55,
    x2: 454.754,
    y2: 221.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1010_30625",
    x1: 454.754,
    y1: 360.55,
    x2: 454.754,
    y2: 221.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1010_30625",
    x1: 454.754,
    y1: 360.55,
    x2: 454.754,
    y2: 221.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1010_30625",
    x1: 454.754,
    y1: 360.551,
    x2: 454.754,
    y2: 221.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1010_30625",
    x1: 454.754,
    y1: 360.549,
    x2: 454.754,
    y2: 221.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1010_30625",
    x1: 454.754,
    y1: 359.072,
    x2: 454.754,
    y2: 219.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1010_30625",
    x1: 454.754,
    y1: 359.073,
    x2: 454.754,
    y2: 219.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1010_30625",
    x1: 454.754,
    y1: 359.072,
    x2: 454.754,
    y2: 219.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1010_30625",
    x1: 454.754,
    y1: 359.073,
    x2: 454.754,
    y2: 219.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1010_30625",
    x1: 454.754,
    y1: 359.071,
    x2: 454.754,
    y2: 219.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1010_30625",
    x1: 454.754,
    y1: 359.071,
    x2: 454.754,
    y2: 219.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1010_30625",
    x1: 454.754,
    y1: 359.074,
    x2: 454.754,
    y2: 219.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1010_30625",
    x1: 454.754,
    y1: 359.072,
    x2: 454.754,
    y2: 219.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1010_30625",
    x1: 454.754,
    y1: 359.072,
    x2: 454.754,
    y2: 219.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1010_30625",
    x1: 454.754,
    y1: 359.073,
    x2: 454.754,
    y2: 219.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1010_30625",
    x1: 454.754,
    y1: 359.073,
    x2: 454.754,
    y2: 219.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1010_30625",
    x1: 335,
    y1: 368.291,
    x2: 335,
    y2: 139.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#173751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3584,
    stopColor: "#1A445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5438,
    stopColor: "#205872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7312,
    stopColor: "#28758E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9184,
    stopColor: "#329AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1010_30625",
    x1: 367.64,
    y1: 368.291,
    x2: 367.64,
    y2: 130.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37ADC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    stopColor: "#40B0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2671,
    stopColor: "#58BACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#80C9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    stopColor: "#B7DEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FDF9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1010_30625",
    x1: 364.76,
    y1: 368.291,
    x2: 364.76,
    y2: 139.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1005,
    stopColor: "#1C3851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2322,
    stopColor: "#2C465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3811,
    stopColor: "#475D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5429,
    stopColor: "#6D7D90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7149,
    stopColor: "#9EA7B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    stopColor: "#D8D9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1010_30625",
    x1: 335,
    y1: 357.839,
    x2: 335,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1010_30625",
    x1: 335,
    y1: 357.84,
    x2: 335,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1010_30625",
    x1: 335,
    y1: 357.839,
    x2: 335,
    y2: 147.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1010_30625",
    x1: 335,
    y1: 357.839,
    x2: 335,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1010_30625",
    x1: 335,
    y1: 357.839,
    x2: 335,
    y2: 147.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1010_30625",
    x1: 335,
    y1: 357.841,
    x2: 335,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1010_30625",
    x1: 335,
    y1: 357.84,
    x2: 335,
    y2: 147.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1010_30625",
    x1: 335,
    y1: 357.838,
    x2: 335,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1010_30625",
    x1: 335,
    y1: 357.838,
    x2: 335,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1010_30625",
    x1: 335,
    y1: 357.84,
    x2: 335,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1010_30625",
    x1: 335,
    y1: 357.84,
    x2: 335,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1010_30625",
    x1: 335,
    y1: 357.838,
    x2: 335,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1010_30625",
    x1: 335,
    y1: 357.838,
    x2: 335,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1010_30625",
    x1: 335,
    y1: 357.84,
    x2: 335,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1010_30625",
    x1: 335,
    y1: 357.84,
    x2: 335,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1010_30625",
    x1: 335,
    y1: 357.84,
    x2: 335,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1010_30625",
    x1: 364.759,
    y1: 365.72,
    x2: 364.759,
    y2: 144.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1010_30625",
    x1: 364.759,
    y1: 365.721,
    x2: 364.759,
    y2: 144.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1010_30625",
    x1: 364.759,
    y1: 365.721,
    x2: 364.759,
    y2: 144.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1010_30625",
    x1: 364.759,
    y1: 365.721,
    x2: 364.759,
    y2: 144.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1010_30625",
    x1: 364.759,
    y1: 365.722,
    x2: 364.759,
    y2: 144.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1010_30625",
    x1: 364.759,
    y1: 365.72,
    x2: 364.759,
    y2: 144.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1010_30625",
    x1: 364.759,
    y1: 365.72,
    x2: 364.759,
    y2: 144.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1010_30625",
    x1: 364.759,
    y1: 365.721,
    x2: 364.759,
    y2: 144.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1010_30625",
    x1: 364.759,
    y1: 365.72,
    x2: 364.759,
    y2: 144.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1010_30625",
    x1: 364.759,
    y1: 365.72,
    x2: 364.759,
    y2: 144.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1010_30625",
    x1: 364.759,
    y1: 365.721,
    x2: 364.759,
    y2: 144.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1010_30625",
    x1: 364.759,
    y1: 365.72,
    x2: 364.759,
    y2: 144.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1010_30625",
    x1: 348.906,
    y1: 365.721,
    x2: 348.906,
    y2: 144.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1010_30625",
    x1: 372.1,
    y1: 365.721,
    x2: 372.1,
    y2: 144.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1010_30625",
    x1: 360.28,
    y1: 365.724,
    x2: 360.28,
    y2: 144.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1010_30625",
    x1: 380.4,
    y1: 365.724,
    x2: 380.4,
    y2: 144.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1010_30625",
    x1: 348.66,
    y1: 365.72,
    x2: 348.66,
    y2: 144.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1010_30625",
    x1: 369.226,
    y1: 365.72,
    x2: 369.226,
    y2: 144.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1010_30625",
    x1: 357.693,
    y1: 365.72,
    x2: 357.693,
    y2: 144.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1010_30625",
    x1: 378.233,
    y1: 365.72,
    x2: 378.233,
    y2: 144.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1010_30625",
    x1: 252.614,
    y1: 368.291,
    x2: 252.614,
    y2: 142.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#173751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3584,
    stopColor: "#1A445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5438,
    stopColor: "#205872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7312,
    stopColor: "#28758E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9184,
    stopColor: "#329AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1010_30625",
    x1: 285.255,
    y1: 368.292,
    x2: 285.255,
    y2: 109.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37ADC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1365,
    stopColor: "#3BAFC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#48B3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    stopColor: "#5CBBD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5673,
    stopColor: "#79C7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#9FD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8597,
    stopColor: "#CCE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1010_30625",
    x1: 282.375,
    y1: 368.29,
    x2: 282.375,
    y2: 116.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0907052,
    stopColor: "#1F3B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2387,
    stopColor: "#374F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4257,
    stopColor: "#5F7185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6443,
    stopColor: "#96A1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8866,
    stopColor: "#DCDCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1010_30625",
    x1: 266.784,
    y1: 104.968,
    x2: 279.355,
    y2: 133.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1010_30625",
    x1: 252.614,
    y1: 357.838,
    x2: 252.614,
    y2: 147.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1010_30625",
    x1: 252.614,
    y1: 357.839,
    x2: 252.614,
    y2: 147.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1010_30625",
    x1: 252.614,
    y1: 357.84,
    x2: 252.614,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1010_30625",
    x1: 252.614,
    y1: 357.84,
    x2: 252.614,
    y2: 147.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1010_30625",
    x1: 252.614,
    y1: 357.84,
    x2: 252.614,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1010_30625",
    x1: 252.614,
    y1: 357.839,
    x2: 252.614,
    y2: 147.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1010_30625",
    x1: 252.614,
    y1: 357.838,
    x2: 252.614,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1010_30625",
    x1: 252.614,
    y1: 357.839,
    x2: 252.614,
    y2: 147.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1010_30625",
    x1: 252.614,
    y1: 357.839,
    x2: 252.614,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1010_30625",
    x1: 252.614,
    y1: 357.84,
    x2: 252.614,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1010_30625",
    x1: 252.614,
    y1: 357.839,
    x2: 252.614,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1010_30625",
    x1: 252.614,
    y1: 357.839,
    x2: 252.614,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1010_30625",
    x1: 252.614,
    y1: 357.839,
    x2: 252.614,
    y2: 147.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1010_30625",
    x1: 252.614,
    y1: 357.84,
    x2: 252.614,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1010_30625",
    x1: 252.614,
    y1: 357.839,
    x2: 252.614,
    y2: 147.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1010_30625",
    x1: 252.614,
    y1: 357.84,
    x2: 252.614,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1010_30625",
    x1: 252.614,
    y1: 357.844,
    x2: 252.614,
    y2: 147.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#173C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#1B465E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1010_30625",
    x1: 282.373,
    y1: 368.675,
    x2: 282.373,
    y2: 145.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1010_30625",
    x1: 282.373,
    y1: 368.675,
    x2: 282.373,
    y2: 145.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1010_30625",
    x1: 282.373,
    y1: 368.675,
    x2: 282.373,
    y2: 145.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1010_30625",
    x1: 282.373,
    y1: 368.675,
    x2: 282.373,
    y2: 145.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1010_30625",
    x1: 282.373,
    y1: 368.676,
    x2: 282.373,
    y2: 145.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1010_30625",
    x1: 282.373,
    y1: 368.676,
    x2: 282.373,
    y2: 145.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1010_30625",
    x1: 282.373,
    y1: 368.674,
    x2: 282.373,
    y2: 145.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1010_30625",
    x1: 282.373,
    y1: 368.675,
    x2: 282.373,
    y2: 145.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1010_30625",
    x1: 282.373,
    y1: 368.675,
    x2: 282.373,
    y2: 145.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1010_30625",
    x1: 282.373,
    y1: 368.675,
    x2: 282.373,
    y2: 145.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1010_30625",
    x1: 282.373,
    y1: 368.675,
    x2: 282.373,
    y2: 145.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1010_30625",
    x1: 282.373,
    y1: 368.677,
    x2: 282.373,
    y2: 145.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1010_30625",
    x1: 282.373,
    y1: 368.675,
    x2: 282.373,
    y2: 145.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1010_30625",
    x1: 282.373,
    y1: 368.681,
    x2: 282.373,
    y2: 145.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1010_30625",
    x1: 275.775,
    y1: 368.675,
    x2: 275.775,
    y2: 145.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1010_30625",
    x1: 296.692,
    y1: 368.675,
    x2: 296.692,
    y2: 145.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1010_30625",
    x1: 268.136,
    y1: 368.679,
    x2: 268.136,
    y2: 145.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1010_30625",
    x1: 288.715,
    y1: 368.679,
    x2: 288.715,
    y2: 145.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1010_30625",
    x1: 273.556,
    y1: 368.674,
    x2: 273.556,
    y2: 145.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1010_30625",
    x1: 294.072,
    y1: 368.674,
    x2: 294.072,
    y2: 145.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16334D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#183C56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#1F546E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6846,
    stopColor: "#2A7C95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37ADC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1010_30625",
    x1: 240.513,
    y1: 196.965,
    x2: 214.846,
    y2: 175.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1010_30625",
    x1: 200.813,
    y1: 368.293,
    x2: 200.813,
    y2: 191.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1010_30625",
    x1: 200.813,
    y1: 374.096,
    x2: 200.813,
    y2: 203.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1010_30625",
    x1: 200.813,
    y1: 374.096,
    x2: 200.813,
    y2: 203.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1010_30625",
    x1: 200.813,
    y1: 374.096,
    x2: 200.813,
    y2: 203.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1010_30625",
    x1: 200.813,
    y1: 374.096,
    x2: 200.813,
    y2: 203.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1010_30625",
    x1: 200.813,
    y1: 374.096,
    x2: 200.813,
    y2: 203.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1010_30625",
    x1: 200.813,
    y1: 374.096,
    x2: 200.813,
    y2: 203.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1010_30625",
    x1: 200.813,
    y1: 374.096,
    x2: 200.813,
    y2: 203.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1010_30625",
    x1: 200.813,
    y1: 374.096,
    x2: 200.813,
    y2: 203.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1010_30625",
    x1: 200.813,
    y1: 374.097,
    x2: 200.813,
    y2: 203.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1010_30625",
    x1: 200.813,
    y1: 374.097,
    x2: 200.813,
    y2: 203.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1010_30625",
    x1: 200.813,
    y1: 374.096,
    x2: 200.813,
    y2: 203.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1010_30625",
    x1: 200.813,
    y1: 374.097,
    x2: 200.813,
    y2: 203.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1010_30625",
    x1: 200.813,
    y1: 374.095,
    x2: 200.813,
    y2: 203.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1010_30625",
    x1: 233.495,
    y1: 368.294,
    x2: 233.495,
    y2: 191.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1010_30625",
    x1: 233.493,
    y1: 364.615,
    x2: 233.493,
    y2: 201.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1010_30625",
    x1: 233.493,
    y1: 364.614,
    x2: 233.493,
    y2: 201.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_1010_30625",
    x1: 233.493,
    y1: 364.615,
    x2: 233.493,
    y2: 201.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_1010_30625",
    x1: 233.493,
    y1: 364.614,
    x2: 233.493,
    y2: 201.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_1010_30625",
    x1: 233.493,
    y1: 364.615,
    x2: 233.493,
    y2: 201.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_1010_30625",
    x1: 233.493,
    y1: 364.615,
    x2: 233.493,
    y2: 201.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_1010_30625",
    x1: 233.493,
    y1: 364.615,
    x2: 233.493,
    y2: 201.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_1010_30625",
    x1: 233.493,
    y1: 364.616,
    x2: 233.493,
    y2: 201.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_1010_30625",
    x1: 233.493,
    y1: 364.616,
    x2: 233.493,
    y2: 201.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_1010_30625",
    x1: 233.493,
    y1: 364.615,
    x2: 233.493,
    y2: 201.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1010_30625",
    x1: 233.493,
    y1: 364.615,
    x2: 233.493,
    y2: 201.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_1010_30625",
    x1: 233.493,
    y1: 364.614,
    x2: 233.493,
    y2: 201.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_1010_30625",
    x1: 233.493,
    y1: 364.615,
    x2: 233.493,
    y2: 201.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#238BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1010_30625",
    x1: 233.493,
    y1: 373.479,
    x2: 233.493,
    y2: 206.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_1010_30625",
    x1: 233.493,
    y1: 373.48,
    x2: 233.493,
    y2: 206.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_1010_30625",
    x1: 233.493,
    y1: 373.481,
    x2: 233.493,
    y2: 206.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_1010_30625",
    x1: 233.493,
    y1: 373.481,
    x2: 233.493,
    y2: 206.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_1010_30625",
    x1: 233.493,
    y1: 373.481,
    x2: 233.493,
    y2: 206.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_1010_30625",
    x1: 233.493,
    y1: 373.482,
    x2: 233.493,
    y2: 206.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1010_30625",
    x1: 233.493,
    y1: 373.479,
    x2: 233.493,
    y2: 206.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_1010_30625",
    x1: 233.493,
    y1: 373.48,
    x2: 233.493,
    y2: 206.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_1010_30625",
    x1: 233.493,
    y1: 373.478,
    x2: 233.493,
    y2: 206.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_1010_30625",
    x1: 233.493,
    y1: 373.481,
    x2: 233.493,
    y2: 206.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_1010_30625",
    x1: 233.493,
    y1: 373.479,
    x2: 233.493,
    y2: 206.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_1010_30625",
    x1: 233.493,
    y1: 373.477,
    x2: 233.493,
    y2: 206.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3251,
    stopColor: "#113A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#14445E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_1010_30625",
    x1: 301.296,
    y1: 160.316,
    x2: 269.355,
    y2: 139.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_1010_30625",
    x1: 298.796,
    y1: 180.48,
    x2: 265.243,
    y2: 158.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_1010_30625",
    x1: 383.15,
    y1: 200.693,
    x2: 345.581,
    y2: 176.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_1010_30625",
    x1: 381.188,
    y1: 221.204,
    x2: 347.63,
    y2: 199.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_1010_30625",
    x1: 376.956,
    y1: 364.165,
    x2: 376.956,
    y2: 284.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00632238,
    stopColor: "#737272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1004,
    stopColor: "#989797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2008,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3099,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7279,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_1010_30625",
    x1: 403.268,
    y1: 364.166,
    x2: 403.268,
    y2: 299.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00632238,
    stopColor: "#737272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1004,
    stopColor: "#989797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2008,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3099,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7279,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_1010_30625",
    x1: 410.848,
    y1: 331.171,
    x2: 584.388,
    y2: 331.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046313,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_1010_30625",
    x1: 351.17,
    y1: 330.568,
    x2: 584.388,
    y2: 330.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7359,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9978,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_1010_30625",
    x1: 356.062,
    y1: 338.669,
    x2: 584.389,
    y2: 338.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0614687,
    stopColor: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1885,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4875,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_1010_30625",
    x1: 203.44,
    y1: 364.167,
    x2: 203.44,
    y2: 269.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1567,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5006,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    stopColor: "#EFEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8384,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_1010_30625",
    x1: 229.751,
    y1: 364.167,
    x2: 229.751,
    y2: 285.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00632238,
    stopColor: "#737272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1004,
    stopColor: "#989797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2008,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3099,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7279,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_1010_30625",
    x1: 147.089,
    y1: 364.164,
    x2: 147.089,
    y2: 253.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00632238,
    stopColor: "#737272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1004,
    stopColor: "#989797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2008,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3099,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7279,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_1010_30625",
    x1: 150.592,
    y1: 346.187,
    x2: 195.309,
    y2: 284.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_1010_30625",
    x1: 170.326,
    y1: 369.408,
    x2: 183.307,
    y2: 346.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2107,
    stopColor: "#015976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#016682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6508,
    stopColor: "#017A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    stopColor: "#0097B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ABC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_1010_30625",
    x1: 182.683,
    y1: 352.9,
    x2: 152.036,
    y2: 330.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1616,
    stopColor: "#747373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3291,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4994,
    stopColor: "#959494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6715,
    stopColor: "#B2B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8433,
    stopColor: "#D7D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_1010_30625",
    x1: 141.676,
    y1: 364.166,
    x2: 141.676,
    y2: 298.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_1010_30625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.578 345.738) scale(7.2779 7.28802)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2245,
    stopColor: "#DDFC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#D0F15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6935,
    stopColor: "#BCE145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#9FC929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_1010_30625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.038 342.535) rotate(7.70709) scale(3.94442 2.79329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_1010_30625",
    x1: 292.294,
    y1: 364.165,
    x2: 292.294,
    y2: 224.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00632238,
    stopColor: "#737272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1004,
    stopColor: "#989797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2008,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3099,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7279,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_1010_30625",
    x1: 356.199,
    y1: 354.663,
    x2: 286.452,
    y2: 234.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00632238,
    stopColor: "#737272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1004,
    stopColor: "#989797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2008,
    stopColor: "#B8B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3099,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4293,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7279,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_1010_30625",
    x1: 308.487,
    y1: 360.857,
    x2: 311.816,
    y2: 348.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1207,
    stopColor: "#055874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#12607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3731,
    stopColor: "#266E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5018,
    stopColor: "#448297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6317,
    stopColor: "#699BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7625,
    stopColor: "#97B9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8916,
    stopColor: "#CCDDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_1010_30625",
    x1: 315.752,
    y1: 362.841,
    x2: 319.08,
    y2: 350.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1207,
    stopColor: "#055874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#12607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3731,
    stopColor: "#266E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5018,
    stopColor: "#448297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6317,
    stopColor: "#699BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7625,
    stopColor: "#97B9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8916,
    stopColor: "#CCDDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_1010_30625",
    x1: 323.02,
    y1: 364.826,
    x2: 326.348,
    y2: 352.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1207,
    stopColor: "#055874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#12607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3731,
    stopColor: "#266E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5018,
    stopColor: "#448297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6317,
    stopColor: "#699BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7625,
    stopColor: "#97B9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8916,
    stopColor: "#CCDDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_1010_30625",
    x1: 330.286,
    y1: 366.81,
    x2: 333.614,
    y2: 354.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1207,
    stopColor: "#055874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#12607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3731,
    stopColor: "#266E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5018,
    stopColor: "#448297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6317,
    stopColor: "#699BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7625,
    stopColor: "#97B9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8916,
    stopColor: "#CCDDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_1010_30625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(284.553 340.877) scale(8.27034 8.28184)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2245,
    stopColor: "#DDFC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#D0F15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6935,
    stopColor: "#BCE145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#9FC929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_1010_30625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.074 337.236) rotate(7.70712) scale(4.4823 3.17421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_1010_30625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(297.889 345.877) scale(6.61628 6.62548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2245,
    stopColor: "#DDFC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#D0F15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6935,
    stopColor: "#BCE145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#9FC929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_1010_30625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.305 342.966) rotate(7.70711) scale(3.58584 2.53936)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_1010_30625",
    x1: 478.145,
    y1: 372.284,
    x2: 495.358,
    y2: 342.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1207,
    stopColor: "#055874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#12607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3731,
    stopColor: "#266E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5018,
    stopColor: "#448297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6317,
    stopColor: "#699BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7625,
    stopColor: "#97B9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8916,
    stopColor: "#CCDDE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_1010_30625",
    x1: 405.604,
    y1: 391.957,
    x2: 372.188,
    y2: 391.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7911,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8682,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_1010_30625",
    x1: 385.49,
    y1: 373.495,
    x2: 388.752,
    y2: 382.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1217,
    stopColor: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#EEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#DAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    stopColor: "#BCF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#97F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7687,
    stopColor: "#69F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8988,
    stopColor: "#34EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_1010_30625",
    x1: 465.342,
    y1: 396.209,
    x2: 498.758,
    y2: 396.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7911,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8682,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_1010_30625",
    x1: 484.473,
    y1: 378.651,
    x2: 484.473,
    y2: 384.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1217,
    stopColor: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#EEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#DAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    stopColor: "#BCF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#97F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7687,
    stopColor: "#69F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8988,
    stopColor: "#34EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_1010_30625",
    x1: 481.184,
    y1: 378.651,
    x2: 481.184,
    y2: 384.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1217,
    stopColor: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#EEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#DAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    stopColor: "#BCF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#97F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7687,
    stopColor: "#69F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8988,
    stopColor: "#34EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_1010_30625",
    x1: 245.45,
    y1: 396.209,
    x2: 278.865,
    y2: 396.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7911,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8682,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_1010_30625",
    x1: 264.581,
    y1: 378.651,
    x2: 264.581,
    y2: 384.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1217,
    stopColor: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#EEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#DAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    stopColor: "#BCF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#97F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7687,
    stopColor: "#69F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8988,
    stopColor: "#34EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_1010_30625",
    x1: 261.292,
    y1: 378.651,
    x2: 261.292,
    y2: 384.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1217,
    stopColor: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#EEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#DAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    stopColor: "#BCF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#97F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7687,
    stopColor: "#69F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8988,
    stopColor: "#34EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_1010_30625",
    x1: 171.453,
    y1: 391.957,
    x2: 138.037,
    y2: 391.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7911,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8682,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_1010_30625",
    x1: 151.945,
    y1: 374.748,
    x2: 154.002,
    y2: 380.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1217,
    stopColor: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#EEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#DAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    stopColor: "#BCF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#97F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7687,
    stopColor: "#69F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8988,
    stopColor: "#34EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_1010_30625",
    x1: 154.564,
    y1: 374.924,
    x2: 156.505,
    y2: 380.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1217,
    stopColor: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#EEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#DAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    stopColor: "#BCF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#97F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7687,
    stopColor: "#69F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8988,
    stopColor: "#34EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_1010_30625",
    x1: 324.142,
    y1: 396.211,
    x2: 357.557,
    y2: 396.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7911,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8682,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9352,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_1010_30625",
    x1: 347.224,
    y1: 378.943,
    x2: 349.5,
    y2: 384.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1217,
    stopColor: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2479,
    stopColor: "#EEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#DAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    stopColor: "#BCF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#97F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7687,
    stopColor: "#69F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8988,
    stopColor: "#34EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05EAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_1010_30625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(498.574 343.219) scale(7.0298 7.03957)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2245,
    stopColor: "#DDFC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#D0F15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6935,
    stopColor: "#BCE145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#9FC929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_1010_30625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(499.018 340.127) rotate(7.70715) scale(3.80994 2.69808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_1010_30625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(470.485 340.877) scale(8.27036 8.28184)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2245,
    stopColor: "#DDFC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    stopColor: "#D0F15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6935,
    stopColor: "#BCE145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#9FC929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95C11F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_1010_30625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(471.008 337.236) rotate(7.70712) scale(4.4823 3.17421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_1010_30625",
    x1: 335.842,
    y1: 97.1651,
    x2: 335.842,
    y2: 291.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#215772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_1010_30625",
    x1: 229.455,
    y1: 61.4945,
    x2: 229.455,
    y2: 364.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#215772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_1010_30625",
    x1: 278.701,
    y1: 61.4945,
    x2: 278.701,
    y2: 364.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#215772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_1010_30625",
    x1: 457.15,
    y1: 120.345,
    x2: 457.15,
    y2: 364.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#175AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1367FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1367FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_1010_30625",
    x1: 425.913,
    y1: 61.4945,
    x2: 425.913,
    y2: 364.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#215772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_1010_30625",
    x1: 163.648,
    y1: 120.385,
    x2: 163.648,
    y2: 364.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#215772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_1010_30625",
    x1: 496.102,
    y1: 169.455,
    x2: 496.102,
    y2: 364.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#215772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_1010_30625",
    x1: 120.03,
    y1: 170.585,
    x2: 120.03,
    y2: 365.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#215772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_1010_30625",
    x1: 563.52,
    y1: 228.424,
    x2: 563.52,
    y2: 287.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#215772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14445E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_1010_30625",
    x1: 400.064,
    y1: 0.0159816,
    x2: 400.064,
    y2: 243.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#215772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14445E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartBuilding);
export default __webpack_public_path__ + "static/media/SmartBuilding.22a1d63fd5375a3896d97badd790f20a.svg";
export { ForwardRef as ReactComponent };